/**
 * Centralized translations for the entire application
 * Supports English (en) and French (fr)
 */

export const translations = {
  en: {
    // Common
    cancel: 'Cancel',
    save: 'Save',
    saveChanges: 'Save Changes',
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    search: 'Search',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    of: 'of',
    
    // Suppliers
    suppliers: 'Suppliers',
    supplier: 'Supplier',
    addSupplier: 'Add Supplier',
    editSupplier: 'Edit Supplier',
    deleteSupplier: 'Delete Supplier',
    supplierName: 'Supplier Name',
    contactName: 'Contact Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    postcode: 'Postal Code',
    notes: 'Notes',
    sites: 'Sites',
    available: 'available',
    totalSuppliers: 'Total Suppliers',
    noSuppliersFound: 'No suppliers found',
    noSuppliersMessage: 'Get started by adding your first supplier',
    tryAdjusting: 'Try adjusting your search terms',
    searchPlaceholder: 'Search suppliers by name, email, city...',
    addFirstSupplier: 'Add Your First Supplier',
    title: 'Suppliers',
    subtitle: 'Manage your suppliers and their contact information',
    
    // Market Prices
    marketPrices: 'Market Prices',
    addMarketPrice: 'Add Market Price',
    editMarketPrice: 'Edit Market Price',
    itemName: 'Item Name',
    goodType: 'Good Type',
    ingredientCategory: 'Ingredient Category',
    recipeUnit: 'Recipe Unit',
    purchaseUnitConversion: 'Purchase Unit Conversion',
    supplierItem: 'Supplier Item',
    unit: 'Unit',
    unitsPerPurchase: 'Units per Purchase',
    price: 'Price',
    packaging: 'Packaging',
    step: 'Step',
    basicInfo: 'Basic Information',
    selectExistingItem: 'Select existing item',
    enterItemName: 'Enter item name',
    selectSupplier: 'Select supplier',
    clickToUpload: 'Click to upload image',
    fileFormat: 'PNG, JPG up to 5MB',
    clickToChange: 'Click to change',
    addingSupplierTo: 'Adding supplier to',
    recipeUnitQuestion: 'What unit do you use in recipes?',
    conversionQuestion: 'How many recipe units in one purchase unit?',
    editItemName: 'Edit Item',
    updateItemInfo: 'Update item information',
    marketPriceListSubtitle: 'Manage prices and suppliers for all your products',
    marketPriceListExportCsv: 'Export CSV',
    marketPriceListImportCsv: 'Import CSV',
    marketPriceListNewPrice: 'New Price',
    
    // Form fields
    required: 'Required',
    optional: 'Optional',
    streetAddress: 'Street address',
    phonePlaceholder: 'Phone number',
    emailPlaceholder: 'Email address',
    addNotes: 'Add any additional notes...',
    
    // Good Types
    food: 'Food',
    beverage: 'Beverage',
    nonFood: 'Non-Food',
    supply: 'Supply',
    equipment: 'Equipment',

    // Space Menu
    spaceMenuTitle: 'Space Menus',
    spaceMenuSubtitle: 'Manage your shops and menus by space',
    spaceMenuShop: 'shop',
    spaceMenuShops: 'shops',
    spaceMenuSpace: 'Space',
    spaceMenuSelectSpace: 'Select Space',
    spaceMenuConfiguration: 'Configuration',
    spaceMenuSelectConfiguration: 'Select Configuration',
    spaceMenuView: 'View',
    spaceMenuByShop: 'By Shop',
    spaceMenuByMenuItem: 'By Menu Item',
    spaceMenuSaveConfiguration: 'Save configuration',
    spaceMenuOpen: 'Open',
    spaceMenuClosed: 'Closed',
    spaceMenuSearchShops: 'Search shops...',
    spaceMenuSearchMenuItems: 'Search by menu item...',
    spaceMenuSelectASpace: 'Select a space',
    spaceMenuChooseSpaceToSeeShops: 'Choose a space to see its shops',
    spaceMenuFoodAndBeverages: 'Food and Beverages',
    spaceMenuNoMatchingShops: 'No matching shops',
    spaceMenuTryAdjustingFilters: 'Try adjusting your filters',
    spaceMenuNoShopsFound: 'No shops found',
    spaceMenuSpaceHasNoShops: "This space doesn't have any shops yet",
    spaceMenuMenuItems: 'Menu Items',
    spaceMenuItems: 'items',
    spaceMenuLoadingMenuItems: 'Loading menu items...',
    spaceMenuNoMenuItemsFound: 'No menu items found',
    spaceMenuAvailable: 'Available',
    spaceMenuNotAvailable: 'Not Available',
    spaceMenuReasonInactive: 'unavailable ingredient',
    spaceMenuReasonNoSupplier: 'No Supplier',
    spaceMenuReasonSupplierNotInSpace: 'supplier does not serve this space',
    spaceMenuNoRecipe: 'No recipe',
    spaceMenuMissingIngredients: 'Missing Ingredients:',
    spaceMenuLoadError: 'Failed to load data',
    spaceMenuRetry: 'Retry',
    spaceMenuMenuItem: 'Menu Item',
    spaceMenuValidateSelection: 'Validate Selection',
    spaceMenuMenuItemsAttached: 'Menu items successfully attached to the shop.',
    spaceMenuFailedToAttachMenuItems: 'Failed to attach menu items to the shop.',
    spaceMenuEditShop: 'Edit Shop',
    spaceMenuShopImage: 'Shop Image',
    spaceMenuClickToChange: 'Click to change',
    spaceMenuUploadShopImage: 'Upload shop image',
    spaceMenuClickToBrowseOrDrag: 'Click to browse or drag and drop',
    spaceMenuFileTypes: 'PNG, JPG up to 5MB',
    spaceMenuShopTypes: 'Shop Types',
    spaceMenuSelected: 'selected',
    spaceMenuActiveConfiguration: 'Active configuration',
    spaceMenuActive: 'Active',
    spaceMenuNoConfigurationSelected: 'No configuration selected',
    spaceMenuUnknownConfiguration: 'Unknown Configuration',
    spaceMenuFailedToLoadSpaces: 'Failed to load spaces',
    spaceMenuFailedToLoadShops: 'Failed to load shops',
    spaceMenuShopTypeBeer: 'Beer',
    spaceMenuShopTypeGpPremium: 'GP Premium',
    spaceMenuShopTypeTemporary: 'Temporary',
    spaceMenuShopTypeDrinkee: 'Drinkee',
    spaceMenuAttachMenuItems: 'Attach Menu Items',

    // Settings Drawer Navigation
    navSettings: 'Settings',
    navConfiguration: 'Configuration',
    navPreferences: 'Preferences',
    navLanguage: 'Language',
    navTheme: 'Theme',
    signOut: 'Sign out',
    // Sidebar gauche (MAIN_NAVIGATION)
    navMenu: 'Menu',
    navAnalytics: 'Analytics',
    navSpaces: 'Spaces',
    navFb: 'F&B',
    navHospitality: 'Hospitality',
    navMerch: 'Merch',
    navTicketing: 'Ticketing',
    navStorage: 'Storage',
    navMenuFB: 'Menu F&B',
    navMarketPricesList: 'Market Prices List',
    navComponents: 'Components',
    navSpaceMenu: 'Space Menu',
    navMenuItems: 'Menu items',
    navEvents: 'Events',
    navEventTypes: 'Event Types',
    navEventCategories: 'Event Categories',
    navEventSubcategories: 'Event Subcategories',
    navConfigurations: 'Configurations',
    navProductCategories: 'Menu Item Categories',
    navProductTypes: 'Menu Item Types',
    navMarketPriceTypes: 'Good Types',
    navMarketPriceCategories: 'Good Categories',
    navComponentTypes: 'Component Types',
    navComponentCategories: 'Component Categories',
    navBrandNames: 'Brand Names',
    navDisplayNames: 'Display Names',
    navIndustrials: 'Industrials',
    navPackingTypes: 'Packing Types',
    brandNameListTitle: 'Brand Names',
    brandNameListSubtitle: 'Manage your brand names',
    brandNameListAddBrand: 'Add brand name',
    brandNameListTotalBrands: 'Total brands',
    brandNameListSearchPlaceholder: 'Search a brand name...',
    brandNameListColName: 'Name',
    brandNameListColCreated: 'Created',
    brandNameListColActions: 'Actions',
    brandNameListDialogCreateTitle: 'New brand name',
    brandNameListDialogCreateSubtitle: 'Add a new brand name to your list',
    brandNameListDialogEditTitle: 'Edit brand name',
    brandNameListDialogEditSubtitle: 'Update the brand name',
    brandNameListLabelName: 'Brand name',
    brandNameListNamePlaceholder: 'e.g. Nike, Coca-Cola...',
    brandNameListCancel: 'Cancel',
    brandNameListSave: 'Save',
    brandNameListCreate: 'Create',
    brandNameListDeleteTitle: 'Delete brand name',
    brandNameListDeleteSubtitle: 'This action is irreversible',
    brandNameListDeleteConfirm: 'Are you sure you want to delete',
    brandNameListDelete: 'Delete',
    navIngredients: 'Ingredients',
    navDataIntegration: 'Data Integration',
    navOrganisation: 'Organisation',
    navAccount: 'Account',
    navUsers: 'Users',
    navProfile: 'Profile',
    navAccess: 'Access',
    navRoles: 'Roles',
    navPermissions: 'Permissions',
    permissionListTitle: 'Permissions',
    permissionListSubtitle: 'Manage access permissions for your organisation',
    permissionListAddPermission: 'Add permission',
    permissionListTotalPermissions: 'Total permissions',
    permissionListSearchPlaceholder: 'Search a permission...',
    permissionListColName: 'Name',
    permissionListColDescription: 'Description',
    permissionListColType: 'Type',
    permissionListColCreated: 'Created',
    permissionListColActions: 'Actions',
    permissionListTypeSystem: 'System',
    permissionListTypeCustom: 'Custom',
    permissionListDialogCreateTitle: 'New permission',
    permissionListDialogCreateSubtitle: 'Add a new permission to your organisation',
    permissionListDialogEditTitle: 'Edit permission',
    permissionListDialogEditSubtitle: 'Update the permission details',
    permissionListLabelName: 'Permission name',
    permissionListNamePlaceholder: 'e.g. read:invoices, write:users...',
    permissionListLabelCode: 'Code',
    permissionListCodePlaceholder: 'e.g. custom.export.pdf',
    permissionListCodeHint: 'Lowercase letters, digits, dots and underscores only. Cannot be changed afterwards.',
    permissionListLabelCategory: 'Category',
    permissionListCategoryPlaceholder: 'e.g. Organisation, F&B...',
    permissionListLabelDescription: 'Description',
    permissionListDescriptionPlaceholder: 'Describe what this permission allows...',
    permissionListCancel: 'Cancel',
    permissionListSave: 'Save',
    permissionListCreate: 'Create',
    permissionListDeleteTitle: 'Delete permission',
    permissionListDeleteSubtitle: 'This action is irreversible',
    permissionListDeleteConfirm: 'Are you sure you want to delete',
    permissionListDelete: 'Delete',
    roleListTitle: 'Roles',
    roleListSubtitle: 'Manage roles and their associated permissions',
    roleListAddRole: 'Add role',
    roleListTotalRoles: 'Total roles',
    roleListSearchPlaceholder: 'Search a role...',
    roleListDialogCreateTitle: 'New role',
    roleListDialogCreateSubtitle: 'Define a new role and assign permissions',
    roleListDialogEditTitle: 'Edit role',
    roleListDialogEditSubtitle: 'Update the role and its permissions',
    roleListLabelName: 'Role name',
    roleListNamePlaceholder: 'e.g. Administrator, Editor...',
    roleListLabelDescription: 'Description',
    roleListDescriptionPlaceholder: 'Describe what this role allows...',
    roleListSectionPermissions: 'Permissions',
    roleListSearchPermissions: 'Search permissions...',
    roleListNoPermissionsAvailable: 'No permissions defined yet',
    roleListPermissionsSelected: 'permission(s) selected',
    roleListPermissions: 'permission(s)',
    roleListNoPermissions: 'No permissions assigned',
    roleListEmptyTitle: 'No roles defined',
    roleListEmptySubtitle: 'Create your first role to manage access in your organisation',
    roleListNoResults: 'No matching roles',
    roleListNoResultsSubtitle: 'Try a different search term',
    roleListCancel: 'Cancel',
    roleListSave: 'Save',
    roleListCreate: 'Create',
    roleListDeleteTitle: 'Delete role',
    roleListDeleteSubtitle: 'This action is irreversible',
    roleListDeleteConfirm: 'Are you sure you want to delete',
    roleListDelete: 'Delete',
    roleListSystemBadge: 'System',
    roleListAdminAllPermissionsNote: 'The Admin role always has all permissions.',
    userListTitle: 'Users',
    userListSubtitle: 'Manage your organisation members',
    userListAddUser: 'Add user',
    userListImport: 'Import',
    userListExport: 'Export',
    userListSearchPlaceholder: 'Search by name or email...',
    userListAllRoles: 'All roles',
    userListUserFound: 'user found',
    userListUsersFound: 'users found',
    userListClearFilters: 'Clear filters',
    userListColName: 'Name',
    userListColEmail: 'Email',
    userListColPhone: 'Phone',
    userListColRole: 'Role',
    userListColCreated: 'Created',
    userListColActions: 'Actions',
    userListStatusActive: 'Active',
    userListStatusPending: 'Pending',
    userListLastSeen: 'Last seen',
    userListReinvite: 'Resend invitation',
    userListReinviteSuccess: 'Invitation resent',
    userListReinviteError: 'Could not resend the invitation',
    userListEmptyTitle: 'No users yet',
    userListEmptySubtitle: 'Add your first user to get started',
    userListDrawerEditTitle: 'Edit user',
    userListDrawerEditSubtitle: 'Update user information',
    userListLabelFirstName: 'First name',
    userListFirstNamePlaceholder: 'John',
    userListLabelLastName: 'Last name',
    userListLastNamePlaceholder: 'Doe',
    userListLabelEmail: 'Email',
    userListEmailPlaceholder: 'john@example.com',
    userListLabelPhone: 'Phone',
    userListPhonePlaceholder: '+1 234 567 890',
    userListLabelRole: 'Role',
    userListRolePlaceholder: 'Select a role',
    userListNoName: 'No name',
    userListSectionIdentity: 'Identity',
    userListSectionContact: 'Contact',
    userListSectionAccess: 'Access',
    userListCancel: 'Cancel',
    userListSave: 'Save',
    userListDeleteTitle: 'Delete user',
    userListDeleteSubtitle: 'This action is irreversible',
    userListDeleteConfirm: 'Are you sure you want to delete',
    userListDelete: 'Delete',
    userCreateTitle: 'Create Users',
    userCreateSubtitle: 'Add one or multiple users before saving',
    userCreateCancel: 'Cancel',
    userCreateSaveAll: 'Save all',
    userCreateUser: 'user',
    userCreateUsers: 'users',
    userCreateStagingTitle: 'Users to create',
    userCreateStagingEmptyTitle: 'No users added yet',
    userCreateStagingEmptySubtitle: 'Fill in the form on the right and click "Add to list"',
    userCreateFormTitle: 'New user',
    userCreateFormEditTitle: 'Edit user',
    userCreateFormSubtitle: 'Fill in the fields and add to the list',
    userCreateSectionIdentity: 'Identity',
    userCreateSectionContact: 'Contact',
    userCreateSectionAccess: 'Access',
    userCreateLabelFirstName: 'First name',
    userCreateFirstNamePlaceholder: 'John',
    userCreateLabelLastName: 'Last name',
    userCreateLastNamePlaceholder: 'Doe',
    userCreateLabelEmail: 'Email',
    userCreateEmailPlaceholder: 'john@example.com',
    userCreateLabelPhone: 'Phone',
    userCreatePhonePlaceholder: '+1 234 567 890',
    userCreateLabelRole: 'Role',
    userCreateRolePlaceholder: 'Select a role',
    userCreateAddToList: 'Add to list',
    userCreateUpdateInList: 'Update',
    userCreateCancelEdit: 'Cancel edit',
    userCreateColName: 'Name',
    userCreateColEmail: 'Email',
    userCreateColPhone: 'Phone',
    userCreateColRole: 'Role',
    userCreateColStatus: 'Status',
    userCreateStatusPending: 'Pending',
    userCreateStatusSaved: 'Saved',
    userCreateStatusError: 'Error',

    // Component List View
    compListTitle: 'Components Library',
    compListSubtitle: 'Manage and organize your menu components',
    compListExportCsv: 'Export CSV',
    compListAddComponent: 'Add Component',
    compListSearchPlaceholder: 'Search components by name...',
    compListAllCategories: 'All Categories',
    compListAllTypes: 'All Types',
    compListFound: 'found',
    compListComponent: 'component',
    compListComponents: 'components',
    compListColName: 'Component Name',
    compListColCategory: 'Category',
    compListColType: 'Type',
    compListColUnit: 'Unit',
    compListColUnitsRecipe: 'Units/Recipe',
    compListColStorageType: 'Storage Type',
    compListColUnitCost: 'Unit Cost (€)',
    compListColSubItems: 'Sub-Items',
    compListColActions: 'Actions',
    compListItems: 'items',
    compListDeleteTitle: 'Delete Component',
    compListDeleteSubtitle: 'This action cannot be undone.',
    compListDeleteConfirm: 'Are you sure you want to delete',
    compListDeleteThisComponent: 'this component',
    compListSubItemsTitle: 'Sub-Components:',
    compListSubItemsSubtitle: 'View the ingredients and components that make up this component',
    compListSubColItemName: 'Item Name',
    compListSubColType: 'Type',
    compListSubColCategory: 'Category',
    compListSubColUnits: 'Number of Units',
    compListSubColUnit: 'Unit',
    compListSubColCost: 'Cost (€)',
    compListNoComponentsFound: 'No components found',
    compListNoComponentsMessage: 'Get started by adding your first component',
    compListTryAdjusting: 'Try adjusting your search or filters',

    // ComponentCreateView
    compCreateTitleCreate: 'Create New Component',
    compCreateTitleEdit: 'Edit Component',
    compCreateSubtitleCreate: 'Build a reusable component from ingredients and other components',
    compCreateSubtitleEdit: 'Update the component details and ingredients',
    compCreateBack: 'Back',
    compCreateSubItemsTitle: 'Sub-Components & Ingredients',
    compCreateSubItemsSubtitleCreate: 'Add ingredients and components that make up this component',
    compCreateSubItemsSubtitleEdit: 'Modify ingredients and components that make up this component',
    compCreateAddIngredient: 'Add Ingredient',
    compCreateAddComponent: 'Add Component',
    compCreateStatTotalItems: 'Total Items',
    compCreateStatSubItemsCost: 'Sub-Items Cost',
    compCreateStatFinalUnitCost: 'Final Unit Cost',
    compCreateEmptyTitle: 'No items added yet',
    compCreateEmptySubtitle: 'Click "Add Ingredient" or "Add Component" above to start building this component',
    compCreateDetailsTitle: 'Component Details',
    compCreateDetailsSubtitle: 'Configure the component properties',
    compCreateFieldName: 'Component Name',
    compCreateFieldNamePlaceholder: 'e.g., Burger Patty, Caesar Dressing',
    compCreateFieldCategory: 'Category',
    compCreateFieldType: 'Component Type',
    compCreateFieldUnit: 'Unit',
    compCreateFieldUnitsPerRecipe: 'Number of Units per Recipe',
    compCreateFieldUnitsHint: 'How many units this recipe makes',
    compCreateFieldStorageType: 'Storage Type',
    compCreateFieldReadyForSale: 'Ready for Sale',
    compCreateFieldKitchenType: 'Kitchen',
    compKitchenCentral: 'Central Kitchen',
    compKitchenLocal: 'Local Kitchen',
    compCreateCalcTitle: 'Calculated Unit Cost',
    compCreateCalcSubItems: 'Sub-items total:',
    compCreateCalcPerUnit: 'per unit',
    compCreateFieldAllergens: 'Allergens',
    compCreateFieldDescription: 'Description (Optional)',
    compCreateFieldDescriptionPlaceholder: 'Add preparation notes, storage instructions, or other details...',
    compCreateSaveCreate: 'Create Component',
    compCreateSaveEdit: 'Update Component',
    compCreateIngrDrawerTitle: 'Select Ingredients',
    compCreateIngrDrawerSubtitle: 'Choose ingredients from the Market Price List to add to your component',
    compCreateIngrSearchPlaceholder: 'Search items...',
    compCreateCompDrawerTitle: 'Select Components',
    compCreateCompDrawerSubtitle: 'Choose components from the Components Library to add to your component',
    compCreateCompSearchPlaceholder: 'Search components...',
    compCreateSubTableColType: 'Type',
    compCreateSubTableColName: 'Name',
    compCreateSubTableColCategory: 'Category',
    compCreateSubTableColUnits: 'Number of Units',
    compCreateSubTableColUnit: 'Unit',
    compCreateSubTableColCost: 'Cost (€)',
    compCreateSubTableColStorage: 'Storage',
    compCreateSubTableColActions: 'Actions',
    compCreateCompColName: 'Name',
    compCreateCompColType: 'Type',
    compCreateCompColCategory: 'Category',
    compCreateCompColUnit: 'Unit',
    compCreateCompColUnitCost: 'Unit Cost (€)',
    compCreateItemsSelected: 'items selected',
    compCreateAddSelected: 'Add Selected',
    compCreateCancel: 'Cancel',
    compCreateCalcUnits: 'units',
    compCreateIngrTableColIngredient: 'Ingredient',
    compCreateIngrTableColUnit: 'Unit',
    compCreateIngrTableColCostUnit: 'Cost/Unit',
    compCreateNewCategoryOption: '+ Create a new category',
    compCreateNewTypeOption: '+ Create a new type',
    compCreateNewCategoryDialogTitle: 'Create a new category',
    compCreateNewCategoryDialogSubtitle: 'Enter the name of the new component category.',
    compCreateNewCategoryDialogLabel: 'Category name',
    compCreateNewTypeDialogTitle: 'Create a new type',
    compCreateNewTypeDialogSubtitle: 'Enter the name of the new component type.',
    compCreateNewTypeDialogLabel: 'Type name',
    compCreateDialogConfirm: 'Create',
    compCreateDialogCancel: 'Cancel',
    // Menu Items Library
    menuItemLibTitle: 'Menu Items Library',
    menuItemLibSubtitle: 'Manage your menu items, prices and costs',
    menuItemLibExportCsv: 'Export CSV',
    menuItemLibRefreshCosts: 'Refresh Costs',
    menuItemLibSyncCategories: 'Sync Categories',
    menuItemLibAddMenuItem: 'Add Menu Item',
    menuItemLibSearchPlaceholder: 'Search menu items by name...',
    menuItemLibAllSpaces: 'All Spaces',
    menuItemLibAllTypes: 'All Types',
    menuItemLibAllCategories: 'All Categories',
    menuItemLibReadyStatus: 'Ready Status',
    menuItemLibReadyAll: 'All',
    menuItemLibReadyYes: 'Yes',
    menuItemLibReadyNo: 'No',
    menuItemLibMenuItem: 'menu item',
    menuItemLibMenuItems: 'menu items',
    menuItemLibFound: 'found',
    menuItemLibClearFilters: 'Clear All Filters',
    menuItemLibNoDataFound: 'No menu items found',
    menuItemLibNoDataSubtitle: 'Try adjusting your search or filters to find what you\'re looking for.',
    menuItemLibTotalCost: 'Total Cost',
    menuItemLibTotalPrice: 'Total Price',
    menuItemLibAvgMargin: 'Avg Margin',
    menuItemLibItems: 'items',
    menuItemLibColPicture: 'Picture',
    menuItemLibColName: 'Name',
    menuItemLibColCategory: 'Category',
    menuItemLibColReady: 'Ready',
    menuItemLibColCombo: 'Combo',
    menuItemLibColPrice: 'Price',
    menuItemLibColTotalCost: 'Cost / Piece',
    menuItemLibColMargin: 'Margin %',
    menuItemLibColDiet: 'Diet',
    menuItemLibColStorage: 'Storage',
    menuItemLibColActions: 'Actions',
    menuItemLibReady: 'Ready',
    menuItemLibNotReady: 'Not Ready',
    menuItemLibCombo: 'Combo',
    menuItemLibEdit: 'Edit',
    menuItemLibThisMenuItem: 'this menu item',
    menuItemLibDeleteTitle: 'Delete Menu Item',
    menuItemLibDeleteSubtitle: 'This action cannot be undone.',
    menuItemLibDeleteConfirm: 'Are you sure you want to delete',
    menuItemLibDeleteBtn: 'Delete Menu Item',
    // Menu Item CSV Import
    menuItemImportTitle: 'Import Menu Items',
    menuItemImportStep1: 'File',
    menuItemImportStep2: 'Preview',
    menuItemImportStep3: 'Result',
    menuItemImportStep1Desc: 'Choose a CSV file',
    menuItemImportStep2Desc: 'Verify the data',
    menuItemImportStep3Desc: 'Import complete',
    menuItemImportDropzone: 'Drop a CSV file here',
    menuItemImportDropzoneOr: 'or click to browse',
    menuItemImportChooseFile: 'Choose a file',
    menuItemImportKnownCols: 'Recognized columns',
    menuItemImportRequired: 'required',
    menuItemImportFormatDesc: 'First line = headers · Comma separator · UTF-8 encoding',
    menuItemImportBack: 'Back',
    menuItemImportCancel: 'Cancel',
    menuItemImportClose: 'Close',
    menuItemImportRun: 'Import',
    menuItemImportPreviewFile: 'Valid lines',
    menuItemImportErrors: 'errors',
    menuItemImportSkipped: 'line(s) ignored (missing "name" field).',
    menuItemImportInProgress: 'Import in progress…',
    menuItemImportSuccess: 'Import successful',
    menuItemImportError: 'Import error',
    menuItemImportMoreRows: 'and other items',
    menuItemImportValid: 'valid',
    menuItemImportItems: 'item(s) imported',
    // Menu Item Create/Edit
    menuItemCreateTitle: 'Create New Menu Item',
    menuItemCreateEditTitle: 'Edit Menu Item',
    menuItemCreateSubtitle: 'Build a menu item from components and ingredients',
    menuItemCreateEditSubtitle: 'Update your menu item details',
    menuItemCreateCancel: 'Back',
    menuItemCreateSave: 'Create Menu Item',
    menuItemCreateSaveEdit: 'Update Menu Item',
    menuItemCreateComponentsTitle: 'Components & Ingredients',
    menuItemCreateAddIngredient: 'Add Ingredient',
    menuItemCreateAddComponent: 'Add Component',
    menuItemCreateAddComboItem: 'Add Combo Item',
    menuItemCreateAddPackaging: 'Add Packaging',
    menuItemCreateNoItems: 'No components or ingredients added yet. Click "Add Component" or "Add Ingredient" to get started.',
    menuItemCreateIngrTitle: 'Add Ingredient',
    menuItemCreateIngrSubtitle: 'Select ingredients from your market prices',
    menuItemCreateIngrSearchPlaceholder: 'Search ingredients...',
    menuItemCreateIngrNoData: 'No ingredients found',
    menuItemCreateIngrAddBtn: 'Add',
    menuItemCreateCancel: 'Cancel',
    menuItemCreateClose: 'Close',
    menuItemCreatePkgTitle: 'Add Packaging',
    menuItemCreatePkgSubtitle: 'Select packaging from your inventory',
    menuItemCreatePkgSearchPlaceholder: 'Search packaging...',
    menuItemCreatePkgNoData: 'No packaging items found',
    menuItemCreatePkgAddBtn: 'Add',
    menuItemCreateColName: 'Name',
    menuItemCreateColType: 'Type',
    menuItemCreateColCategory: 'Category',
    menuItemCreateColUnit: 'Unit',
    menuItemCreateColQuantity: 'Quantity',
    menuItemCreateColUnitCost: 'Unit Cost',
    menuItemCreateColTotalCost: 'Total Cost',
    menuItemCreateColStorage: 'Storage',
    menuItemCreateColActions: 'Actions',
    menuItemCreateDetailsTitle: 'Menu Item Details',
    menuItemCreateLabelPicture: 'Picture',
    menuItemCreateUploadPicture: 'Upload Picture',
    menuItemCreateLabelName: 'Name',
    menuItemCreateNamePlaceholder: 'e.g., Classic Burger',
    menuItemCreateLabelSpace: 'Space',
    menuItemCreateSpacePlaceholder: 'Select spaces...',
    menuItemCreateSpacesNoneSelected: 'No spaces selected',
    menuItemCreateSpacesCount: 'space(s) selected',
    menuItemCreateSpacesDrawerTitle: 'Spaces',
    menuItemCreateSpacesDrawerSubtitle: 'Select the spaces and set the price for each one',
    menuItemCreateSpacesDrawerSearch: 'Search a space...',
    menuItemCreateSpacesDrawerNoData: 'No spaces found',
    menuItemCreateSpacesDrawerPriceLabel: 'Price in this space',
    menuItemCreateSpacesDrawerDept: 'Dept.',
    menuItemCreateSpacesDrawerConfirm: 'Confirm',
    menuItemCreateLabelBrand: 'Brand Name',
    menuItemCreateBrandPlaceholder: 'Select a brand...',
    menuItemCreateLabelType: 'Menu Item Type',
    menuItemCreateTypePlaceholder: 'Select a Menu Item Type...',
    menuItemCreateLabelCategory: 'Menu Item Category',
    menuItemCreateCategoryPlaceholder: 'Select a Menu Item Category...',
    menuItemCreateLabelReady: 'Ready for Sale',
    menuItemCreateInventoryInfo: 'Inventory Information',
    menuItemCreatePackagingType: 'Packaging Type',
    menuItemCreateNumberOfUnits: 'Number of Units',
    menuItemCreateNone: 'None',
    menuItemCreateLabelCombo: 'Combo Item',
    menuItemCreateLabelBasePrice: 'Base Price (€) *',
    menuItemCreateBasePriceHint: 'Please select spaces above to set space-specific pricing',
    menuItemCreateSummaryTotalCost: 'Total Cost per Piece:',
    menuItemCreateSummaryBasePrice: 'Base Price:',
    menuItemCreateSummaryMargin: 'Margin:',
    menuItemCreateLabelStorage: 'Storage Type',
    menuItemCreateStorageDry: 'Dry',
    menuItemCreateStorageCold: 'Cold',
    menuItemCreateStorageFreezer: 'Freezer',
    menuItemCreateLabelDiet: 'Diet',
    menuItemCreateDietVegan: 'Vegan',
    menuItemCreateDietVegetarian: 'Vegetarian',
    menuItemCreateDietHalal: 'Halal',
    menuItemCreateDietKosher: 'Kosher',
    menuItemCreateDietHot: 'Hot',
    menuItemCreateLabelDescription: 'Description',
    menuItemCreateDescriptionPlaceholder: 'Optional description of the menu item...',
    menuItemCreateIngrTitle: 'Select Ingredients',
    menuItemCreateIngrSubtitle: 'Choose ingredients from the Market Price List to add to your menu item',
    menuItemCreateIngrSearchPlaceholder: 'Search items...',
    menuItemCreateIngrNoData: 'No ingredients found',
    menuItemCreateIngrColIngredient: 'Ingredient',
    menuItemCreateIngrColUnit: 'Unit',
    menuItemCreateIngrColCostUnit: 'Cost/Unit',
    menuItemCreateIngrAddBtn: 'Add',
    menuItemCreateIngrItem: 'Item',
    menuItemCreateIngrItems: 'Items',
    menuItemCreateCompTitle: 'Select Components',
    menuItemCreateCompSubtitle: 'Choose components from the Components Library to add to your menu item',
    menuItemCreateCompSearchPlaceholder: 'Search components...',
    menuItemCreateCompAddBtn: 'Add Selected',
    menuItemCreatePkgTitle: 'Select Packaging',
    menuItemCreatePkgSubtitle: 'Choose packaging items from the Market Price List',
    menuItemCreatePkgSearchPlaceholder: 'Search packaging...',
    menuItemCreatePkgNoData: 'No packaging found',
    menuItemCreatePkgColName: 'Name',
    menuItemCreatePkgColSupplier: 'Supplier',
    menuItemCreatePkgColUnit: 'Unit',
    menuItemCreatePkgColCostUnit: 'Cost/Unit',
    menuItemCreatePkgAddBtn: 'Add Selected',
    menuItemCreateTypeCreateOption: '+ Create a product type',
    menuItemCreateCategoryCreateOption: '+ Create a product category',
    menuItemCreateTypeDialogTitle: 'Create a Menu Item Type',
    menuItemCreateTypeDialogSubtitle: 'Add a new Menu Item Type',
    menuItemCreateTypeDialogLabel: 'Type name *',
    menuItemCreateTypeDialogPlaceholder: 'E.g., Beverage, Food...',
    menuItemCreateTypeDialogCancel: 'Cancel',
    menuItemCreateTypeDialogCreate: 'Create',
    menuItemCreateCategoryDialogTitle: 'Create a Menu Item Category',
    menuItemCreateCategoryDialogSubtitle: 'Add a new Menu Item Category',
    menuItemCreateCategoryDialogTypeLabel: 'Type:',
    menuItemCreateCategoryDialogLabel: 'Category name *',
    menuItemCreateCategoryDialogPlaceholder: 'E.g., Juice, Snack...',
    menuItemCreateCategoryDialogCancel: 'Cancel',
    menuItemCreateCategoryDialogCreate: 'Create',
    menuItemCreateUnsavedTitle: 'Unsaved changes',
    menuItemCreateUnsavedMessage: 'You have unsaved changes. What would you like to do?',
    menuItemCreateLeaveWithoutSaving: 'Continue without saving',
    menuItemCreateSaveAndLeave: 'Continue and save',

    // Event Types
    eventTypeListTitle: 'Event Types',
    eventTypeListSubtitle: 'Define and manage your different event types',
    eventTypeListExportCsv: 'Export CSV',
    eventTypeListImportCsv: 'Import CSV',
    eventTypeListNewType: 'New Type',
    eventTypeListSearchPlaceholder: 'Search an event type...',
    eventTypeListColName: 'Name',
    eventTypeListColCategories: 'Categories',
    eventTypeListColCreatedAt: 'Created at',
    eventTypeListColUpdatedAt: 'Updated at',
    eventTypeListColActions: 'Actions',
    eventTypeListDrawerCreateTitle: 'New Event Type',
    eventTypeListDrawerCreateSubtitle: 'Fill in the information below to create a new type',
    eventTypeListDrawerEditTitle: 'Edit Event Type',
    eventTypeListDrawerEditSubtitle: 'Modify the information for this event type',
    eventTypeListLabelName: 'Type Name *',
    eventTypeListNamePlaceholder: 'e.g., Concert, Sport...',
    eventTypeListSave: 'Save',
    eventTypeListCancel: 'Cancel',
    // Event Category List
    eventCategoryListTitle: 'Event Categories',
    eventCategoryListSubtitle: 'Manage and organize all your event categories',
    eventCategoryListExportCsv: 'Export CSV',
    eventCategoryListImportCsv: 'Import CSV',
    eventCategoryListNewCategory: 'New Category',
    eventCategoryListSearchPlaceholder: 'Search a category...',
    eventCategoryListColName: 'Name',
    eventCategoryListColType: 'Event Type',
    eventCategoryListColHomeTeam: 'Has Home Team',
    eventCategoryListColActions: 'Actions',
    eventCategoryListDrawerCreateTitle: 'New Event Category',
    eventCategoryListDrawerCreateSubtitle: 'Fill in the information below to create a new category',
    eventCategoryListDrawerEditTitle: 'Edit Event Category',
    eventCategoryListDrawerEditSubtitle: 'Modify the information for this category',
    eventCategoryListLabelName: 'Category Name *',
    eventCategoryListNamePlaceholder: 'e.g., Football, Music...',
    eventCategoryListLabelEventType: 'Event Type *',
    eventCategoryListSelectType: 'Select a type',
    eventCategoryListLabelHasHomeTeam: 'Has Home Team',
    eventCategoryListSave: 'Save',
    eventCategoryListCancel: 'Cancel',
    // Event Subcategory List
    eventSubcategoryListTitle: 'Event Subcategories',
    eventSubcategoryListSubtitle: 'Organize your events into detailed subcategories',
    eventSubcategoryListExportCsv: 'Export CSV',
    eventSubcategoryListImportCsv: 'Import CSV',
    eventSubcategoryListNewSubcategory: 'New Subcategory',
    eventSubcategoryListSearchPlaceholder: 'Search a subcategory...',
    eventSubcategoryListColName: 'Name',
    eventSubcategoryListColCategory: 'Event Category',
    eventSubcategoryListColActions: 'Actions',
    eventSubcategoryListDrawerCreateTitle: 'New Event Subcategory',
    eventSubcategoryListDrawerCreateSubtitle: 'Fill in the information below to create a new subcategory',
    eventSubcategoryListDrawerEditTitle: 'Edit Event Subcategory',
    eventSubcategoryListDrawerEditSubtitle: 'Modify the information for this subcategory',
    eventSubcategoryListLabelName: 'Subcategory Name *',
    eventSubcategoryListNamePlaceholder: 'e.g., Final, Group Stage...',
    eventSubcategoryListLabelCategory: 'Event Category *',
    eventSubcategoryListSelectCategory: 'Select a category',
    eventSubcategoryListSave: 'Save',
    eventSubcategoryListCancel: 'Cancel',
    // Event Type Dialog
    eventTypeDialogTitle: 'Create Event Type',
    eventTypeDialogSubtitle: 'Form to create a new event type',
    eventTypeDialogNameLabel: 'Type Name *',
    eventTypeDialogNamePlaceholder: 'Enter type name',
    eventTypeDialogSave: 'Save',
    eventTypeDialogCancel: 'Cancel',
    // Event Category Dialog
    eventCategoryDialogTitle: 'Create Event Category',
    eventCategoryDialogSubtitle: 'Form to create a new event category',
    eventCategoryDialogTypeLabel: 'Event Type *',
    eventCategoryDialogTypePlaceholder: 'Select Event Type',
    eventCategoryDialogNameLabel: 'Category Name *',
    eventCategoryDialogNamePlaceholder: 'Enter category name',
    eventCategoryDialogHasHomeTeam: 'Has Home Team',
    eventCategoryDialogSave: 'Save',
    eventCategoryDialogCancel: 'Cancel',
    // Event Subcategory Dialog
    eventSubcategoryDialogTitle: 'Create Event Subcategory',
    eventSubcategoryDialogSubtitle: 'Form to create a new event subcategory',
    eventSubcategoryDialogCategoryLabel: 'Event Category *',
    eventSubcategoryDialogCategoryPlaceholder: 'Select Event Category',
    eventSubcategoryDialogNameLabel: 'Subcategory Name *',
    eventSubcategoryDialogNamePlaceholder: 'Enter subcategory name',
    eventSubcategoryDialogSave: 'Save',
    eventSubcategoryDialogCancel: 'Cancel',
    // Events List
    eventsListTitle: 'Events Library',
    eventsListSubtitle: 'Manage all your events in one place',
    eventsListExportCsv: 'Export CSV',
    eventsListImportCsv: 'Import CSV',
    eventsListCalculateRevenue: 'Calculate Revenue',
    eventsListNewEvent: 'New Event',
    eventsListSearchPlaceholder: 'Search an event...',
    eventsListAllLocations: 'All locations',
    eventsListColSpace: 'Space',
    eventsListColDate: 'Event Date',
    eventsListColName: 'Event Name',
    eventsListColType: 'Event Type',
    eventsListColCategory: 'Event Category',
    eventsListColSubcategory: 'Event Subcategory',
    eventsListColStatus: 'Status',
    eventsListColRevenue: 'Revenue',
    eventsListColTransactions: 'Transactions',
    eventsListColActions: 'Actions',
    eventsListDrawerCreateTitle: 'New Event',
    eventsListDrawerCreateSubtitle: 'Fill in the information below to create a new event',
    eventsListDrawerEditTitle: 'Edit Event',
    eventsListDrawerEditSubtitle: 'Modify the information for this event',
    eventsListLabelName: 'Event Name',
    eventsListNamePlaceholder: 'Enter the event name',
    eventsListLabelSpace: 'Space',
    eventsListSelectSpace: 'Select a space',
    eventsListLabelStartDate: 'Start Date',
    eventsListLabelEndDate: 'End Date',
    eventsListLabelEndTime: 'End Time',
    eventsListLabelEventType: 'Event Type',
    eventsListSelectType: 'Select a type',
    eventsListLabelCategory: 'Event Category',
    eventsListSelectCategory: 'Select a category',
    eventsListLabelSubcategory: 'Event Subcategory',
    eventsListSelectSubcategory: 'Select a subcategory',
    eventsListLabelSessions: 'Number of Sessions',
    eventsListLabelSessionsDetail: 'Sessions',
    eventsListLabelDoorsOpening: 'Doors Opening',
    eventsListLabelShowTime: 'Show Time',
    eventsListLabelOptions: 'Event Options',
    eventsListLabelOpeningAct: 'Opening Act',
    eventsListLabelOpeningActDesc: 'Does the event have an opening act?',
    eventsListLabelIntermission: 'Intermission',
    eventsListLabelIntermissionDesc: 'Does the event have an intermission?',
    eventsListSave: 'Save',
    eventsListCancel: 'Cancel',

    // Product Type List
    productTypeListTitle: 'Menu Item Types',
    productTypeListSubtitle: 'Manage your product types and classifications',
    productTypeListAddType: 'Add Type',
    productTypeListTotalTypes: 'Total Types',
    productTypeListSearchPlaceholder: 'Search types by name...',
    productTypeListCategory: 'category',
    productTypeListCategories: 'categories',
    productTypeListNoCategories: 'No categories',
    productTypeListColName: 'Name',
    productTypeListColCategories: 'Categories',
    productTypeListColCreated: 'Created',
    productTypeListColActions: 'Actions',
    productTypeListDialogCreateTitle: 'Add Type',
    productTypeListDialogCreateSubtitle: 'Create a new product type',
    productTypeListDialogEditTitle: 'Edit Type',
    productTypeListDialogEditSubtitle: 'Update type details',
    productTypeListLabelName: 'Name *',
    productTypeListNamePlaceholder: 'Enter type name',
    productTypeListCancel: 'Cancel',
    productTypeListSave: 'Save',
    productTypeListCreate: 'Create',
    productTypeListDeleteTitle: 'Delete Type',
    productTypeListDeleteSubtitle: 'This action cannot be undone.',
    productTypeListDeleteConfirm: 'Are you sure you want to delete',
    productTypeListDelete: 'Delete',
    productTypeListCategoriesTitle: 'Categories for',
    productTypeListClose: 'Close',
    productTypeListNoCategoriesFound: 'No categories found',

    // Product Category List
    productCategoryListTitle: 'Menu Item Categories',
    productCategoryListSubtitle: 'Manage your product categories and their types',
    productCategoryListAddCategory: 'Add Category',
    productCategoryListTotalCategories: 'Total Categories',
    productCategoryListSearchPlaceholder: 'Search categories by name...',
    productCategoryListNoType: 'No type',
    productCategoryListColName: 'Name',
    productCategoryListColType: 'Type',
    productCategoryListColCreated: 'Created',
    productCategoryListColActions: 'Actions',
    productCategoryListDialogCreateTitle: 'Add Category',
    productCategoryListDialogCreateSubtitle: 'Create a new product category',
    productCategoryListDialogEditTitle: 'Edit Category',
    productCategoryListDialogEditSubtitle: 'Update category details',
    productCategoryListLabelType: 'Type *',
    productCategoryListSelectType: 'Select type',
    productCategoryListLabelName: 'Name *',
    productCategoryListNamePlaceholder: 'Enter category name',
    productCategoryListCancel: 'Cancel',
    productCategoryListSave: 'Save',
    productCategoryListCreate: 'Create',
    productCategoryListDeleteTitle: 'Delete Category',
    productCategoryListDeleteSubtitle: 'This action cannot be undone.',
    productCategoryListDeleteConfirm: 'Are you sure you want to delete',
    productCategoryListDelete: 'Delete',

    // Market Price Types
    marketPriceTypeListTitle: 'Good Types',
    marketPriceTypeListSubtitle: 'Manage your market price types and classifications',
    marketPriceTypeListAddType: 'Add Type',
    marketPriceTypeListTotalTypes: 'Total Types',
    marketPriceTypeListSearchPlaceholder: 'Search types by name...',
    marketPriceTypeListCategory: 'category',
    marketPriceTypeListCategories: 'categories',
    marketPriceTypeListNoCategories: 'No categories',
    marketPriceTypeListColName: 'Name',
    marketPriceTypeListColCategories: 'Categories',
    marketPriceTypeListColCreated: 'Created',
    marketPriceTypeListColActions: 'Actions',
    marketPriceTypeListDialogCreateTitle: 'Add Type',
    marketPriceTypeListDialogCreateSubtitle: 'Create a new market price type',
    marketPriceTypeListDialogEditTitle: 'Edit Type',
    marketPriceTypeListDialogEditSubtitle: 'Update type details',
    marketPriceTypeListLabelName: 'Name *',
    marketPriceTypeListNamePlaceholder: 'Enter type name',
    marketPriceTypeListCancel: 'Cancel',
    marketPriceTypeListSave: 'Save',
    marketPriceTypeListCreate: 'Create',
    marketPriceTypeListDeleteTitle: 'Delete Type',
    marketPriceTypeListDeleteSubtitle: 'This action cannot be undone.',
    marketPriceTypeListDeleteConfirm: 'Are you sure you want to delete',
    marketPriceTypeListDelete: 'Delete',
    marketPriceTypeListCategoriesTitle: 'Categories for',
    marketPriceTypeListClose: 'Close',
    marketPriceTypeListNoCategoriesFound: 'No categories found',

    // Market Price Categories
    marketPriceCategoryListTitle: 'Good Categories',
    marketPriceCategoryListSubtitle: 'Manage your market price categories and their types',
    marketPriceCategoryListAddCategory: 'Add Category',
    marketPriceCategoryListTotalCategories: 'Total Categories',
    marketPriceCategoryListSearchPlaceholder: 'Search categories by name...',
    marketPriceCategoryListNoType: 'No type',
    marketPriceCategoryListColName: 'Name',
    marketPriceCategoryListColType: 'Type',
    marketPriceCategoryListColCreated: 'Created',
    marketPriceCategoryListColActions: 'Actions',
    marketPriceCategoryListDialogCreateTitle: 'Add Category',
    marketPriceCategoryListDialogCreateSubtitle: 'Create a new market price category',
    marketPriceCategoryListDialogEditTitle: 'Edit Category',
    marketPriceCategoryListDialogEditSubtitle: 'Update category details',
    marketPriceCategoryListLabelType: 'Type *',
    marketPriceCategoryListSelectType: 'Select type',
    marketPriceCategoryListLabelName: 'Name *',
    marketPriceCategoryListNamePlaceholder: 'Enter category name',
    marketPriceCategoryListCancel: 'Cancel',
    marketPriceCategoryListSave: 'Save',
    marketPriceCategoryListCreate: 'Create',
    marketPriceCategoryListDeleteTitle: 'Delete Category',
    marketPriceCategoryListDeleteSubtitle: 'This action cannot be undone.',
    marketPriceCategoryListDeleteConfirm: 'Are you sure you want to delete',
    marketPriceCategoryListDelete: 'Delete',

    // Component Types
    componentTypeListTitle: 'Component Types',
    componentTypeListSubtitle: 'Manage your component types and classifications',
    componentTypeListAddType: 'Add Type',
    componentTypeListTotalTypes: 'Total Types',
    componentTypeListSearchPlaceholder: 'Search types by name...',
    componentTypeListCategory: 'category',
    componentTypeListCategories: 'categories',
    componentTypeListNoCategories: 'No categories',
    componentTypeListColName: 'Name',
    componentTypeListColCategories: 'Categories',
    componentTypeListColCreated: 'Created',
    componentTypeListColActions: 'Actions',
    componentTypeListDialogCreateTitle: 'Add Type',
    componentTypeListDialogCreateSubtitle: 'Create a new component type',
    componentTypeListDialogEditTitle: 'Edit Type',
    componentTypeListDialogEditSubtitle: 'Update type details',
    componentTypeListLabelName: 'Name *',
    componentTypeListNamePlaceholder: 'Enter type name',
    componentTypeListCancel: 'Cancel',
    componentTypeListSave: 'Save',
    componentTypeListCreate: 'Create',
    componentTypeListDeleteTitle: 'Delete Type',
    componentTypeListDeleteSubtitle: 'This action cannot be undone.',
    componentTypeListDeleteConfirm: 'Are you sure you want to delete',
    componentTypeListDelete: 'Delete',
    componentTypeListCategoriesTitle: 'Categories for',
    componentTypeListClose: 'Close',
    componentTypeListNoCategoriesFound: 'No categories found',

    // Component Categories
    componentCategoryListTitle: 'Component Categories',
    componentCategoryListSubtitle: 'Manage your component categories and their types',
    componentCategoryListAddCategory: 'Add Category',
    componentCategoryListTotalCategories: 'Total Categories',
    componentCategoryListSearchPlaceholder: 'Search categories by name...',
    componentCategoryListNoType: 'No type',
    componentCategoryListColName: 'Name',
    componentCategoryListColType: 'Type',
    componentCategoryListColCreated: 'Created',
    componentCategoryListColActions: 'Actions',
    componentCategoryListDialogCreateTitle: 'Add Category',
    componentCategoryListDialogCreateSubtitle: 'Create a new component category',
    componentCategoryListDialogEditTitle: 'Edit Category',
    componentCategoryListDialogEditSubtitle: 'Update category details',
    componentCategoryListLabelType: 'Type *',
    componentCategoryListSelectType: 'Select type',
    componentCategoryListLabelName: 'Name *',
    componentCategoryListNamePlaceholder: 'Enter category name',
    componentCategoryListCancel: 'Cancel',
    componentCategoryListSave: 'Save',
    componentCategoryListCreate: 'Create',
    componentCategoryListDeleteTitle: 'Delete Category',
    componentCategoryListDeleteSubtitle: 'This action cannot be undone.',
    componentCategoryListDeleteConfirm: 'Are you sure you want to delete',
    componentCategoryListDelete: 'Delete',

    // Space List
    spaceListTitle: 'My Spaces',
    spaceListSubtitle: 'Manage the performance of all your F&B venues',
    spaceListNewSpace: 'New Space',
    spaceListSearchPlaceholder: 'Search a space...',
    spaceListTypePlaceholder: 'Space type',
    spaceListFilterSearch: 'Search',
    spaceListFilterType: 'Type',
    spaceListLoading: 'Loading spaces...',
    spaceListRetry: 'Retry',
    spaceListEmptyFound: 'No spaces found',
    spaceListEmptyNone: 'No spaces available',
    spaceListEmptyFoundDesc: 'Try adjusting your search filters',
    spaceListEmptyNoneDesc: 'Start by creating your first space to manage your F&B venues',
    spaceListCreateFirst: 'Create my first space',
    spaceListResetFilters: 'Reset filters',
    spaceListCityUnknown: 'City not specified',
    spaceListTypeUnknown: 'Type not specified',
    spaceListStepInfo: 'Information',
    spaceListStepAddress: 'Address',
    spaceListStepContact: 'Contact',
    spaceListStepSocial: 'Social',
    spaceListAddImage: 'Add an image',
    spaceListImageHint: 'PNG, JPG · Max 5 MB',
    spaceListChangeImage: 'Click to change the image',
    spaceListLabelName: 'Space name',
    spaceListLabelSpaceType: 'Space type',
    spaceListLabelDepartment: 'Department',
    spaceListLabelCapacity: 'Max capacity',
    spaceListLabelAddress: 'Address',
    spaceListLabelAddress2: 'Address 2',
    spaceListLabelCity: 'City',
    spaceListLabelPostcode: 'Postal code',
    spaceListLabelCountry: 'Country',
    spaceListLabelEmail: 'Email',
    spaceListLabelPhone: 'Phone',
    spaceListLabelFullName: 'Full name',
    spaceListLabelContactEmail: 'Contact email',
    spaceListLabelContactPhone: 'Phone',
    spaceListSocialTitle: 'Connect your networks for more visibility',
    spaceListBack: '< Back',
    spaceListContinue: 'Continue',
    spaceListDeleteTitle: 'Delete space',
    spaceListDeleteConfirm: 'Are you sure you want to delete the space',
    spaceListCancel: 'Cancel',
    spaceListDelete: 'Delete',
    spaceListDialogCreateTitle: 'New space',
    spaceListDialogEditTitle: 'Edit space',
    spaceListDialogSubmitCreate: 'Create space',
    spaceListDialogSubmitEdit: 'Save',
    spaceListSubtitleStep0: 'Fill in the main information about the space',
    spaceListSubtitleStep1: 'Add the address of your space',
    spaceListSubtitleStep2: 'Add contact information',
    spaceListSubtitleStep3: 'Add links to your networks (optional)',
    spaceListSortName: 'Name (A-Z)',
    spaceListSortRevenue: 'Revenue (descending)',
    spaceListSortCapacity: 'Capacity (descending)',
    spaceListSortRecent: 'Recent',
    spaceListErrorCreate: 'Unable to create the space',
    spaceListErrorLoad: 'Unable to load spaces',
    spaceListErrorDelete: 'Unable to delete the space',
    spaceListDeleteSubtitle: 'This action cannot be undone.',
    spaceListSpace: 'space',
    spaceListSpaces: 'spaces',

    // Space Builder
    spaceBuilderNewSpace: 'New Space',
    spaceBuilderNewConfig: 'New configuration',
    spaceBuilderBack: 'Back',
    spaceBuilderSave: 'Save',
    spaceBuilderSaveUpdate: 'Save changes',
    spaceBuilderSelectFloor: 'Select a floor',
    spaceBuilderSelectFloorDesc: 'Choose a floor to view the plan',
    spaceBuilderNoElement: 'No element selected',
    spaceBuilderNoElementDesc: 'Select an element in the plan to edit its properties',
    spaceBuilderFBShopsList: 'F&B Shops',
    spaceBuilderFBShopsListDesc: 'Click a shop to view and edit its properties',
    spaceBuilderNoFBShops: 'No F&B shops yet',
    spaceBuilderElementsListDesc: 'Click an element to view and edit its properties',
    spaceBuilderNoElementsInCategory: 'No elements in this category yet',
    spaceBuilderAllAreas: 'All Areas',
    spaceBuilderUnsavedTitle: 'Unsaved changes',
    spaceBuilderUnsavedConfirmLeave: 'You have unsaved changes. What would you like to do?',
    spaceBuilderLeaveWithoutSaving: 'Continue without saving',
    spaceBuilderSaveAndLeave: 'Continue and save',
    spaceBuilderSaveDialogTitle: 'Save configuration',
    spaceBuilderSaveDialogDesc: 'Give a name to this configuration to find it easily later.',
    spaceBuilderSaveDialogLabel: 'Configuration name',
    spaceBuilderSaveDialogPlaceholder: 'Ex: Event Configuration 2024',
    spaceBuilderSaveSuccess: 'Configuration "{name}" saved successfully!',
    spaceBuilderSaveError: 'Error saving configuration',
    spaceBuilderLoadError: 'Error loading configuration',
    spaceBuilderRename: 'Rename',
    spaceBuilderRenameDialogTitle: 'Rename configuration',
    spaceBuilderRenameDialogLabel: 'New name',
    spaceBuilderSaving: 'Saving…',
    spaceBuilderSavingWait: 'Please wait',
    elevationBuilder3DView: '3D Space View',
    elevationBuilderSearch: 'Search an element...',
    elevationBuilderResetView: 'Reset view',

    // Properties Panel
    ppProperties: 'Properties',
    ppImage: 'Image',
    ppDuplicate: 'Duplicate',
    ppElementName: 'Element Name',
    ppElementNamePlaceholder: 'Enter element name...',
    ppShopType: 'Shop Type',
    ppPerformanceMetrics: 'Performance Metrics',
    ppRevenue: 'Revenue',
    ppNumberOfPOS: 'Number of POS',
    ppTransactions: 'Transactions',
    ppTransPerMin: 'Trans/Min',
    ppStaffCost: 'Staff Cost',
    ppRevPerEmployee: 'Rev/Employee',
    ppMenu: 'Menu',
    ppSearchMenuItems: 'Search menu items...',
    ppNoMenuItemsQuery: 'No menu items found matching',
    ppNoMenuItemsConfigured: 'No menu items configured',
    ppGoToSpaceMenusConfigure: 'Go to Space Menus to configure',
    ppInventory: 'Inventory',
    ppSearchInventory: 'Search inventory items...',
    ppInventoryItems: 'Inventory Items',
    ppUsedIn: 'Used in:',
    ppCustomInventoryItems: 'Custom Inventory Items',
    ppNoCustomInventory: 'No custom inventory items.',
    ppNoInventory: 'No inventory items yet.',
    ppStaffManagement: 'Staff Management',
    ppStaffPositionPlaceholder: 'e.g., Cashier, Cook, Security',
    ppNoStaffPositions: 'No staff positions yet',
    ppAddStaffHint: 'Add one above to get started',
    ppPositionDimensions: 'Position & Dimensions',
    ppPosition: 'Position',
    ppDimensions: 'Dimensions',
    ppXMeters: 'X (m)',
    ppYMeters: 'Y (m)',
    ppWidthMeters: 'Width (m)',
    ppDepthMeters: 'Depth (m)',
    ppHeightMeters: 'Height (m)',
    ppCornerRadius: 'Corner Radius',
    ppAllCorners: 'All Corners (m)',
    ppTopLeft: 'Top Left (m)',
    ppTopRight: 'Top Right (m)',
    ppBottomLeft: 'Bottom Left (m)',
    ppBottomRight: 'Bottom Right (m)',
    ppCalculations: 'Calculations',
    ppFloorArea: 'Floor Area',
    ppVolume: 'Volume',
    ppConfiguration: 'Configuration',
    ppConfigurationDesc: 'Select configurations where this element should appear',
    ppCurrent: '(current)',
    ppShops: 'Shops',
    ppShopsDesc: 'Select F&B Elements that use this storage',
    ppShopsDescShop: 'Select related F&B Elements',
    ppShopsDescKitchen: 'Select Food & Beverages shops served by this kitchen',
    ppStorageType: 'Storage type',
    ppHospitalityType: 'Hospitality type',
    ppMerchType: 'Merch type',
    ppAccessType: 'Access type',
    ppEntertainmentType: 'Entertainment type',
    ppTicketingType: 'Ticketing type',
    ppKitchenType: 'Kitchen type',
    ppItems: 'Items',
    ppItemsPlaceholder: 'e.g., T-shirt, Cap, Scarf',
    ppNoItems: 'No items yet.',
    ppDeleteTitle: 'Delete element',
    ppDeleteDesc: 'This action cannot be undone. You can choose to keep historical data for reporting.',
    ppKeepHistoricalData: 'Keep historical data',

    // Data Integration
    diTitle: 'Data Integration',
    diFB: 'F&B',
    diFBIntegration: 'F&B Integration',
    diAddIntegration: 'Add Integration',
    diNoIntegrations: 'No integrations added yet',
    diNoIntegrationsHint: 'Click "Add Integration" to get started',
    diReconfigure: 'Reconfigure',
    diRemove: 'Remove',
    diConnected: 'Connected',
    diCreated: 'Created',
    diOrg: 'Org',
    diFrom: 'From',
    diUntil: 'Until',
    diSyncing: 'Syncing...',
    diSyncImport: 'Sync & Import',
    diSyncHistory: 'History',
    diLinkSpace: 'Link a space',
    diLocations: 'Locations',
    diNoLocations: 'No locations — run Sync to import',
    diSpaces: 'Spaces',
    diNoSpaces: 'No space linked — click + to configure',
    diConfigureSpace: 'Configure space',
    diLinkedSpace: 'Linked space',
    diWeezeventLocations: 'Weezevent Locations (POS)',
    diInternalShops: 'Internal shops',
    diNoWeezeventLocations: 'No Weezevent locations found for this integration',
    diAssociateIntegrationToSpace: 'Link this integration to a DataFriday Space',
    diAssociateIntegrationToSpaceDesc: 'Select or create a Space that represents this venue (e.g. Stade Français).',
    diAssociateLocationsToShops: 'Step 2: Map Weezevent Locations to internal shops',
    diAssociateLocationsToShopsDesc: 'Map each Weezevent point of sale (location) to an element in your space configuration.',
    diLocationColumn: 'Location (Weezevent)',
    diIntegrationLevelSpaceStep: 'Step 1: Link to a Space',
    diIntegrationLevelShopStep: 'Step 2: Map Locations to Shops',
    diIntegrationNoLocations: 'No locations found — run Sync & Import first.',
    diIntegrationShopsSaved: 'Locations mapped successfully',
    diIntegrationShopsSkipped: 'Skipped unmapped locations',
    diNoSpaceMappedHint: 'Run Sync & Import, then click + to link this integration to a Space.',
    diMapped: 'mapped',
    diUnmapped: 'unmapped',
    diAll: 'All',
    diMatchScore: 'Match',
    diSaveAndNext: 'Save & Next',
    diSkipUnmapped: 'Skip unmapped',
    diApplySuggestions: 'Apply all',
    diAutoSuggestionBanner: '{n} automatic suggestion{s} available',
    diSelectSpace: 'Select a Space',
    diCreateSpace: 'Create a new Space',
    diSpaceName: 'Space name',
    diFloors: 'Floors',
    diBasements: 'Basements',
    diForecourt: 'Forecourt',
    diExternalArea: 'External area',
    diCreateSpaceBtn: 'Create Space',
    diSuggestion: 'Suggestion',
    diUseSuggestion: 'Use',
    diOrUse: '— or —',
    diSpaceMappingNext: 'Next',
    diSpaceMappingDisabled: 'Select a space to continue',
    diCancelSync: 'Cancel',
    diSyncDone: 'View results',
    diSyncFailed: 'Close',
    diWeezeventSyncTitle: 'Weezevent Synchronisation',
    diImportDone: 'Import complete!',
    diImportedData: 'Imported data',
    diDetectedLocations: 'Detected locations',
    diConfigureLocations: 'Configure locations',
    diNeverSynced: 'never',
    diLastSync: 'Last sync:',
    diCount: '{n} imported',
    diRunning: 'running...',
    diError: 'Error',
    diSyncError: 'Sync error',
    diSyncSuccess: 'Events synced ({n} items)',
    diTestConnectionBtn: 'Test Connection',
    diSaveConnectBtn: 'Save & Connect',
    diUpdateSaveBtn: 'Update & Save',
    diModifyCredentialsBtn: 'Modify credentials',
    diWeezeventDescCard: 'Event ticketing and cashless payment',
    diAddIntegrationTitle: 'Add Integration',
    diAddIntegrationDesc: 'Select an integration to add to your F&B setup',
    diWeezeventDesc: 'Event ticketing and cashless',
    diDigifoodDesc: 'Digital food ordering',
    diSoon: 'Soon',
    diConfigureDigifood: 'Configure Digifood',
    diReconfigureDigifood: 'Reconfigure Digifood',
    diDigifoodRealtime: 'Real-time — webhooks',
    diDigifoodRealtimeHint: 'Sales arrive automatically as they happen. No sync needed.',
    diDigifoodWebhookUrl: 'Webhook URL',
    diDigifoodWebhookUrlHint: 'Give this URL to Digifood to enable real-time sales delivery.',
    diDigifoodSecret: 'Webhook secret',
    diDigifoodSecretHint: 'HMAC secret provided by Digifood (webhook signature).',
    diDigifoodSecretKeepPlaceholder: 'Leave empty to keep the current secret',
    diDigifoodSecretRequired: 'Webhook secret is required',
    diDigifoodCheckReception: 'Check reception',
    diDigifoodLastWebhook: 'Last webhook received',
    diDigifoodNoWebhook: 'No webhook received yet — check provisioning with Digifood.',
    diDigifoodImportCsv: 'Import CSV history',
    diDigifoodImportCsvTitle: 'CSV history import',
    diDigifoodImportCsvHint: 'Bootstraps catalog and points of sale before the first webhook sales (or catches up a reception gap). Preview first, nothing is written.',
    diDigifoodDryRunReport: 'Preview (no data written)',
    diDigifoodConfirmImport: 'Confirm import',
    diDigifoodImportDone: 'Import completed',
    diDigifoodOrdersDetected: 'orders detected',
    diDigifoodOrdersCreated: 'new orders',
    diDigifoodOrdersUpdated: 'already known (updated)',
    diDigifoodOrdersSkipped: 'skipped',
    diDigifoodProductsCreated: 'new products',
    diDigifoodLocationsCreated: 'new points of sale',
    diDigifoodRejectedRows: 'rejected rows',
    diDigifoodPosVersion: 'POS version',
    diCopy: 'Copy',
    diCopied: 'Copied!',
    diDigifoodNoLocationsHint: 'No point of sale received yet. Import a CSV history or wait for the first webhook sales.',
    diDigifoodTemplateHint: 'Expected format (or map your own columns below)',
    diDigifoodDownloadTemplate: 'Download CSV template',
    diDigifoodMappingTitle: 'Column mapping',
    diDigifoodMappingHint: 'Match your file\'s columns to the expected fields — auto-detected, adjust if needed.',
    diDigifoodMappingIgnore: '— ignore —',
    diDigifoodMappingRequired: 'Map the required fields: order ID, item, quantity, and one price (unit cents OR line total €).',
    diDigifoodPeriodDetected: 'Detected period',
    diDigifoodMappingBadHint: 'No order detected — your columns probably don\'t match. Check the column mapping above, then run the preview again.',
    diConfigureWeezevent: 'Configure Weezevent',
    diReconfigureWeezevent: 'Reconfigure Weezevent',
    diConfigureDesc: 'Enter your Weezevent API credentials to connect your account.',
    diReconfigureDesc: 'Update your Weezevent API credentials.',
    diInstanceName: 'Instance name',
    diInstanceNamePlaceholder: 'e.g. Hellfest 2025',
    diInstanceNameHint: 'A label to identify this integration',
    diClientId: 'Client ID',
    diClientIdPlaceholder: 'e.g. app_eat-is-family-datafriday_...',
    diClientSecret: 'Client Secret',
    diClientSecretPlaceholder: 'e.g. your-client-secret',
    diClientSecretKeepPlaceholder: 'Leave empty to keep current secret',
    diOrgId: 'Organization ID',
    diOrgIdPlaceholder: 'e.g. 182509',
    diConnectionSuccess: 'Connection to Weezevent established successfully',
    diConfigSaved: 'Configuration saved! Importing data...',
    diConfigUpdated: 'Configuration updated!',
    diTestConnection: 'Test Connection',
    diSaveConnect: 'Save & Connect',
    diUpdateSave: 'Update & Save',
    diModifyCredentials: 'Modify credentials',
    diClientIdRequired: 'Client ID and Organization ID are required',
    diClientSecretRequired: 'Client Secret is required',
    diConnectionFailed: 'Connection failed — check your credentials',
    diSaveFailed: 'Failed to save configuration',

    // StepMapShops
    smsTitle: 'Step 2: Map Locations to Internal Shops',
    smsSubtitle: 'Map each Weezevent location (point of sale) to an internal shop in your configuration.',
    smsMappedChip: 'mapped',
    smsAutoSuggestion: 'automatic suggestion',
    smsAutoSuggestions: 'automatic suggestions',
    smsAutoSuggestionAvailable: 'available',
    smsApplyAll: 'Apply all',
    smsMapped: 'Mapped',
    smsUnmapped: 'Unmapped',
    smsAll: 'All',
    smsColLocation: 'Location (Weezevent)',
    smsColShop: 'Internal Shop (DataFriday)',
    smsColMatch: 'Match',
    smsSelectPlaceholder: 'Select...',
    smsCreateShopTitle: 'Create a DataFriday shop',
    smsCreateShopDesc: 'This shop will be created in your space and mapped to the Weezevent shop',
    smsShopName: 'Shop name',
    smsShopNameRequired: 'Name is required',
    smsShopType: 'Type',
    smsCreateAndMap: 'Create & Map',
    smsCancel: 'Cancel',
    smmCreateTitle: 'Create a menu item',
    smmCreateFor: 'For',
    smmCreateSectionId: 'Identification',
    smmCreateLabelName: 'Item name',
    smmCreatePlaceholderName: 'Ex. Draft beer 50cl',
    smmCreateLabelType: 'Type',
    smmCreateLabelCategory: 'Category',
    smmCreateChoose: '— Choose —',
    smmCreateSectionPrice: 'Sale price',
    smmCreateLabelPrice: 'Price (€)',
    smmCreatePlaceholderPrice: '0.00',
    smmCreateLabelPriceTtc: 'Price incl. VAT (€)',
    smmCreateLabelVat: 'VAT (%)',
    smmCreateVatPlaceholder: 'Tenant default',
    smmCreateLabelDiscountType: 'Discount',
    smmCreateLabelDiscountValue: 'Discount value',
    smmCreateDiscountNone: 'None',
    smmCreateDiscountPercent: 'Percent',
    smmCreateDiscountAmount: 'Amount (€)',
    smmPriceGrossTtc: 'Gross (incl. VAT)',
    smmPriceDiscount: 'Discount',
    smmPriceNetTtc: 'Net (incl. VAT)',
    smmPriceHt: 'o/w excl. VAT',
    smmPriceVat: 'o/w VAT',
    smmPriceVatUnknown: 'Enter a VAT rate to see the excl.-VAT / tax breakdown (otherwise the tenant default applies server-side).',
    smmCreateConfirm: 'Create & Map',
    smmCreateCancel: 'Cancel',
    smsSkipUnmapped: 'Skip unmapped',
    smsSave: 'Save',
    smsNoMerchants: 'No location (point of sale) found. Run a Sync & Import first.',
    smsShopGeneric: 'Generic shop',
    smsShopFnbFood: 'Food & Beverage - Food',
    smsShopFnbBeverages: 'Food & Beverage - Beverages',
    smsShopFnbBar: 'Food & Beverage - Bar',
    smsShopFnbSnack: 'Food & Beverage - Snacks',
    smsShopFnbIcecream: 'Food & Beverage - Ice cream',
    smsShopMerch: 'Merchandising',

    // Types de PdV canoniques (Analyse) — alignés sur l'enum Space Menu
    anShopTypeFood: 'Food',
    anShopTypeBeverages: 'Beverages',
    anShopTypeBeer: 'Beer',
    anShopTypeGpPremium: 'GP Premium',
    anShopTypeTemporary: 'Temporary',
    anShopTypeDrinkee: 'Drinkee',
    anShopTypeOther: 'Other',
    anWeezeventUnmatchedToast: '{n} Weezevent product(s) without an app category — categories incomplete',
    anUnmatchedItems: 'Unattached',
    anUnmatchedShops: 'Unattached POS',
    anUnmatchedCoverageToast: '{n} sale(s) not matched to the DataFriday catalog · {pct}% catalog coverage',
    anNoEventsForConfig: 'No event attached to this configuration.',
    anCatalogLoadError: 'Failed to load the catalog.',
    anCatalogLoading: 'Loading the catalog…',
    anCatalogNoConfig: 'No usable configuration.',
    anCatalogNoShops: 'No point of sale available for this configuration.',
    anCatalogNoItems: 'No item available for this configuration.',
    anRetry: 'Retry',
    anNoComparisonData: 'No comparison data for this period',
    anComparisonNeedsDates: 'Enter start and end dates to compare',
    anNoItemData: 'No item data for this period',
    diImportHistory: 'Import history (N-1)',
    anOpenMenuItem: 'Open the menu item (verify mapping)',

    // Analyse module
    anConfiguration: 'Configuration',
    anTools: 'Tools',
    anToolAnalyse: 'Analyse',
    anToolPredict: 'Predict',
    anToolEventPredict: 'Event Predict',
    anToolInventory: 'Inventory',
    anToolLogistic: 'Logistic',
    anToolRestock: 'Restock',
    anEvents: 'Events',
    anAll: 'All',
    anNone: 'None',
    anDates: 'Dates',
    anStartDate: 'Start date',
    anEndDate: 'End date',
    anAttendance: 'Attendance',
    anTicketsSold: 'Tickets sold',
    anTicketsScanned: 'Tickets scanned',
    anAdvancedFilters: 'Advanced filters',
    anEventCategory: 'Event category',
    anEventType: 'Event type',
    anTeam: 'Team',
    anSponsor: 'Sponsor',
    anSubcategory: 'Subcategory',
    anSessions: 'Sessions',
    anDoorsOpening: 'Doors opening',
    anShowTime: 'Show time',
    anVisitingTeam: 'Visiting team',
    anPerformer: 'Performer',
    anOpeningAct: 'Opening act',
    anIntermission: 'Intermission',
    anYes: 'Yes',
    anNo: 'No',
    anComparisonMode: 'Comparison mode',
    anCopyImage: 'Copy as image',
    anShowActiveFilters: 'Show active filters',
    anShops: 'Points of sale',
    anShopTypes: 'POS types',
    anTypes: 'Types',
    anZones: 'Zones',
    anMenuItems: 'Menu items',
    anItems: 'Items',
    anTypeCategory: 'Type & Category',
    anItemType: 'Type (Food/Drinks/Glasses)',
    anCategory: 'Category',
    anComparison: 'Comparison',
    anPrevPeriod: 'Prev. period',
    anYearOverYear: 'Year-over-year',
    anResetFilters: 'Reset filters',
    anAllConfigurations: 'All Configurations',
    anScheduled: 'Scheduled',
    anSearchEvent: 'Search for an event...',
    anSearchShop: 'Search for a POS...',
    anActiveFilters: 'Active filters',
    anNoActiveFilters: 'No active filters. All events and points of sale are included.',
    anResetAllFilters: 'Reset all filters',
    anClose: 'Close',
    anFrom: 'From',
    anRangeAll: 'All history',
    anRangeToday: 'Today',
    anRangeYesterday: 'Yesterday',
    anRangeThisWeek: 'This week',
    anRangeLastWeek: 'Last week',
    anRangeThisMonth: 'This month',
    anRangeLastMonth: 'Last month',
    anRangeNextMonth: 'Next month',
    anRangeThisQuarter: 'This quarter',
    anRangeLastQuarter: 'Last quarter',
    anRangeNextQuarter: 'Next quarter',
    anRangeThisYear: 'This year',
    anRangeLastYear: 'Last year',
    anRangeNextYear: 'Next year',
    anRangeCustom: 'Custom period',
    anRangeLast7Days: 'Last 7 days',
    anRangeLast30Days: 'Last 30 days',
    anRangeLast90Days: 'Last 90 days',
    anChipDates: 'Dates',
    anChipTimeRange: 'Time range',
    anAlertsInsights: 'Alerts & insights',
    anMarkAllRead: 'Mark all as read',
    anNoAlerts: 'No alerts. Everything is fine for the current period.',
    anCopy: 'Copy',
    anShare: 'Share',
    anEventsSelected: 'event(s) selected',
    anThisYear: 'This year',
    anClearAll: 'Clear all',
    anEventsPerformance: 'Events performance',
    anCollapse: 'Collapse',
    anSeeAll: 'See all',
    anSemanticMatch: 'Found by semantic match',
    anClear: 'Clear',
    anAssistantTip: '💡 Type **help** to see all supported questions.',
    anClick: 'Click',
    anDataAnalysis: 'Data analysis',
    anQueryPlaceholder: 'e.g.: What is the revenue...',
    anAnalyze: 'Analyze',
    anSmartUnderstanding: 'Smart understanding',
    anSemanticTooltip: 'Activates a local AI model (Transformers.js, ~25 MB) that understands paraphrases. Downloaded once, cached. No data sent externally.',
    anModelDownloading: 'Downloading model...',
    anShopPerformance: 'POS performance',
    anTotal: 'Total',
    anAvg: 'Avg.',
    anUnits: 'units',
    anPerEvent: '/ event',
    anSeeAllShops: 'See all POSs',
    anItemPerformance: 'Item performance',
    anCompareTo: 'Compare with',
    anComparedToWindow: 'Compared to:',
    anEventsWord: 'events',
    anEditFilter: 'Edit filter',
    anPrevious: 'Previous',
    anLoading: 'Loading...',
    anAvgPerEvent: 'Avg. per event',
    anMenuItemsByShop: 'Menu items by POS',
    anSearchItemsByShop: 'Search by POS, type, category or item...',
    anGroupByItem: 'Group by item',
    anGroupByShop: 'Group by POS',
    anByShop: 'By POS',
    anByItem: 'By item',
    anScopeAll: 'All',
    anScopeShop: 'POS',
    anScopeType: 'Type',
    anScopeCategory: 'Category',
    anScopeItem: 'Item',
    anSearchByShop: 'Search by POS…',
    anSearchByType: 'Search by type…',
    anSearchByCategory: 'Search by category…',
    anSearchByItem: 'Search by item…',
    anAvgQty: 'Avg Qty',
    anTotalQty: 'Total Qty',
    anMenuItemDistTitle: 'Revenue distribution by item',
    anTotalRevenue: 'Total revenue',
    anQuantityMode: 'Quantity',
    anRevenueMode: 'Revenue',
    anCatTotal: 'Total revenue',
    anTopItemsByRevenue: 'Top items by revenue',
    anSubtitleItems: 'Top 10 of {n} items',
    anUnidentifiedItem: 'Unidentified transaction item',
    anByItemType: 'By item type',
    anSubtitleTypes: '{n} types',
    anByItemCategory: 'By item category',
    anSubtitleCategories: '{n} categories',
    anTypes: 'Types',
    anCategories: 'Categories',
    anAllCategories: 'All categories',
    anItem: 'Item',
    anType: 'Type',
    anQuantity: 'Quantity',
    anRevenue: 'Revenue',
    anShop: 'POS',
    anPeriod: 'Period',
    anFoodBev: 'Food & Beverage',
    anEventLabel: 'Event',
    anTo: 'To',

    // Charts – Analyse
    // Metric labels (GenericByEventChart toggles)
    anMetricCA: 'Rev.',
    anMetricCost: 'Cost',
    anMetricTransactions: 'Transactions',
    anMetricAttendees: 'Attendees',
    anMetricAvgBasket: 'Basket',
    anMetricPerCap: 'Per cap',
    anMetricTransferRate: 'Trans. rate',
    anSortDate: 'Date',
    // GenericByEventChart – config strings
    anChartPerEvent: 'per event',
    anChartEventCount: 'event(s)',
    anChartDisplayLabel: '· display:',
    // EventRevenueByShopChart
    anChartChangeAggLabel: 'Change aggregation',
    anChartPredictionsIncluded: 'Predictions included',
    anChartCumulativeRev: 'Cumul. Rev.',
    anChartSortByDate: 'By Date',
    anChartSortByRevenue: 'By Revenue',
    anChartViewShops: 'Shops',
    anChartViewMenuTypes: 'Menu Types',
    anChartAverage: 'Average',
    anChartNoRevenueByShop: 'No revenue data by shop',
    anChartNoRevenueByMenuType: 'No revenue data by menu type',
    anChartAvailableForSelection: 'available for the selection.',
    anChartAdjustFiltersHint: 'Adjust your filters or the date range to display data.',
    anChartLegendCollapse: 'Collapse',
    anChartShowMore: 'Show',
    anChartLegendTypes: 'types',
    anChartAggPerEvent: 'Per Event',
    anChartAggMonthly: 'Monthly',
    anChartAggQuarterly: 'Quarterly',
    anChartAggYearly: 'Yearly',
    anChartSubtitleMonthly: 'Monthly Revenue',
    anChartSubtitleQuarterly: 'Quarterly Revenue',
    anChartSubtitleYearly: 'Annual Revenue',
    anChartSubtitleEvent: 'Event Revenue',
    anChartShopDim: 'shop',
    anChartMenuTypeDim: 'menu type',
    anChartTitleBy: 'by',
    anChartTitleExTax: '(ex-tax)',
    anChartTooltipPredictedPrefix: 'PREDICTED',
    anChartTooltipLowConf: 'LOW CONFIDENCE',
    anChartTooltipPeriod: 'Period:',
    anChartTooltipDate: 'Date:',
    anChartTooltipCumulRev: 'Cumul. Rev.:',
    anChartTooltipTotal: 'Total:',
    anChartTooltipGlobalShare: '· Global share:',
    anChartTooltipEventSuffix: 'event(s)',
    // EventTimelineChart
    anTimelineDefaultEvent: 'Event',
    anTimelinePredictiveData: 'Predictive data',
    anTimelineBreakdownMenu: 'Menu',
    anTimelineBreakdownShop: 'Shop',
    anTimelineReset: 'Reset',
    anTimelineStart: 'Start',
    anTimelineEnd: 'End',
    anTimelineNoData: 'No timeline data available.',
    anTimelineOthers: 'Others',
    anTimelineAvgPrefix: 'Average over',
    anTimelineAvgAlignedEvents: 'aligned events',
    anTimelineAvgUnalignedSuffix: '(not aligned)',
    anUnalignedAlert: 'excluded from the average — no kickoff time',
    anUnalignedAlertView: 'View',
    anUnalignedDialogTitle: 'Events without a kickoff time',
    anUnalignedDialogSubtitle: 'These events have no usable showtime, so they cannot be aligned and were excluded from the average. Add a kickoff time to include them.',
    anUnalignedDialogAddTime: 'Add time',
    anUnalignedDialogClose: 'Close',
    // ShopDistributionPieChart
    anPieDistributionTitle: 'POS Distribution by Revenue',
    anPieTotalRevenue: 'Total Revenue:',
    anPieByShopTitle: 'POS Distribution',
    anPieByShopSubtitle: 'points of sale',
    anPieByTypeTitle: 'By POS type',
    anPieByTypeSubtitleSuffix: 'types',
    anPieByAreaTitle: 'By area',
    anPieByAreaSubtitleSuffix: 'areas',
    // ShopPerformanceByTransactionRate
    anShopPerfTitle: 'Shop Performance by Transaction Rate',
    anShopPerfSubtitle: 'Shops ranked by total revenue',
    anShopPerfShopName: 'Shop Name',
    anShopPerfExportTooltip: 'Export Excel',
    anShopPerfCalculating: 'Calculating transaction rates…',
    anShopPerfNoData: 'No transaction rate data available.',
    anShopPerfTotalRevenue: 'Total Revenue',
    anShopPerfAvgEvent: 'Avg/Event',
    anShopPerfTxnPerMin: 'txn/min',
    anShopPerfFirstHour: '1st hour',
    anShopPerfTotalTransactions: 'Total Transactions:',
    anShopPerfEventsLabel: 'Events:',
    anShopPerfOperatingMinutes: 'Operating Minutes:',
    anShopPerfPeak: 'Peak (15 min):',
    anShopPerfPage: 'page',
    // DonutChartCard
    anDonutCollapse: '↑ Collapse',
    anDonutShowAll: '↩ Show all',

    // Ex-DoorsOpeningDialog (supprimé) — clés conservées : ShopItemEventsDialog les utilise.
    anDoorsDialogEvent: 'event',
    anDoorsDialogEvents: 'events',
    anEventsDialogTitle: 'Events',
    anEventsDialogShop: 'Shop',
    anEventsDialogItem: 'Menu item',
    anEventsDialogOrdered: 'ordered chronologically',
    anEventsDialogEmpty: 'No events found for this menu item',
    anEventsDialogClose: 'Close',
    invCountTitle: 'Count',
    invCountCounted: 'Counted',
    invCountPackedUnits: 'Packed units',
    invCountNumberOf: 'Number of',
    invCountOf: 'of',
    invCountLooseUnits: 'Number of loose units',
    invCountTotal: 'Total',
    invCountMarkCounted: 'Mark counted',
    invCountReset: 'Reset',
    invCountPerPack: '/pack',
    invCountUnitFallback: 'pc',
    invCountEmptyTitle: 'No items to count',
    invCountEmptyHint: 'This point of sale has no mapped menu items. Complete menu mapping (wizard step 3) for this space to populate the inventory.',
    invCardItems: 'items',
    invCardNoItems: 'No items',
    invCardStartCount: 'Start counting',
    invCardContinueCount: 'Continue counting',
    invCardReviewCount: 'Review count',
    invAllCountedToast: 'all items counted ✓',
    invPageTitle: 'Space Inventory',
    invChangeSpace: 'Change space',
    invSearchSpace: 'Search a space…',
    invNoSpaces: 'No space available',
    invNoSpaceFound: 'No space found',
    invEventLabel: 'Event',
    invDemoData: 'Demo data',
    invFiltersBtn: 'Filters',
    invDemoActive: 'Demo active',
    invDemoMode: 'Demo mode',
    invEventSource: 'Event source',
    invSearchShopsItems: 'Search shops or items',
    invPrint: 'Print',
    invPrintInventory: 'Print inventory',
    invSave: 'Save',
    invConfiguration: 'Configuration',
    invTools: 'Tools',
    invFilters: 'Filters',
    invTabShops: 'F&B Shops',
    invTabStorage: 'Storage',
    invTabMerch: 'External Merch',
    invToolAnalyse: 'Analyse',
    invToolPredict: 'Predict',
    invToolEventPredict: 'Event Predict',
    invToolInventory: 'Space Inventory',
    invToolLogistic: 'Logistic',
    invToolRestock: 'Restock',

    // ── Logistic (stock temps réel par PDV/Storage) ──
    logiPageTitle: 'Logistic',
    logiSince: 'since',
    logiSearchPlaceholder: 'Search an item…',
    logiResetBtn: 'Reset inventory',
    logiTabShops: 'F&B Shops',
    logiTabStorage: 'Storage',
    logiManageStock: 'Manage stock',
    logiRowItemsSuffix: 'items tracked',
    logiFilters: 'Filters',
    logiFilterElements: 'Search a shop…',
    logiItemKind: 'Item type',
    logiKindIngredient: 'Ingredient',
    logiKindComponent: 'Component',
    logiKindPackaging: 'Packaging',
    logiKindProduct: 'Product',
    logiSummary: 'Summary',
    logiSummaryElements: 'tracked shops & storages',
    logiSummaryItems: 'tracked items',
    logiSort: 'Sort',
    logiSortName: 'Name',
    logiSortRuptures: 'Out of stock first',
    logiSortStock: 'Lowest stock first',
    logiRowRuptures: 'out of stock',
    logiRowLowStock: 'low stock',
    logiAggTitle: 'Restock alerts',
    logiAggShopsSuffix: 'shops',
    logiAggStatRuptures: 'out of stock',
    logiAggStatLow: 'low stock',
    logiAggStatUncounted: 'never counted',
    logiAggEmpty: 'Nothing to report — all good.',
    logiAggGo: 'Manage',
    logiReconciliation: 'Reconciliation',
    logiReconciliationEmpty: 'No reconciliation yet.',
    logiReconciliationNoEvent: 'Inventory',
    logiLines: 'lines',
    logiDownloadCsv: 'Download CSV',
    logiEmpty: 'No shop in this configuration.',
    logiItems: 'items',
    logiNoItems: 'No item for this element.',
    logiHistoryBtn: 'History',
    logiUnits: 'units',
    logiPackedShort: 'packed',
    logiLooseShort: 'loose',
    logiAddTitle: 'Add a product',
    logiRemoveTitle: 'Remove a product',
    logiProduct: 'Product',
    logiMarketPrice: 'Product name',
    logiMarketPricePlaceholder: 'Market price for this product',
    logiPacked: 'Packed',
    logiLoose: 'Number of loose units',
    logiPackagingOf: 'of',
    logiNumberOf: 'Number of',
    logiTotal: 'Total',
    logiAvailable: 'Available',
    logiReason: 'Reason',
    logiReasonDelivery: 'Delivery',
    logiReasonFromShop: 'Transfer from a shop',
    logiReasonFromStorage: 'Transfer from a storage',
    logiReasonToShop: 'Transfer to a shop',
    logiReasonToStorage: 'Transfer to a storage',
    logiReasonExpiry: 'Expiry date (best before)',
    logiReasonOther: 'Other',
    logiReasonTransferShop: 'Shop transfer',
    logiReasonTransferStorage: 'Storage transfer',
    logiReasonSale: 'Sales',
    logiReasonReset: 'Inventory reset',
    logiFromShop: 'Shop name',
    logiToShop: 'Shop name',
    logiFromStorage: 'Storage name',
    logiToStorage: 'Storage name',
    logiExpiryDate: 'Best before date',
    logiOtherReason: 'Reason',
    logiOtherReasonPlaceholder: 'Explain the reason…',
    logiCancel: 'Cancel',
    logiAddBtn: 'Add',
    logiRemoveBtn: 'Remove',
    logiHistoryTitle: 'Logistics history',
    logiToday: 'Today',
    logiYesterday: 'Yesterday',
    logiHistoryEmpty: 'No operation recorded yet.',
    logiHistoryError: 'Unable to load history.',
    logiHistoryMore: 'Load more',
    logiHistoryTo: 'to',
    logiHistoryFrom: 'from',
    logiHistorySales: 'sales (aggregated per event)',
    logiHistorySalesNoEvent: 'Sales without event',
    logiRetry: 'Retry',
    logiMovementSaved: 'Movement saved.',
    logiMovementError: 'Unable to save the movement.',
    logiResetConfirm: 'Replace all expected values with the quantities counted during the last inventory? Differences will be archived in the Reconciliation section.',
    logiResetEvent: 'Reference inventory',
    logiResetGo: 'Reset',
    logiResetDone: 'Inventory reset done — differences archived.',
    logiResetError: 'Inventory reset failed.',
    logiResetNothing: 'No counted or tracked value to reset.',
    logiDownloadError: 'Download failed.',

    invMetricShops: 'Shops',
    invMetricStorages: 'Storage',
    invMetricItems: 'Items',
    invMetricCounted: 'Counted',
    invLoadingInventory: 'Loading inventory…',
    invEmptyMappedTitle: 'No mapped products for this space',
    invEmptyMappedHint: "This space has no menu items mapped yet (menu mapping — wizard step 3). Until that's done, there is nothing to count here.",
    invConfigReadonly: 'Configuration',
    invEmptyConfigTitle: 'No items assigned for this configuration',
    invEmptyConfigHint: 'The open points of sale of this configuration have no menu items assigned. Assign items in Space Menus.',
    invOpenFromEventPredictTitle: 'No event selected',
    invOpenFromEventPredict: 'Open the inventory from Event Predict to choose the space and configuration to inventory.',
    invAssignmentLoadError: 'Could not load the shop assignment for this configuration.',
    invAssignmentRetry: 'Retry',
    invAssignmentPartialWarning: 'Some points of sale could not be loaded — the list may be incomplete.',
    invUseDemo: 'Use demo data',
    invNothingTitle: 'Nothing to display',
    invResetFilters: 'Reset filters',
    invDemoSheetTitle: 'Demo mode',
    invDemoSheetBody: 'Enable mock data (Adidas Arena) to run the inventory, the summary and the shopping list without a backend: shops, counts, packaging types and reference sales are simulated.',
    invDemoActiveChip: 'Demo mode active',
    invRealModeChip: 'Real mode (API)',
    invClose: 'Close',
    invEnableDemo: 'Enable demo',
    invExitDemo: 'Exit demo',
    invEventIndependent: 'Event-independent',
    invColItem: 'Item',
    invColPacked: 'Packed',
    invColLoose: 'Loose',
    invColLooseUnits: 'Loose units',
    invColShops: 'Shops',
    invUsedIn: 'Used in:',
    invPrintInvTitle: 'Inventory',
    invPrintShopTitle: 'Shopping list',
    invExportInventory: 'Export inventory (CSV)',
    invStatusToCount: 'To count',
    invStatusCounted: 'Counted',
    invNoSearchResult: 'No result for this search.',
    invNoItemsInFilter: 'No item in this filter.',
    invAggSummaryTitle: 'Inventory Summary',
    invAggTabInventory: 'Counted inventory',
    invAggChooseEvent: 'Choose a reference event…',
    invAggTotalItems: 'Total items',
    invAggTotalUnits: 'Total units',
    invAggItemsToRestock: 'Items to restock',
    invAggUnitsToRestock: 'Units to restock',
    invAggNoCount: 'No inventory counted yet',
    invAggNoCountHint: 'Start counting items in shops to see the summary here',
    invAggCalcShopping: 'Computing shopping list…',
    invAggPickEventRestock: 'Choose a reference event to compute restocking.',
    invAggAllInStock: 'Everything in stock — nothing to restock.',
    invAggRestockPacks: 'To restock (packs):',
    invAggRestockLoose: 'To restock (loose):',
    invAggRestockTotal: 'Total to restock:',
    invAggDetailByShop: 'Detail by shop',
    invPackaging: 'packaging',
    invFilterTitle: 'Inventory filters',
    invFilterStatus: 'Status',
    invFilterShops: 'Shops',
    invFilterShopTypes: 'Shop types',
    invFilterZones: 'Areas',
    invStorageCollapse: 'Collapse',
    invStorageShowAll: 'Show all',
    // inv — SpaceInventoryView / InventoryAggregateView / InventoryCountingInterface
    invOptions: 'Options',
    invOptionsTitle: 'Inventory options',
    invToolsLabel: 'Tools',
    invVerifyCoverage: 'Check stock ↔ menus',
    invBack: 'Back',
    invToolboxNav: 'Tools navigation',
    invSummaryAria: 'Inventory summary',
    invLoadingAria: 'Loading inventory',
    invPrevShop: 'Previous shop',
    invNextShop: 'Next shop',
    invCountedTooltip: '"Counted" = shops where ALL items are counted. A partial count keeps the shop in "To count" — hence a "Counted" of 0 until a shop is fully counted at 100%.',
    invIncompleteTitle: 'Incomplete inventory',
    invIncompleteMsgPrefix: 'items counted. Save and move to restocking anyway?',
    invSaveAnyway: 'Save anyway',
    invContinueCounting: 'Keep counting',
    invSaveError: 'Failed to save the inventory',
    invFocusCounting: 'Counting in progress:',
    invAggGoalLabel: 'Goal derived from a past event’s sales',
    invAggNoPastEvent: 'No past event available as a reference.',
    invAggDegraded: 'Sales detail unavailable for this event — goal in degraded mode.',
    invAggTodoTitle: 'Shops to count',
    invChangeShop: 'Change shop',
    hdrSecSpaces: 'Spaces',
    hdrSecEvents: 'Events',
    hdrSecDashboard: 'Dashboard',
    hdrSecSuppliers: 'Suppliers',
    hdrSecEventTypes: 'Event types',
    hdrSecEventCategories: 'Categories',
    hdrSecEventSubcategories: 'Subcategories',
    hdrSecBuilder: 'Builder',
    hdrSecEventPredict: 'Event Predict',
    hdrSecInventory: 'Inventory',
    // eps — EventPredictStockUpSection
    epsNoConfigSelected: 'No configuration selected',
    epsNoStockItems: 'No stock items to display',
    epsSelectMenuItemsHint: 'Select menu items in the Configuration settings section above',
    epsTotalEstimatedCost: 'Estimated total stock-up cost',
    epsOtherCategory: 'Other',
    epsUnitCostTitle: 'Unit cost',
    epsItem: 'item',
    epsItems: 'items',
    epsFrom: 'from',
    epsPackagingOf: 'of',
    epsNoShopType: 'No Shop Type',
    epsAndJoiner: 'and',
    epsTypeFood: 'Food',
    epsTypeBeverages: 'Beverages',
    epsTypeBeer: 'Beer',
    epsTypeGpPremium: 'GP Premium',
    epsTypeTemporary: 'Temporary',
    epsTypeDrinkee: 'Drinkee',
    // epm — EventPredictMenusSection
    epmEmptyNoConfig: 'No sales or configuration for this event',
    epmEmptyNoFbElements: 'No F&B elements found in this configuration',
    epmSearchShopsItems: 'Search shops or menu items...',
    epmTabOpen: 'Open',
    epmTabClosed: 'Closed',
    epmNoShopsFoundPrefix: 'No ',
    epmNoShopsFoundSuffix: ' shops found',
    epmPred: 'Pred.',
    epmAdjusted: 'Adjusted',
    epmShopAdjustment: 'Shop Adjustment',
    epmResetTo100: 'Reset to 100%',
    epmCollapseShop: 'Collapse shop details',
    epmExpandShop: 'Expand shop details',
    epmNoItemsForFilter: 'No menu items found for this filter',
    epItemsLoading: 'Loading items…',
    epNoItems: 'No items to display for now.',
    epNoItemsPrediction: 'No items available for this prediction. Check the configuration, item mapping, or re-run the calculation.',
    epmSelectAllItems: 'Select All Menu Items',
    epmCostLabel: 'cost',
    epmMarginLabel: 'margin',
    epmManualQty: 'Manual Qty:',
    epmUnits: 'units',
    epmUnitsLabel: 'Units:',
    epmMinusUnit: '−1 unit',
    epmPlusUnit: '+1 unit',
    epmUnitAbbr: 'u',
    epmMissing: 'Missing:',
    epmAdjustedColon: 'Adjusted:',
    epmSearchItemsShops: 'Search menu items or shops...',
    epmScrollLeft: 'Scroll categories left',
    epmScrollRight: 'Scroll categories right',
    epmTabAll: 'All',
    epmTabFood: 'Food',
    epmTabBeverage: 'Beverage',
    epmTabCombo: 'Combo',
    epmNoMenuItems: 'No menu items found',
    epmNoCategory: 'No Category',
    epmShopsSuffix: 'shops',
    epmItemAdjustment: 'Item Adjustment',
    epmMixed: 'Mixed',
    epmCollapseItem: 'Collapse item details',
    epmExpandItem: 'Expand item details',
    epmSelectAllShops: 'Select All Shops',

    // ep — EventPredictView
    epBack: 'Back',
    epTitle: 'Event prediction',
        b2Back: "Back",
        b2ElpAllAreas: "All Areas",
        b2ElpScrollLeft: "Scroll left",
        b2ElpScrollRight: "Scroll right",
        invToggleFilters: "Show/hide filters",
        srToggleFilters: "Show/hide filters",
        logiToggleFilters: "Show/hide filters",
        anHeaderToggleFilters: "Show/hide filters",
        anHeaderToggleNav: "Show/hide navigation",
        f_itemName: "Item name",
        f_unit: "Unit",
        f_price: "Price",
        f_goodType: "Good type",
        f_recipeUnit: "Recipe unit",
        f_purchaseUnitConversion: "Purchase unit conversion",
        f_category: "Category",
        f_supplierName: "Supplier name",
        f_supplierItemName: "Supplier item name",
        f_unitsPerPurchase: "Units per purchase",
        f_pricePerUnit: "Price per unit",
        f_purchasePackaging: "Purchase packaging",
        roleListEdit: "Edit",
        spaceMenuSelectItemsToAttach: "Select items to attach",
    displayNameListAddDisplayName: 'Add display name',
    displayNameListCancel: 'Cancel',
    displayNameListColActions: 'Actions',
    displayNameListColCreated: 'Created',
    displayNameListColName: 'Name',
    displayNameListCreate: 'Create',
    displayNameListDelete: 'Delete',
    displayNameListDeleteConfirm: 'Are you sure you want to delete',
    displayNameListDeleteSubtitle: 'This action is irreversible',
    displayNameListDeleteTitle: 'Delete display name',
    displayNameListDialogCreateSubtitle: 'Add a new display name to your list',
    displayNameListDialogCreateTitle: 'New display name',
    displayNameListDialogEditSubtitle: 'Update the display name',
    displayNameListDialogEditTitle: 'Edit display name',
    displayNameListLabelName: 'Display name',
    displayNameListNamePlaceholder: 'e.g. Deluxe Burger...',
    displayNameListSave: 'Save',
    displayNameListSearchPlaceholder: 'Search a display name...',
    displayNameListSubtitle: 'Manage your display names',
    displayNameListTitle: 'Display Names',
    displayNameListTotalDisplayNames: 'Total display names',
    industrialListAddIndustrial: 'Add industrial',
    industrialListCancel: 'Cancel',
    industrialListColActions: 'Actions',
    industrialListColCreated: 'Created',
    industrialListColName: 'Name',
    industrialListCreate: 'Create',
    industrialListDelete: 'Delete',
    industrialListDeleteConfirm: 'Are you sure you want to delete',
    industrialListDeleteSubtitle: 'This action is irreversible',
    industrialListDeleteTitle: 'Delete industrial',
    industrialListDialogCreateSubtitle: 'Add a new industrial to your list',
    industrialListDialogCreateTitle: 'New industrial',
    industrialListDialogEditSubtitle: 'Update the industrial',
    industrialListDialogEditTitle: 'Edit industrial',
    industrialListLabelName: 'Industrial',
    industrialListNamePlaceholder: 'e.g. Sysco, Metro...',
    industrialListSave: 'Save',
    industrialListSearchPlaceholder: 'Search an industrial...',
    industrialListSubtitle: 'Manage your industrials',
    industrialListTitle: 'Industrials',
    industrialListTotalIndustrials: 'Total industrials',
    menuItemCreateDisplayNamePlaceholder: 'Select a display name...',
    menuItemCreateLabelDisplayName: 'Display Name',
    packingTypeListAddPackingType: 'Add packing type',
    packingTypeListCancel: 'Cancel',
    packingTypeListColActions: 'Actions',
    packingTypeListColCreated: 'Created',
    packingTypeListColName: 'Name',
    packingTypeListCreate: 'Create',
    packingTypeListDelete: 'Delete',
    packingTypeListDeleteConfirm: 'Are you sure you want to delete',
    packingTypeListDeleteSubtitle: 'This action is irreversible',
    packingTypeListDeleteTitle: 'Delete packing type',
    packingTypeListDialogCreateSubtitle: 'Add a new packing type to your list',
    packingTypeListDialogCreateTitle: 'New packing type',
    packingTypeListDialogEditSubtitle: 'Update the packing type',
    packingTypeListDialogEditTitle: 'Edit packing type',
    packingTypeListLabelName: 'Packing type',
    packingTypeListNamePlaceholder: 'e.g. Cup, Keg, Bottle...',
    packingTypeListSave: 'Save',
    packingTypeListSearchPlaceholder: 'Search a packing type...',
    packingTypeListSubtitle: 'Manage your packing types',
    packingTypeListTitle: 'Packing Types',
    packingTypeListTotalPackingTypes: 'Total packing types',
    addNewSupplier: 'Add a new supplier',
    addSupplierItem: 'Add supplier item',
    addSupplierSubtitle: 'Add a supplier to this item',
    addSupplierTitle: 'Add supplier',
    back: 'Back',
    chooseFile: 'Choose a file',
    createNew: 'Create new',
    deleteConfirm: 'Are you sure you want to delete?',
    deleteSupplierTitle: 'Delete supplier',
    downloadTemplate: 'Download template',
    drawerTitle: 'Details',
    dropSub: 'or drag and drop it here',
    dropTitle: 'Drop your file here',
    editSupplierSubtitle: 'Edit this supplier link',
    editSupplierTitle: 'Edit supplier',
    err_invalidGoodType: 'Invalid good type',
    err_missingGoodType: 'Good type is required',
    err_missingName: 'Name is required',
    err_missingPrice: 'Price is required',
    err_missingUnit: 'Unit is required',
    errors: 'Errors',
    expectedFormat: 'Expected format',
    forTheAmountOf: 'for the amount of',
    formatDesc: 'The file must follow this format.',
    goodCategory: 'Category',
    height: 'Height',
    imageOptional: 'Image (optional)',
    importAnother: 'Import another file',
    importBtn: 'Import',
    importedOk: 'Import successful',
    importing: 'Importing…',
    invClear: 'Clear',
    inventoryInfo: 'Inventory information',
    itemIsPurchasedIn: 'This item is purchased in',
    itemIsStoredIn: 'This item is stored in',
    componentIsStoredIn: 'Component is stored in',
    kitchenCentral: 'Central Kitchen',
    kitchenLocal: 'Local Kitchen',
    kitchenType: 'Kitchen',
    length: 'Length',
    logiClear: 'Clear',
    mapColumns: 'Map columns',
    missingRequiredMapping: 'Some required columns are not mapped.',
    next: 'Next',
    noRows: 'No rows',
    numberOfUnits: 'Number of units',
    packedUnits: 'Packed units',
    packingInfo: 'Packing information',
    purchaseInfo: 'Purchase information',
    row: 'Row',
    rowsLabel: 'rows',
    sectionIdentity: 'Identity',
    selectAll: 'Select all',
    selectExisting: 'Select existing',
    selectUnit: 'Select a unit',
    srClear: 'Clear',
    stepFile: 'File',
    stepLabelFile: 'File',
    stepLabelMapping: 'Mapping',
    stepLabelResults: 'Results',
    stepMapping: 'Mapping',
    stepResults: 'Results',
    supplierConfigurations: 'Configurations',
    supplierContactName: 'Contact name',
    supplierCreateSubtitle: 'Create a new supplier',
    supplierEmail: 'Email',
    supplierPhone: 'Phone',
    supplierSectors: 'Sectors',
    supplierSpaces: 'Spaces',
    unselectAll: 'Unselect all',
    uploadPicture: 'Upload a picture',
    width: 'Width',
    epmAddShopsSpaceMenus: 'Add shops (Space Menus)',
    epmAssignmentMissing: 'No menu item is assigned to points of sale in this configuration. Predicted quantities are still displayed, but use remap to attach each item to the shop menu.',
    epmCostAbovePriceBadge: 'cost > price',
    epmCostAbovePriceTitle: 'Unit cost is higher than the sale price excl. tax — cost data is probably wrong',
    epmDisabledBadge: 'disabled',
    epmDisabledTitle: 'Item exists in this shop Space Menu but is disabled — not counted in revenue',
    epmGhostBadge: 'ghost — outside catalog',
    epmGhostTitle: 'Assignment row whose item does not exist in the catalog (assigned by mistake) — invisible in Space Menus, remove it here',
    epmGross: 'Gross',
    epmManualQtyWhy: 'Why a manual quantity?',
    epmNeverSold: 'Never sold here',
    epmNeverSoldHint: 'This point of sale has no past sales for this item — nothing to predict.',
    epmNoConfigShopsHint: 'Add shops to the configuration to prepare point-of-sale prediction.',
    epmNoConfigShopsTitle: 'No point of sale in this configuration.',
    epmOutsideMenuBadge: 'outside menu',
    epmOutsideMenuTitle: 'Item is outside this point-of-sale Space Menu — not counted in revenue',
    epmRemappedBadge: 'remapped',
    epmRemappedTitle: 'Attached to the shop menu by name matching',
    epmRemoveFromMenu: 'Remove from menu',
    epmRemoveFromMenuTitle: 'Remove this row from the shop menu (Space Menus)',
    epmShopSearchPlaceholder: 'Search an item...',
    epmShopTabNoSales: 'No predicted sales',
    epmShopTabNoSalesHint: "Items attached to this shop's menu, but with no predicted sales for this event.",
    epmShopTabSales: 'Predicted sales',
    epmShopTabSalesHint: "Items attached to this shop's menu with at least one predicted sale for this event.",
    epmShopTabUnmapped: 'Not attached to menu',
    epmShopTabUnmappedHint: "Predicted sales on items missing from this shop's Space Menu — attach them so they count toward the revenue adjustment.",
    epmUnmappedBadge: 'unmapped',
    epmUnmappedItemViewHint: 'Sales are predicted on these unattached items — worth including in the revenue adjustment',
    epmUnmappedTitle: 'Sold but missing from the assigned menu — attach it',
    epraActions: 'Actions',
    epraAddToMenu: 'Add to menu',
    epraReactivate: 'Reactivate in menu',
    epraRemap: 'Remap',
    epsdAttendance: 'Att',
    epsdCategory: 'Cat',
    epsdDay: 'Day',
    epsdExcluded: 'Excluded',
    epsdNoAlgoEvent: 'No event retained by the algorithm.',
    epsdNoOtherPastEvent: 'No other past event available.',
    epsdPerformer: 'Perf',
    epsdRecalculating: 'Recalculating…',
    epsdSaveRecalculate: 'Save and recalculate',
    epsdScale: 'Scale',
    epsdScore: 'Score',
    epsdSelectedByAlgo: 'Selected by algorithm',
    epsdSelectedPlural: 'events selected',
    epsdSelectedSingular: 'event selected',
    epsdSponsor: 'Spons',
    epsdSubcategory: 'Sub',
    epsdSubtitle: 'Choose past events used as the calculation base.',
    epsdTeam: 'Team',
    epsdTime: 'Time',
    epsdTitle: 'Events used for prediction',
    epsdType: 'Type',
    epsdUnselected: 'Unselected',
    epsdWeight: 'Weight',
    logiClose: 'Close',
    logiPackNotConfigured: 'Pack size not configured',
    logiSimulateAddLine: 'Add a line',
    logiSimulateAfter: 'After',
    logiSimulateAnother: 'Simulate another sale',
    logiSimulateBefore: 'Before',
    logiSimulateBtn: 'Simulate a sale',
    logiSimulateError: 'Unable to simulate this sale.',
    logiSimulateGo: 'Simulate',
    logiSimulateIntro: 'Creates a synthetic Weezevent transaction to test stock deduction, without waiting for a real sale.',
    logiSimulateItem: 'Item',
    logiSimulateMenuItem: 'Menu item',
    logiSimulateNoMenuItems: 'No menu item mapped to Weezevent for this shop — a sale cannot be simulated here.',
    logiSimulatePurge: 'Purge simulated sales for this shop',
    logiSimulatePurgeError: 'Unable to purge simulated sales.',
    logiSimulatePurged: 'Simulated sales purged.',
    logiSimulateShop: 'Shop',
    logiSimulateTitle: 'Simulate a sale (QA)',
    logiSimulateWarning: 'This simulated sale will also appear in revenue/analytics dashboards until purged.',
    epToolAnalyse: 'Analyse',
    epToolPredict: 'Predict',
    epToolEventPredict: 'Event Predict',
    epToolSpaceInventory: 'Space Inventory',
    epToolLogistic: 'Logistic',
    epToolRestock: 'Restock',
    edeDateTimeAt: 'at',
    epActivateThisVersion: 'Activate this version',
    epActive: 'Active',
    epAdjustmentsLoadingAria: 'Loading adjustments',
    epAlgoInfoMessage: 'The prediction weights past events by their similarity to the target event.',
    epAlgoInfoTitle: 'How the algorithm works',
    epAlgoSelectionTitle: 'Algorithm selection',
    epApply: 'Apply',
    epAssignReplaceLabel: 'Assign / replace with',
    epCalculatingAria: 'Calculating',
    epChooseUpcomingEventDate: 'Choose the upcoming event date',
    epCollapsePanel: 'Collapse panel',
    epConfigLabel: 'Configuration:',
    epConfigurationTab: 'Configuration',
    epDebugMode: 'Debug mode',
    epDetailedDataLoading: 'Loading detailed data…',
    epDialogDate: 'Date',
    epDisplayMode: 'Display mode',
    epDuplicate: 'Duplicate',
    epEmptyText: 'Select an event to start the prediction.',
    epEmptyTitle: 'No event selected',
    epEventFallbackName: 'Event',
    epEventWordPlural: 'events',
    epEventWordSingular: 'event',
    epGoToRestock: 'Go to restock',
    epHome: 'Home',
    epInventoryLink: 'Inventory',
    epLowConfidenceWarning: 'Low-confidence prediction',
    epManualQtyInfoMessage: 'Manually entered quantities override the prediction.',
    epManualQtyInfoTitle: 'Manual quantities',
    epMetricBasket: 'Basket',
    epMetricCost: 'Cost',
    epMetricMargin: 'Margin',
    epMetricTransformation: 'Conversion',
    epMultiDescPrefix: 'Aggregated prediction over',
    epMultiTip: 'Select several events to aggregate their prediction.',
    epMultiTitle: 'Multi-event',
    epNavToggle: 'Toggle navigation',
    epNextMonth: 'Next month',
    epNoEventAvailable: 'No event available',
    epNoTimelineData: 'No timeline data',
    epNotifications: 'Notifications',
    epOpenInventoryForEvent: 'Open inventory for this event',
    epOpenRestockForEvent: 'Open restock for this event',
    epPastEventPlural: 'past events',
    epPastEventSingular: 'past event',
    epPerCap: 'Per cap',
    epPosLabel: 'POS:',
    epPredictionBasedOn: 'Prediction based on',
    epPredictionSourcesDescription: 'Past events used to weight the prediction.',
    epPredictiveDataLoadingAria: 'Loading predictive data',
    epPreviousMonth: 'Previous month',
    epRealTimelineDesc: 'Actual revenue timeline for this past event.',
    epRealTimelineLoading: 'Loading timeline…',
    epRealTimelineTitle: 'Actual timeline',
    epReload: 'Reload',
    epRemapDialogTitle: 'Remap to the menu',
    epRename: 'Rename',
    epRestockReadyText: 'The restock is ready to generate.',
    epRestockReadyTitle: 'Restock ready',
    epRevenueHt: 'Revenue (ex-tax)',
    epSavedVersions: 'Saved versions',
    epScoringLoading: 'Scoring…',
    epScoringLoadingAria: 'Scoring past events',
    epSectionsAria: 'Sections',
    epSettings: 'Settings',
    epShareLinkCopy: 'Copy link',
    epShopBackendMissing: 'Shop not found on the backend.',
    epShowPanel: 'Show panel',
    epSignOut: 'Sign out',
    epSoldItemLabel: 'Sold item:',
    epSources: 'Sources',
    epSpaceInventory: 'Space inventory',
    epSpaceLabel: 'Space:',
    epStockTab: 'Stock up',
    epSummary: 'Summary',
    epTenantLabel: 'Tenant:',
    epTickets: 'Tickets',
    epTimeLabel: 'Time',
    epTimeRange: 'Time range',
    epTimeline: 'Timeline',
    epTimelineAlignmentUnavailableText: 'Timeline alignment is unavailable for this selection.',
    epTimelineAlignmentUnavailableTitle: 'Alignment unavailable',
    epTimelineCalcAria: 'Computing timeline',
    epTimelineCalcErrorText: 'An error occurred while computing the timeline.',
    epTimelineCalcErrorTitle: 'Timeline error',
    epTimelineFallbackNoSales: 'No sales data for the timeline.',
    epTimelineNoComparable: 'No comparable event for the timeline.',
    epTimelineNoUsableSales: 'No usable sales for the timeline.',
    epTimelineUnavailableTitle: 'Timeline unavailable',
    epTip: 'Tip',
    epTools: 'Tools',
    epToolsNavigation: 'Tools navigation',
    epTotalRevenueHt: 'Total revenue (ex-tax)',
    epUnsavedClickSaveTitle: 'Unsaved changes — click Save as',
    epUpcomingEventPlural: 'upcoming events',
    epUpcomingEventSingular: 'upcoming event',
    epUpdate: 'Update',
    epVersion: 'Version',
    epViewModeItem: 'By item',
    epViewModeShop: 'By shop',
    epWaitingSpaceMenuAria: 'Waiting for the space menu',
    edeAdd: 'Add',
    edeCancel: 'Cancel',
    edeCreate: 'Create',
    edeCreateTeam: 'Create a new team',
    edeCreateTeamTitle: 'Create a team',
    edeCreateTeamError: 'Unable to create the team',
    edeTeamName: 'Team name',
    edeCategory: 'Category',
    edeConfigUndefined: 'Configuration not set',
    edeConfiguration: 'Configuration',
    edeDatesTimes: 'Dates and times',
    edeDoorsOpening: 'Doors opening',
    edeDrawerSubtitle: 'Full information',
    edeDrawerTitle: 'Event detail',
    edeEndDate: 'End date',
    edeEndTime: 'End time',
    edeEventName: 'Event name',
    edeEventType: 'Event type',
    edeGeneralInfo: 'General information',
    edeHomeTeam: 'Home team',
    edeNone: 'None',
    edeNotSaved: 'Not saved',
    edeRemoveSession: 'Remove session',
    edeSave: 'Save',
    edeSaving: 'Saving…',
    edeScanned: 'scanned',
    edeSearchTeam: 'Search a team',
    edeSelectCategory: 'Select a category',
    edeSelectConfig: 'Select a configuration',
    edeSelectEvent: 'Select an event',
    edeSelectSubcategory: 'Select a subcategory',
    edeSelectType: 'Select a type',
    edeSession: 'Session',
    edeSessions: 'Sessions',
    edeShowStart: 'Show start',
    edeStartDate: 'Start date',
    edeSubcategory: 'Subcategory',
    edeTaxonomy: 'Taxonomy',
    edeTeams: 'Teams',
    edeTicketing: 'Ticketing',
    edeTicketsErrorA: 'Scanned tickets (',
    edeTicketsErrorB: ') cannot exceed sold tickets (',
    edeTicketsErrorC: ').',
    edeTicketsScanned: 'Tickets scanned',
    edeTicketsSold: 'Tickets sold',
    edeUnnamedEvent: 'Unnamed event',
    edeViewDetail: 'View detail',
    edeVisitingTeam: 'Visiting team',
    epNoUpcomingEvent: 'No upcoming event',
    epNotSaved: 'Not saved',
    epNotSavedTitle: 'Unsaved changes on this page',
    epSaveAs: 'Save as',
    epSaveAsTitle: 'Save as a new version',
    epSelectEventPlaceholder: 'Select an event to predict…',
    epTicketsScannedLabel: 'Tickets scanned:',
    epSubtitle: 'Predictive analysis for upcoming events — weighted scoring on past events',
    epBannerSubtitle: 'Predictive view',
    epActiveVersion: 'Active version',
    epActiveVersionTitle: 'Active version',
    epUnnamed: 'unnamed',
    epDraftUnsaved: 'Draft · Unsaved',
    epSaveHintFr: '"Save" freezes the adjusted quantities into a version.',
    epSaveHintEn: '"Save as" stores a snapshot of the adjusted quantities.',
    epReset: 'Reset',
    epResetTitle: 'Reset adjustments',
    epSave: 'Save',
    epSaveTitle: 'Save as a new version',

    // sr — SpaceRestockView
    srBack: 'Back',
    srTitle: 'Restock',
    srObjectiveSalesPrefix: 'Objective: sales from',
    srEventSingular: 'event',
    srEventPlural: 'events',
    srSourceInventoryPrefix: 'Source inventory:',
    srLastSnapshot: 'Last snapshot',
    srSettings: 'Settings',
    srShoppingList: 'Shopping list',
    srToolboxNavLabel: 'Tools navigation',
    srOverviewLabel: 'Restock summary',
    srLoadingLabel: 'Loading restock',
    srEvents: 'Events',
    srPredictedSingular: 'predicted',
    srPredictedPlural: 'predicted',
    srReferenceEventChip: 'Ref. event',
    srSelectedSingular: 'selected',
    srSelectedPlural: 'selected',
    srObjectiveSourceLabel: 'Objective source',
    srForecast: 'Forecast',
    srSalesRefEvent: 'Sales (ref. event)',
    srReferenceEventPlaceholder: 'Reference event',
    srReferenceSalesDegraded: 'Sales detail unavailable for this event — objective computed in degraded mode.',
    srNoPastEvent: 'No past event available as reference.',
    srObjectiveSalesHint: 'Objective based on the sales of this past event. Future event selection is hidden in this mode.',
    srObjectiveSalesHintShort: 'Objective based on the sales of this past event.',
    srGenerateRestock: 'Generate restock',
    srItemsToStock: 'Items to stock',
    srItemsToStockDesc: 'Stock needed per item (predicted → target). The slider adjusts the need; 100% = prediction.',
    srItemSingular: 'item',
    srItemPlural: 'items',
    srFilterItems: 'Filter items',
    srReset: 'Reset',
    srIncludeItem: 'Include this item in the restock',
    srSelectAll: 'Select all',
    srDeselectAll: 'Deselect all',
    srPacked: 'Packed',
    srUsedIn: 'Used in:',
    srSelectEventsEmpty: 'Select one or more events in the calendar.',
    srNoStockNeed: 'No stock need calculated for the selection.',
    srShopSingular: 'shop',
    srShopPlural: 'shops',
    srTargetLabel: 'target',
    srPredictedLabel: 'predicted',
    srScenarioRevenue: 'Predicted revenue (excl. VAT)',
    srScenarioUnits: 'units',
    srAdjustNeedLabel: 'Adjust the need',
    srTargetPresets: 'Target',
    srCompositeDishes: 'Dish composition',
    srCompositeDishesHint: 'Recipes detected in this selection. Quantities follow each component adjustment.',
    srCompositionLabel: 'Composition',
    srComponentSingular: 'component',
    srComponentPlural: 'components',
    srRestockTable: 'Restock table',
    srRestockTableDesc: 'Difference between the stock target and the saved remaining inventory.',
    srToDeposit: 'to deposit',
    srConfirmed: 'confirmed',
    srNotGenerated: 'Not generated',
    srFilterShopItem: 'Filter shop / item',
    srByShop: 'By shop',
    srByItem: 'By item',
    srGenerateRestockHint: 'Click "Generate restock" to freeze the table.',
    srNoElementToDeposit: 'No element to deposit.',
    srConfirmAll: 'Confirm all',
    srUncheckAll: 'Uncheck all',
    srConfirmRow: 'Confirm',
    srConfirmedRow: 'Confirmed',
    srUndoConfirmRow: 'Cancel confirmation',
    srExportCsv: 'Export CSV',
    srColItem: 'Item',
    srColTarget: 'Target',
    srColRemaining: 'Remaining',
    srColToDeposit: 'To deposit',
    srColConfirmed: 'Confirmed',
    srColShop: 'Shop',
    srShoppingListDesc: 'Purchases consolidated and ordered by supplier.',
    srSupplierSingular: 'supplier',
    srSupplierPlural: 'suppliers',
    srArticleSingular: 'item',
    srArticlePlural: 'items',
    srSuppliersPreviewTitle: 'Suppliers',
    srSuppliersPreviewHint: 'Generate the shopping list to preview suppliers.',
    srSuppliersPreviewEmpty: 'No supplier.',
    srSuppliersUnits: 'units',
    srSuppliersEmailBtn: 'Email order',
    srSuppliersEmailDialogTitle: 'Order email',
    srSuppliersEmailTo: 'Recipient',
    srSuppliersEmailSubject: 'Subject',
    srSuppliersEmailBody: 'Message',
    srSuppliersEmailSend: 'Send',
    srSuppliersEmailCancel: 'Cancel',
    srSuppliersEmailBold: 'Bold',
    srSuppliersEmailItalic: 'Italic',
    srSuppliersEmailUnderline: 'Underline',
    srSuppliersEmailBullets: 'Bulleted list',
    srNotGeneratedFem: 'Not generated',
    srFilterSupplierItem: 'Filter supplier / item',
    srPrint: 'Print',
    srGenerateShoppingHint: 'Click "Shopping list" to generate the purchase list.',
    srNoPurchaseNeeded: 'No purchase needed for the generated rows.',
    srShoppingModeFinished: 'Finished products',
    srShoppingModeIngredients: 'Ingredients',
    srShoppingIngredientsHint: 'Raw materials to produce/buy in the central kitchen — every dish is broken down into ingredients, regardless of "Ready for Sale".',
    srFinishedProductsGroup: 'Finished products',
    srRecipesLoading: 'Loading recipes…',
    srNoIngredientNeeded: 'No ingredient to produce for the predicted sales.',
    srEmail: 'Email',
    srCall: 'Call',
    srSupplierPhoneMissingTitle: 'Supplier phone not provided',
    srColQuantityToBuy: 'Quantity to buy',
    srColToBuyShort: 'To buy',
    srColShops: 'Shops',
    srDiagPredicted: 'Predicted',
    srDiagShop: 'in shop',
    srDiagStorage: 'storage',
    srDiagRestock: 'restock',
    srDiagBuy: 'buy',
    srStorageUnmatchedWarn: 'Storage stock present but not matched to any predicted item:',
    srPosShort: 'POS',
    srSettingsSheetTitle: 'Restock settings',
    srToolsLabel: 'Tools',
    srToolAnalyse: 'Analyse',
    srToolPredict: 'Predict',
    srToolEventPredict: 'Event Predict',
    srToolSpaceInventory: 'Space Inventory',
    srToolLogistic: 'Logistic',
    srToolRestock: 'Restock',
    srMetricEvents: 'Events',
    srMetricStockItems: 'Stock items',
    srMetricShopsToDeliver: 'Shops to deliver',
    srMetricConfirmed: 'Confirmed',
    srCannotGenSalesNoRef: 'Select a reference event (past) in the settings.',
    srCannotGenForecastNoEvent: 'No future event to forecast. Choose a target event, or switch to "Ref. event" (settings).',
    srCannotGenSalesNoSales: 'No sales found for the reference event (unavailable in demo mode).',
    srCannotGenForecastNoForecast: 'No forecast available for the selected event.',
    srCannotGenGeneric: 'Objective or theoretical need unavailable.',
    srSnackRestockGenerated: 'Restock table generated.',
    srSnackShoppingGenerated: 'Shopping list generated.',
    srSnackLoadError: 'Error loading restock',
    srSnackEmailMissing: 'Supplier email not provided — add the recipient in your mail client.',
    srSnackEmailBodyCopied: 'Order list too long for email — copied to clipboard, paste it into the email body.',
    srSnackEmailTooLong: 'Order list too long for email — use Print or Export to send it.',
    srSnackPhoneMissing: 'Supplier phone not provided.',
    srSnackPrintBlocked: 'Printing blocked by the browser (pop-up). Allow pop-ups.',
    srSnackPredictionDegraded: 'Per-item forecast quantities unavailable — reopen EventPredict to refresh them.',
    srSnackCatalogDegraded: 'Incomplete product catalog for this space: forecast quantities show, but recipes, packaging and shopping list are degraded. Data fix in progress.',
    srExportGeneratedPrefix: 'Export',
    srExportGeneratedSuffix: 'generated.',
    srSyntheticConfigName: 'Reconstructed config',
    srEventFallback: 'Event',
    srSupplierUndefined: 'Undefined supplier',
    srEmailSubjectPrefix: 'Restock order -',
    srEmailGreeting: 'Hello',
    srEmailIntroPrefix: 'We would like to place the following restock order for',
    srEmailItemsHeading: 'Items to deliver:',
    srEmailClosingRequest: 'Please confirm availability, delivery time and the corresponding amount.',
    srEmailSignOff: 'Kind regards,',
    srPrintColArticle: 'Item',
    srPrintColQuantityToBuy: 'Quantity to buy',
    srPrintColPos: 'POS',
    srPrintListTitle: 'Shopping list',
    srCsvShop: 'Shop',
    srCsvItem: 'Item',
    srCsvTarget: 'Target',
    srCsvRemaining: 'Remaining',
    srCsvToDeposit: 'To_deposit',
    srCsvUnit: 'Unit',
    srCsvConfirmed: 'Confirmed',
    srCsvEvents: 'Events',
    srCsvYes: 'Yes',
    srCsvNo: 'No',
    srCsvSupplier: 'Supplier',
    srCsvQuantity: 'Quantity',
    // sr — wizard
    srStep1: 'Items to stock',
    srStep2: 'Restock',
    srStep3: 'Shopping list',
    srPrevious: 'Previous',
    srStepOf: 'Step',
    // inv — counted shops summary (mirrors invAggTodoTitle / Shops to count)
    invAggCountedTitle: 'Counted shops',
    // inv — left filter panel (Analyse-style groups for Space Inventory)
    invFilterMenuItems: 'Menu items',
    invFilterTypeCategory: 'Type & Category',
    invFilterItemType: 'Type',
    invFilterCategory: 'Category',
    invFilterSearchMenuItem: 'Search a menu item',
    invFilterNoOptions: 'No options',
    invAll: 'All',
    invNone: 'None',
    invSearchShop: 'Search a shop',

    // 3D Builder (builder2)
    b2ToastElementChangedElsewhere: 'Element changed elsewhere — reloading state.',
    b2ToastSaveElementFailed: 'Failed to save the element',
    b2ToastCreateElementFailed: 'Failed to create the element',
    b2ToastDuplicateFailed: 'Failed to duplicate',
    b2ToastLastConfigForElement: 'Last configuration for this element — delete the element instead.',
    b2ToastUpdateConfigsFailed: 'Failed to update configurations',
    b2ToastCreateZoneFailed: 'Failed to create the zone',
    b2ToastSaveZoneFailed: 'Failed to save the zone',
    b2ToastDuplicateZoneFailed: 'Failed to duplicate the zone',
    b2ErrorApiUnavailable: 'Builder v2 API unavailable (endpoints to deploy — doc REFONTE_3D_BUILDER_V2 §3).',
    b2ErrorLoadingGeneric: 'Loading error',
    b2ZoneKindForecourt: 'Forecourt',
    b2ZoneKindExternal: 'External area',
    b2ZoneKindGroundFloor: 'Ground floor',
    b2ZoneKindBasement: 'Basement',
    b2ZoneKindFloor: 'Floor',
    b2ErrorLoadTitle: 'Unable to load the builder',
    b2Retry: 'Retry',
    b2EmptyConfigsTitle: 'No configuration',
    b2EmptyConfigsBody: 'Create your first configuration to draw the plan for this space.',
    b2CreateConfigCta: 'Create a configuration',
    b2ToastCreateFailedGeneric: 'Creation failed',
    b2SpaceFallback: 'Space',
    b2ChangeSpace: 'Change space',
    b2UndoTitle: 'Undo (Ctrl+Z)',
    b2RedoTitle: 'Redo (Ctrl+Y)',
    b2CloneConfigTitle: 'Clone configuration',
    b2NewConfigTitle: 'New configuration',
    b2CloneConfigBody: 'The same elements will be visible in the copy (membership copy, instant).',
    b2NameLabel: 'Name',
    b2Clone: 'Clone',
    b2RenameConfigTitle: 'Rename configuration',
    b2Rename: 'Rename',
    b2Saving: 'Saving…',
    b2Offline: 'Offline',
    b2Pending: 'pending',
    b2SaveError: 'Save error',
    b2Saved: 'Saved',
    b2SavedAgo: 'Saved · {duration} ago',
    b2ToastCreateConfigFailed: 'Failed to create the configuration',
    b2ToastRenameFailed: 'Failed to rename',
    b2CopySuffix: '(copy)',
    b2ConfigPlaceholder: 'Configuration',
    b2AreasTitle: 'Areas',
    b2NoZonesEmpty: 'No zone yet — add a floor to get started.',
    b2ElementWord: 'element',
    b2ElementsWord: 'elements',
    b2ElementAbbrev: 'el.',
    b2InThisConfig: 'in this config',
    b2ElementPaletteTitle: 'Element Palette',
    b2ExistingElementsSuffix: 'existing elements',
    b2AllZones: 'All',
    b2NoElementsInZone: 'No element of this category in this zone.',
    b2NoElementsCategory: 'No element of this category.',
    b2NoElementSelected: 'No element selected',
    b2SelectElementHint: 'Click an element on the plan, or choose a tool in the palette.',
    b2Duplicate: 'Duplicate',
    b2PropertiesTitle: 'Properties',
    b2IdentityTitle: 'Identity',
    b2ChangeImage: 'Change',
    b2Image: 'Image',
    b2RemoveImage: 'Remove',
    b2GeometryTitle: 'Geometry',
    b2PositionTitle: 'Position',
    b2CornerRadius: 'Corner Radius',
    b2FloorArea: 'Floor Area',
    b2Volume: 'Volume',
    b2AxisX: 'X',
    b2AxisY: 'Y',
    b2Width: 'Width',
    b2Depth: 'Depth',
    b2Height: 'Height',
    b2Rotation: 'Rotation',
    b2RoundedCorners: 'Rounded corners',
    b2CornersLinked: 'Linked corners',
    b2CornersIndependent: 'Independent corners',
    b2CornerTopLeft: 'Top L',
    b2CornerTopRight: 'Top R',
    b2CornerBottomLeft: 'Bottom L',
    b2CornerBottomRight: 'Bottom R',
    b2ConfigsTitle: 'Configurations',
    b2ConfigsVisibleIn: 'Configurations in which this element is visible.',
    b2Active: 'active',
    b2ConfigsLastOneHint: 'An element always belongs to at least one configuration — to remove it from the last one, delete the element.',
    b2UsageTitle: 'Usage',
    b2WeezeventMapped: 'Mapped to Weezevent',
    b2WeezeventNotMapped: 'Not mapped to Weezevent',
    b2MenuItems: 'menu item(s)',
    b2InOtherConfigs: 'in other configs',
    b2ManageInSpaceMenu: 'Manage in Space Menu',
    b2UsageLinksHint: 'These links are preserved as long as the element exists — deleting it will require explicit confirmation.',
    b2PerformanceTitle: 'Performance',
    b2Revenue: 'Total revenue (€)',
    b2ElpRevenue: 'Revenue',
    b2SortByFloor: 'By Floor',
    b2SortByType: 'By Type',
    b2ElpItems: 'items',
    b2ElpSearchPlaceholder: 'Search...',
    b2NumberOfPOS: 'Number of POS',
    b2NumberOfTransactions: 'Total transactions',
    b2TransactionsPerMinute: 'Trans./min',
    b2StaffCost: 'Staff cost (€)',
    b2RevenuePerEmployee: 'Revenue/employee (€)',
    b2ToastSavePerformanceFailed: 'Failed to save performance data',
    b2MenuTitle: 'Menu',
    b2SearchMenuItemsPlaceholder: 'Search menu items...',
    b2NoResultsFor: 'No results for "{query}".',
    b2MenuUnavailable: 'Menu unavailable for this shop ({error}).',
    b2NoMenuItemsAssigned: 'No menu item assigned to this shop.',
    b2ManageMenuInSpaceMenu: 'Manage the menu in Space Menu',
    b2InventoryTitle: 'Inventory',
    b2SearchInventoryPlaceholder: 'Search inventory items...',
    b2InventoryItemsLabel: 'Inventory items',
    b2Component: 'Component',
    b2Packaging: 'Packaging',
    b2UsedIn: 'Used in',
    b2MenuInventoryUnavailable: 'Menu inventory unavailable ({error}).',
    b2NoMenuItemsInventoryHint: 'No menu item enabled on this shop — inventory is derived from the menu.',
    b2CustomItems: 'Custom items',
    b2Remove: 'Remove',
    b2AddCustomItemPlaceholder: 'Add custom item...',
    b2ToastSaveInventoryFailed: 'Failed to save inventory',
    b2StorageWord: 'storage',
    b2SoldIn: 'Sold in',
    b2AlertBelow: 'alert ≤',
    b2InventoryUnavailable: 'Inventory unavailable ({error}).',
    b2NoStockableShops: 'No F&B or Merch shop in this configuration — select shops in the Shops section.',
    b2NoMenuItemsInventoryHintPlural: 'No menu item enabled on the selected shops — inventory is derived from their menus.',
    b2NoItemsMatchStorageTypes: 'No item matches the checked storage types.',
    b2ItemsFromFB: 'Items from F&B Elements',
    b2ItemsFromMerch: 'Items from Merch Elements',
    b2ShopsTitle: 'Shops',
    b2NoFbMerchElements: 'No F&B or Merch element in this configuration.',
    b2SelectFbMerchHint: 'Select F&B / Merch elements that use this storage ({count} available)',
    b2ThisStorage: 'This Storage',
    b2Unassigned: 'Unassigned',
    b2SubtypesPrefix: 'Subtypes',
    b2WeezeventMappedWithLocation: 'Mapped to Weezevent: {location}',
    b2MenuItemsAssignedTitle: '{count} menu item(s) assigned in this configuration',
    b2StaffTitle: 'Staff',
    b2PositionPlaceholder: 'e.g., Cashier, Cook, Security',
    b2Add: 'Add',
    b2NoStaffYet: 'No staff positions yet. Add one above.',
    b2ToastSaveStaffFailed: 'Failed to save staff',
    b2SelectZoneToShowPlan: 'Select a zone to show the plan',
    b2ClickToEditDimensions: 'Click to edit dimensions',
    b2DrawingLabel: 'Drawing:',
    b2RotateElementTitle: 'Rotate element 15°',
    b2EditCornerRadiusTitle: 'Edit corner radius',
    b2ViewPropertiesTitle: 'View properties',
    b2ExitFullscreen: 'Exit fullscreen',
    b2EnterFullscreen: 'Enter fullscreen',
    b2ApplySameRadiusAllCorners: 'Apply same radius to all corners',
    b2CornerRadiusM: 'Corner Radius (m)',
    b2CornerTopLeftFull: 'Top Left (m)',
    b2CornerTopRightFull: 'Top Right (m)',
    b2CornerBottomLeftFull: 'Bottom Left (m)',
    b2CornerBottomRightFull: 'Bottom Right (m)',
    b2IsoTitle: '3D view of the space',
    b2DeleteEntityTitle: 'Delete "{name}"?',
    b2OrphanWarning: '{count} element(s) will no longer belong to any configuration:',
    b2ShopWeezeventLabel: 'Weezevent shop',
    b2ReassignToOtherConfig: 'Reassign them to another configuration',
    b2DeleteAlsoDefinitive: 'Delete them too (final)',
    b2DeleteConfigNoOrphansHint: 'Elements visible in this configuration remain available in their other configurations. This action is final.',
    b2ToastDeleteConfigFailed: 'Failed to delete the configuration',
    b2ElementIsUsed: 'This element is used:',
    b2WeezeventMappingLabel: 'Weezevent mapping',
    b2MenuItemsAssignedCount: '{count} menu item(s) assigned',
    b2DeleteElementLinksHint: 'Deleting the element will also delete these links. This action is final.',
    b2DeleteElementNoRefsHint: 'This element is not referenced anywhere. This action is final.',
    b2DeleteAnyway: 'Delete anyway',
    b2ElementReferencedFallback: 'Element referenced',
    b2ToastDeleteFailed: 'Deletion failed',
    b2ZoneContainsLinkedElements: 'This zone contains {count} element(s), including {linkedCount} linked:',
    b2ZoneHiddenElementsWillDelete: '{count} element(s) of this zone are not visible in the active configuration — they will be deleted too.',
    b2DeleteZoneLinkedHint: 'Deleting the zone will delete these elements and unlink their Weezevent shops and menus. Weezevent locations will become unmapped again (re-mappable in Data Integration). This action is final.',
    b2ZoneContainsElementsWillDelete: 'This zone contains {count} element(s) that will be deleted with it.',
    b2ZoneHiddenCountParenthetical: '({count} not visible in the active configuration.)',
    b2ActionIsFinal: 'This action is final.',
    b2ZoneEmptyHint: 'This zone is empty. This action is final.',
    b2UnlinkAndDelete: 'Unlink and delete',
    b2ZoneNotDeletedUsedElements: 'Zone not deleted: it contains elements in use',
    b2ToastDeleteZoneFailed: 'Failed to delete the zone',
    b2EditZoneTitle: 'Edit Zone',
    b2EditZoneSubtitle: 'Update name and dimensions',
    b2ZoneNamePlaceholder: 'Zone name…',
    b2DimensionsLabel: 'Dimensions',
    b2WidthM: 'Width (m)',
    b2LengthM: 'Length (m)',
    b2HeightM: 'Height (m)',
    b2AllCorners: 'All corners',
    b2CornerTopLeftPlain: 'Top Left',
    b2CornerTopRightPlain: 'Top Right',
    b2CornerBottomLeftPlain: 'Bottom Left',
    b2CornerBottomRightPlain: 'Bottom Right',
    b2CreateHoleLabel: 'Create hole in floor (doughnut shape)',
    b2HoleWidthM: 'Hole Width (m)',
    b2HoleLengthM: 'Hole Length (m)',
    b2XPositionRange: 'X Position (0–1)',
    b2YPositionRange: 'Y Position (0–1)',
    b2HoleCornerRadiusLabel: 'Hole Corner Radius',
    b2DragHoleHint: 'Drag the hole in the floor plan view to reposition it.',
    // === Integration (auto-i18n) ===
    intgShopsStep2: 'Step 2',
    intgShopsUnmappedBulkHint: 'unmapped location(s) — create and map DataFriday shops in bulk.',
    intgShopsBulkCreateMap: 'Bulk create & map',
    intgShopsBulkProgressPrefix: 'Bulk creating & mapping',
    intgShopsBulkProgressSuffix: 'location(s)…',
    intgShopsSearchPlaceholder: 'Search for a location…',
    intgShopsTabAll: 'All',
    intgShopsTabMapped: 'Mapped',
    intgShopsTabUnmapped: 'Unmapped',
    intgShopsStatus: 'Status',
    intgShopsNoLocationFound: 'No location found',
    intgShopsValidateSuggestion: 'Accept this suggestion',
    intgShopsIgnore: 'Ignore',
    intgShopsCreateShopFor: 'Create a shop for',
    intgShopsSaveError: 'Save error',
    intgShopsAssignFloor: 'Assign a floor',
    intgShopsUnmappedWarnLabel: 'unmapped location(s)',
    intgShopsUnmappedWarnHint: 'All locations must be associated with a shop before continuing.',
    intgShopsStepConfig: 'Config',
    intgShopsStepZone: 'Zone',
    intgShopsStepPosition: 'Position',
    intgShopsConfiguration: 'Configuration',
    intgShopsLoading: 'Loading…',
    intgShopsChange: 'Change',
    intgShopsSelectConfig: 'Select a configuration…',
    intgShopsNoConfigAvailable: 'No configuration available',
    intgShopsAddNewConfig: '+ Add a new configuration',
    intgShopsZoneFloor: 'Zone / Floor',
    intgShopsGroundFloorShort: 'GF',
    intgShopsElementsShort: 'elem.',
    intgShopsExternalAreaShort: 'Ext. Area',
    intgShopsNewFloor: 'New Floor',
    intgShopsNew: 'New',
    intgShopsNewBasement: 'New Basement',
    intgShopsAdd: 'Add',
    intgShopsAZone: 'a zone',
    intgShopsNoFloorInConfig: 'No floor in this configuration — use the "Add" button above',
    intgShopsZoneName: 'Zone name',
    intgShopsZoneNamePlaceholder: 'e.g. GF, North Stand, Boxes…',
    intgShopsZoneDimensions: 'Zone dimensions',
    intgShopsWidthM: 'Width (m)',
    intgShopsLengthM: 'Length (m)',
    intgShopsHeightM: 'Height (m)',
    intgShopsDepthM: 'Depth (m)',
    intgShopsPositionOnPlan: 'Position on the plan',
    intgShopsDragHint: 'Click or drag to position',
    intgShopsShopDimensions: 'Shop dimensions',
    intgShopsApplyToLocations: 'Also apply to these locations',
    intgShopsCancel: 'Cancel',
    intgShopsApply: 'Apply',
    intgShopsBulkMappingTitle: 'Bulk mapping',
    intgShopsUnmappedLocations: 'unmapped location(s)',
    intgShopsMatchedNamePrefix: 'location(s) share the same name as an existing shop:',
    intgShopsMatchedNameMid: 'they will simply be',
    intgShopsMapped: 'mapped',
    intgShopsMatchedNameSuffix: ', nothing will be created for them.',
    intgShopsNoNameMatch: 'No location matches an existing shop by name.',
    intgShopsCreateMissingPrefix: 'Create the',
    intgShopsCreateMissingSuffix: 'missing shop(s) in the 3D Builder',
    intgShopsGridHint: '2×2 m elements laid out on a grid on the ground floor',
    intgShopsOfConfig: 'of the configuration',
    intgShopsBulkNotePrefix: 'These',
    intgShopsBulkNoteSuffix: 'location(s) will remain unmapped — no 3D element will be created.',
    intgShopsConfigRequired: 'Configuration required',
    intgShopsNoConfigForSpace: 'No configuration attached to this space',
    intgShopsCreateConfigInfo: 'Create a configuration before adding shops. It will be used to position the shops in the 3D Builder.',
    intgShopsConfigName: 'Configuration name',
    intgShopsConfigNamePlaceholder: 'e.g. Main configuration',
    intgShopsGroundFloorLong: 'Ground floor (GF)',
    intgShopsGroundFloorName: 'Ground floor name',
    intgShopsGroundFloorNamePlaceholder: 'e.g. GF, Main hall…',
    intgShopsSkip: 'Skip',
    intgShopsCreateConfig: 'Create the configuration',
    intgShopsCreateShopTitle: 'Create a DataFriday shop',
    intgShopsShopName: 'Shop name',
    intgShopsShopNamePlaceholder: 'e.g. Main Bar, Entrance Merch…',
    intgShopsType: 'Type',
    intgShopsFloorZone: 'Floor / Zone',
    intgShopsSelectFloor: 'Select a floor…',
    intgShopsCreateAndMap: 'Create and map',
    intgShopsCreateWord: 'Create',
    intgShopsAndMapWord: 'and map',
    intgShopsMapWord: 'Map',
    intgShopsLocationsWord: 'location(s)',
    intgShopsBasementWord: 'Basement',
    intgShopsFloorWord: 'Floor',
    intgShopsExternalAreaLong: 'External Area',
    intgShopsNewLower: 'new',
    intgShopsAddZone: 'Add a zone',
    intgShopsMappingFailedSuffix: 'location(s) could not be mapped.',
    intgShopsSelectConfigBeforeAssign: 'Select a configuration before assigning the shops.',
    smmHeaderTitle: 'Map menu products',
    smmHeaderStep: '— Step 3',
    smmHeaderSub: 'Map each Weezevent product to an item in your DataFriday menu.',
    smmMapped: 'mapped',
    smmEmptyProducts: 'No product found for this integration.',
    smmAutoMappingOf: 'Automatic mapping of',
    smmSuggestion: 'suggestion',
    smmSuggestionsPlural: 'suggestions',
    smmSuggestionAvailable: 'automatic suggestion available',
    smmSuggestionsAvailablePlural: 'automatic suggestions available',
    smmView: 'View',
    smmMappingProgress: 'Mapping…',
    smmAutoMapAll: 'Auto-map all',
    smmProduct: 'product',
    smmProductsPlural: 'products',
    smmWithoutMapping: 'without mapping',
    smmItem: 'item',
    smmItemsPlural: 'items',
    smmWithoutSpace: 'without Space',
    smmCreateAndAttach: '— create and attach automatically',
    smmItemAlreadyMapped: 'item already mapped without an associated Space',
    smmItemsAlreadyMappedPlural: 'items already mapped without an associated Space',
    smmWithoutSpaceAttach: '— attach automatically',
    smmCreateAndMapAll: 'Create and map all',
    smmItemMappedPrice: 'mapped item whose DataFriday price differs from the Weezevent price',
    smmItemsMappedPricePlural: 'mapped items whose DataFriday price differs from the Weezevent price',
    smmApplyingProgress: 'Applying…',
    smmApplyWeezeventPrices: 'Apply Weezevent prices',
    smmTabAll: 'All',
    smmTabMapped: 'Mapped',
    smmTabUnmapped: 'Unmapped',
    smmHideUnsoldTitle: 'Hide catalog products that were never sold (no price).',
    smmHiddenSuffix: 'hidden.',
    smmHideUnsold: 'Hide without sales',
    smmColProduct: 'Product (Weezevent)',
    smmColMenuItem: 'Menu Item',
    smmColMatch: 'Match',
    smmNoProductFound: 'No product found',
    smmHtTag: 'excl. tax',
    smmTtcTag: 'incl. tax',
    smmSelectOption: 'Select…',
    smmPricelineDfTitle: 'Current DataFriday price of the item (excl. tax; incl. tax shown alongside)',
    smmPriceInSpace: 'Price in this space:',
    smmApplyWeezeventPricePrefix: 'Apply the Weezevent price',
    smmApplyWeezeventPriceSuffix: 'to the item',
    smmApply: 'Apply',
    smmPriceApplied: 'Price applied',
    smmUpToDate: 'up to date',
    smmPriceHistoryTitle: 'Item price history',
    smmAcceptSuggestion: 'Accept this suggestion',
    smmIgnore: 'Ignore',
    smmCreateMenuItemForPrefix: 'Create menu item for',
    smmSaveError: 'Save error',
    smmPaginationOf: 'of',
    smmPrevious: 'Previous',
    smmPage: 'Page',
    smmNext: 'Next',
    smmUnmappedProductsWarn: 'unmapped product(s)',
    smmAllMustBeMapped: '— All products must be linked to a menu item before continuing.',
    smmLoadingCategories: 'Loading categories…',
    smmCreateProductType: 'Create a product type',
    smmTypeName: 'Type name',
    smmCancel: 'Cancel',
    smmCreate: 'Create',
    smmCreateCategory: 'Create a category',
    smmLinkedToType: 'Linked to type',
    smmCategoryName: 'Category name',
    smmBulkTitle: 'Automatic creation',
    smmBulkSub: 'Bulk creation & mapping of products',
    smmPhasePatchingTitle: 'Attaching to Space…',
    smmPhaseSyncTitle: 'Updating the catalog…',
    smmPhasePreparingTitle: 'Preparing categories…',
    smmPhaseCreatingTitle: 'Creating menu items…',
    smmPhaseDoneTitle: 'Operation completed',
    smmPhaseInterruptedTitle: 'Operation interrupted',
    smmPhasePatchingSub: 'Linking existing items to the current Space…',
    smmPhaseSyncSub: 'Enriching product data in progress…',
    smmPhasePreparingSub: 'Checking and creating DataFriday types & categories',
    smmProductsProcessed: 'products processed',
    smmProductsFailed: 'product(s) failed',
    smmClose: 'Close',
    smmAutoSuggestionsTitle: 'Automatic suggestions',
    smmMatch: 'match',
    smmMatchesPlural: 'matches',
    smmClickApplyHint: '— click Apply to confirm one by one',
    smmNoSuggestionAvailable: 'No suggestion available.',
    smmApplyAll: 'Apply all',
    smmPriceHistoryDialogTitle: 'Price history',
    smmLoadingHistory: 'Loading history…',
    smmNoPriceChange: 'No price change recorded for this item.',
    smmHistDate: 'Date',
    smmHistPriceTtc: 'Price (incl. tax)',
    smmHistVat: 'VAT',
    smmHistSource: 'Source',
    smmProductFallback: 'Product',
    smmCreateTypeOption: '+ Create a type…',
    smmCreateCategoryOption: '+ Create a category…',
    smmStepCatalog: 'Catalog',
    smmStepCategories: 'Categories',
    smmStepCreation: 'Creation',
    smmApplyPriceError: 'Failed to apply the Weezevent price',
    smmApplyPricesError: 'Failed to apply the Weezevent prices',
    smmSourceCatalog: 'Weezevent catalog',
    smmSourceSales: 'Sales (modal price)',
    smmSourceManual: 'Manual',
    smmMappingsAppliedMid: 'mapping(s) applied,',
    smmFailedSuffix: 'failed.',
    smmMappingsApplied: 'mapping(s) applied.',
    smmAutoMappingFailed: 'Automatic mapping failed.',
    smmNameRequired: 'Name is required',
    smmCannotCreateType: 'Unable to create the type',
    smmCreationFailed: 'Creation failed',
    smmSelectTypeFirst: 'Select a type first',
    smmCannotCreateCategory: 'Unable to create the category',
    smmItemsAttachedMid: 'item(s) attached.',
    smmItemsAttachedToSpace: 'item(s) attached to the Space.',
    smmBatchCreateFailed: 'A batch of products could not be created.',
    smmLastError: 'Last error:',
    smmProductsCreatedMappedOn: 'product(s) created and mapped out of',
    smmProductsNotProcessed: 'product(s) were not processed.',
    smmBulkFatalError: 'An error occurred during the automatic creation.',
    intgSpaceHeaderTitlePrefix: 'Map',
    intgSpaceHeaderTitleSuffix: 'to a space',
    intgSpaceHeaderStep: '— Step 1',
    intgSpaceHeaderSub: 'Select an existing space or create a new one. All locations (points of sale) will be attached to this space.',
    intgSpaceBadgeAssociated: 'Mapped',
    intgSpaceBadgePending: 'Pending',
    intgSpaceSuggestionLabel: 'Suggestion:',
    intgSpaceSimilarity: 'similarity',
    intgSpaceUse: 'Use',
    intgSpaceSelectedSuccess: 'selected successfully.',
    intgSpaceExisting: 'Existing space',
    intgSpaceSelectPlaceholder: 'Select a Space…',
    intgSpaceDeselect: 'Deselect',
    intgSpaceOrCreateNew: 'or create a new one',
    intgSpaceCreateNewTitle: 'Create a new Space',
    intgSpaceCreateNewSub: 'Define the basic structure',
    intgSpaceSectionIdentity: 'Identity',
    intgSpaceFieldName: 'Name *',
    intgSpaceFieldPlaceType: 'Venue type',
    intgSpaceSelectEmpty: 'Select…',
    intgSpaceFieldMaxCapacity: 'Max capacity',
    intgSpaceFieldDepartment: 'Department',
    intgSpaceFieldHomeTeam: 'Home team',
    intgSpaceSectionAddress: 'Address',
    intgSpaceFieldAddress: 'Address',
    intgSpaceFieldAddress2: 'Address line 2',
    intgSpaceFieldCity: 'City',
    intgSpaceFieldPostcode: 'Postcode',
    intgSpaceFieldCountry: 'Country',
    intgSpaceSectionContact: 'Contact',
    intgSpaceFieldEmail: 'Email',
    intgSpaceFieldPhone: 'Phone',
    intgSpaceFieldContactPerson: 'Contact person',
    intgSpaceFieldContactEmail: 'Contact email',
    intgSpaceFieldContactPhone: 'Contact phone',
    intgSpaceSectionSocial: 'Social media',
    intgSpaceCreateSpaceBtn: 'Create Space',
    intgSpaceDialogTitle: 'Initial configuration',
    intgSpaceDialogSub: 'Define the default configuration and the first floor',
    intgSpaceConfigName: 'Configuration name',
    intgSpaceGroundFloor: 'Ground floor (GF)',
    intgSpaceFloorName: 'Ground floor name',
    intgSpaceDimensions: 'Dimensions',
    intgSpaceWidth: 'Width (m)',
    intgSpaceLength: 'Length (m)',
    intgSpaceSkip: 'Skip',
    intgSpaceCreateConfigBtn: 'Create configuration',
    intgSpaceNext: 'Next',
    intgSpaceErrNameRequired: 'Name is required',
    intgSpaceErrEmailInvalid: 'Invalid email address',
    intgSpaceErrPositiveValue: 'The value must be positive',
    intgSpaceErrDepartmentInvalid: 'Invalid department number',
    intgSyncHeaderTitle: 'Final synchronization',
    intgSyncHeaderSub: 'Cleanup, reprocessing and generation of consolidated summaries for the selected space.',
    intgSyncBadgeReady: 'Ready',
    intgSyncBadgeInProgress: 'In progress',
    intgSyncBadgeDone: 'Done',
    intgSyncBadgeError: 'Error',
    intgSyncWhatHappens: 'What will happen?',
    intgSyncStepCleanup: 'Cleanup of obsolete aggregations',
    intgSyncStepReprocess: 'Full reprocessing of transactions',
    intgSyncStepDailyAgg: 'Computing daily aggregations',
    intgSyncStepSummaries: 'Generation of consolidated summaries',
    intgSyncStartBtn: 'Start synchronization',
    intgSyncInProgressTitle: 'Synchronization in progress…',
    intgSyncElapsed: 'Elapsed time:',
    intgSyncEstimate: 'Estimate: ~2 min',
    intgSyncPhase: 'Phase',
    intgSyncDoneTitle: 'Synchronization complete.',
    intgSyncDoneSub: 'All data has been processed successfully.',
    intgSyncStatEvents: 'Events',
    intgSyncStatTransactions: 'Transactions',
    intgSyncStatAggregations: 'Aggregations',
    intgSyncFinishBtn: 'Finish',
    intgSyncErrorTitle: 'Synchronization error.',
    intgSyncRetryBtn: 'Retry',
    intgSyncPhaseCleanup: 'Cleanup of old data',
    intgSyncPhaseProcessing: 'Reprocessing transactions',
    intgSyncPhaseAggregating: 'Computing daily aggregations',
    intgSyncPhaseSummaries: 'Generating summaries',
    intgCreateEvtHeaderTitle: 'Create an event',
    intgCreateEvtHeaderSub: 'Linked to an uncovered date',
    intgCreateEvtSectionInfo: 'Information',
    intgCreateEvtNameLabel: 'Event name',
    intgCreateEvtNamePlaceholder: 'e.g. Ligue 1 match',
    intgCreateEvtSectionDates: 'Dates',
    intgCreateEvtStartDate: 'Start date',
    intgCreateEvtEndDate: 'End date',
    intgCreateEvtEndTime: 'End time',
    intgCreateEvtSectionTaxonomy: 'Taxonomy',
    intgCreateEvtTypeLabel: 'Event type',
    intgCreateEvtCreateType: '+ Create a type',
    intgCreateEvtSelectPlaceholder: 'Select…',
    intgCreateEvtCategoryLabel: 'Category',
    intgCreateEvtCreateCategory: '+ Create a category',
    intgCreateEvtSubcategoryLabel: 'Subcategory',
    intgCreateEvtCreateSubcategory: '+ Create a subcategory',
    intgCreateEvtHideOptions: 'Hide',
    intgCreateEvtMoreOptions: 'More options',
    intgCreateEvtSectionTicketing: 'Ticketing',
    intgCreateEvtTicketsSold: 'Tickets sold',
    intgCreateEvtTicketsScanned: 'Tickets scanned',
    intgCreateEvtSectionFlow: 'Schedule',
    intgCreateEvtOpeningAct: 'Opening act',
    intgCreateEvtIntermission: 'Half-time / Intermission',
    intgCreateEvtSectionSessions: 'Sessions',
    intgCreateEvtSessionCount: 'Number of sessions',
    intgCreateEvtSessionTitle: 'Session',
    intgCreateEvtDoorsOpening: 'Doors opening',
    intgCreateEvtKickoff: 'Kick-off',
    intgCreateEvtCancel: 'Cancel',
    intgCreateEvtSubmit: 'Create event',
    intgCreateEvtTypeDialogTitle: 'Create an event type',
    intgCreateEvtTypeNameLabel: 'Type name',
    intgCreateEvtTypeNamePlaceholder: 'e.g. Sport',
    intgCreateEvtCreate: 'Create',
    intgCreateEvtCategoryDialogTitle: 'Create a category',
    intgCreateEvtLinkedToType: 'Linked to type',
    intgCreateEvtCategoryNameLabel: 'Category name',
    intgCreateEvtCategoryNamePlaceholder: 'e.g. Football',
    intgCreateEvtSubDialogTitle: 'Create a subcategory',
    intgCreateEvtLinkedToCategory: 'Linked to category',
    intgCreateEvtSubNameLabel: 'Subcategory name',
    intgCreateEvtSubNamePlaceholder: 'e.g. Ligue 1',
    intgCreateEvtNameRequired: 'Name is required',
    intgCreateEvtCannotCreateType: 'Unable to create the type',
    intgCreateEvtCannotCreateCategory: 'Unable to create the category',
    intgCreateEvtCannotCreateSub: 'Unable to create the subcategory',
    intgCreateEvtCreateFailed: 'Creation failed',
    intgEnrichEvtTitle: 'Enrich the event',
    intgEnrichEvtDoorsOpening: 'Doors opening',
    intgEnrichEvtShowTime: 'Show time / kick-off',
    intgEnrichEvtTimeHint: 'Format HH:MM',
    intgEnrichEvtCategory: 'Category',
    intgEnrichEvtType: 'Event type',
    intgEnrichEvtTypeHome: 'Home',
    intgEnrichEvtTypeAway: 'Away',
    intgEnrichEvtTypeNeutral: 'Neutral',
    intgEnrichEvtHomeTeam: 'Home team',
    intgEnrichEvtVisitingTeam: 'Visiting team',
    intgEnrichEvtIntermission: 'Half-time / Intermission',
    intgEnrichEvtCancel: 'Cancel',
    intgEnrichEvtSave: 'Save',
    intgMapEvtTitle: 'Map to an existing event',
    intgMapEvtDescBefore: 'Transactions of',
    intgMapEvtDescAfter: 'will be attached to the selected event by updating its date.',
    intgMapEvtSelectLabel: 'Existing event',
    intgMapEvtCancel: 'Cancel',
    intgMapEvtConfirm: 'Confirm',
    intgBreakdownTitle: 'Analysis',
    intgBreakdownKpiRevenue: 'Revenue excl. tax',
    intgBreakdownKpiTransactions: 'Transactions',
    intgBreakdownKpiItems: 'Items',
    intgBreakdownKpiShops: 'Shops',
    intgBreakdownTabByShop: 'By shop',
    intgBreakdownTabByItem: 'By item',
    intgBreakdownTabPerMinute: 'Revenue / minute',
    intgBreakdownColShop: 'Shop',
    intgBreakdownColRevenue: 'Revenue excl. tax',
    intgBreakdownColTx: 'Tx',
    intgBreakdownColArt: 'Items',
    intgBreakdownColArticle: 'Item',
    intgBreakdownColQty: 'Qty',
    intgBreakdownNoData: 'No data available.',
    intgBreakdownChartRevenue: 'Revenue excl. tax (€)',
    intgBreakdownChartTransactions: 'Transactions',
    intgTimelineHeaderTitle: 'Uncovered dates',
    intgTimelineHeaderStep: '— Step 4',
    intgTimelineHeaderSub: 'Create or map a DataFriday event for each date before synchronization.',
    intgTimelineUncoveredDatesCount: 'uncovered date(s)',
    intgTimelineWeezeventTransactions: 'Weezevent transactions',
    intgTimelineLinkedToEvent: 'linked to an event',
    intgTimelineWithoutEvent: 'without event',
    intgTimelineUnmappedLocations: 'unmapped location(s)',
    intgTimelineEvent: 'event',
    intgTimelineWeezeventUnlinked: 'unlinked Weezevent',
    intgTimelineWithoutSpace: 'without Space',
    intgTimelineCreateAndAttachAuto: '— create and attach automatically',
    intgTimelineLinked: 'linked',
    intgTimelineWithoutSpaceAttachAuto: 'without an associated Space — attach automatically',
    intgTimelineCreateAndLinkAll: 'Create and link all',
    intgTimelineTabCovered: 'Covered',
    intgTimelineTabUncovered: 'Uncovered',
    intgTimelineTabAll: 'All',
    intgTimelineDatesWithoutDfEvent: 'Dates without a DataFriday event',
    intgTimelineColDate: 'Date',
    intgTimelineColTransactions: 'Transactions',
    intgTimelineColActions: 'Actions',
    intgTimelineBtnMap: 'Map',
    intgTimelineBtnCreate: 'Create',
    intgTimelineAllCoveredTitle: 'All dates are covered',
    intgTimelineAllCoveredSub: '— no date with transactions lacking a DataFriday event.',
    intgTimelineDfEventsCreated: 'DataFriday events created',
    intgTimelineColDateName: 'Date / Name',
    intgTimelineColDataPoints: 'Data points',
    intgTimelineDataPointTooltip: '1 data point = net revenue + transaction count + quantities sold for a unique combination (minute × POS × item).',
    intgTimelineColStatus: 'Status',
    intgTimelineStatusAggregated: 'Aggregated',
    intgTimelineStatusUnprocessed: 'Not processed',
    intgTimelineViewAnalysisTooltip: 'View timeline analysis',
    intgTimelineBtnAnalysis: 'Analysis',
    intgTimelineRerunAggTooltip: 'Re-run aggregation',
    intgTimelineRunAggTooltip: 'Run aggregation',
    intgTimelineBtnRerun: 'Re-run',
    intgTimelineBtnAggregate: 'Aggregate',
    intgTimelineBtnDelete: 'Delete',
    intgTimelineNoDfEvents: 'No DataFriday event created for this space.',
    intgTimelineSyncDoneBadge: 'Done',
    intgTimelinePhase: 'Phase',
    intgTimelineVerifyingStatuses: 'Verifying statuses and Step 4 context...',
    intgTimelineSyncError: 'Error during synchronization.',
    intgTimelineBtnRetry: 'Retry',
    intgTimelineFinishConfig: 'Finish setup',
    intgTimelineBulkTitle: 'Bulk creation',
    intgTimelineBulkSub: 'Linking Weezevent events',
    intgTimelineBulkPatchingTitle: 'Attaching to Space…',
    intgTimelineBulkCreatingTitle: 'Creating events…',
    intgTimelineBulkDoneTitle: 'Operation complete',
    intgTimelineBulkInterruptedTitle: 'Operation interrupted',
    intgTimelineBulkPatchingSub: 'Linking existing events to the current Space…',
    intgTimelineBulkEventsProcessed: 'events processed',
    intgTimelineBulkEventsFailed: 'failed event(s)',
    intgTimelineBtnClose: 'Close',
    intgTimelineStepCleanup: 'Cleaning up old data',
    intgTimelineStepProcessing: 'Reprocessing transactions',
    intgTimelineStepAggregating: 'Computing daily aggregations',
    intgTimelineStepSummaries: 'Generating summaries',
    intgTimelineFinalVerification: 'Final verification',
    intgTimelineFinalSync: 'Final synchronization',
    intgTimelineSyncPrimaryVerify: 'All events are already aggregated. Checks consistency without a full rebuild.',
    intgTimelineSyncPrimaryFull: 'Cleans up old aggregations and recomputes all consolidated summaries.',
    intgTimelineSyncSecondaryVerify: 'Fast, without erasing or recomputing all aggregations.',
    intgTimelineSyncSecondaryFull: 'Run once all dates are covered.',
    intgTimelineRunVerification: 'Run verification',
    intgTimelineRunSync: 'Run synchronization',
    intgTimelineVerifyingLabel: 'Verification in progress...',
    intgTimelineSyncingLabel: 'Synchronization in progress...',
    intgTimelineVerifyDoneTitle: 'Verification complete!',
    intgTimelineSyncDoneTitle: 'Synchronization complete!',
    intgTimelineEventsVerified: 'events verified',
    intgTimelineAggregatedWord: 'aggregated',
    intgTimelineTransactionsMatched: 'matched transactions',
    intgTimelineInitializing: 'Initializing...',
    intgTimelineAggDone: 'Aggregation complete.',
    intgTimelineAggSlow: 'Aggregation is taking longer than expected — tracking will resume on reload.',
    intgTimelineProcessingBackground: 'Processing in the background — refreshing in 5 s…',
    intgTimelineAggErrorPrefix: 'Aggregation error:',
    intgTimelineSyncFailed: 'Synchronization failed.',
    intgTimelineDeleteConfirmPrefix: 'Delete the event',
    intgTimelineDeleteConfirmSuffix: '? The date will return to "Uncovered".',
    intgTimelineDeletedSuffix: 'deleted.',
    intgTimelineDeleteError: 'Error during deletion.',
    intgTimelineBreakdownError: 'Unable to load details.',
    intgTimelineMapSuccess: 'Event updated and date covered.',
    intgTimelineMapErrorPrefix: 'Error during mapping:',
    intgTimelineEventFallbackName: 'Event',
    intgTimelineBulkEventsAttached: 'event(s) attached to the Space.',
    intgTimelineBulkSkippedNoDate: 'skipped (no date).',
    intgTimelineBulkCreatedOn: 'event(s) created out of',
    intgTimelineBulkFailedShort: 'failed.',
    intgTimelineBulkCreatedLinked: 'event(s) created and linked to the Space.',
    intgTimelineGenericError: 'An error occurred.',
    intgTimelineWeezLinked: 'Weezevent event linked.',
    intgTimelineLinkRemoved: 'Link removed.',
    intgTimelineLinkSaveError: 'Error saving the link.',
    intgTimelineEnrichSuccess: 'Event enriched successfully.',
    intgTimelineSaveError: 'Error while saving.',
    intgTimelineCsvMinute: 'Minute',
    intgTimelineCsvShop: 'Shop',
    intgTimelineCsvShopType: 'Shop type',
    intgTimelineCsvArticle: 'Item',
    intgTimelineCsvCategory: 'Category',
    intgTimelineCsvQuantity: 'Quantity',
    intgTimelineCsvTransactions: 'Transactions',
    intgTimelineCsvRevenueHt: 'Net revenue (€)',
    intgTimelineAttendeesSyncedTotal: 'attendees synchronized in total.',
    intgTimelineAttendeesSynced: 'attendees synchronized.',
    intgTimelineAttendeesSyncError: 'Error while syncing attendees.',
    intgSyncProgTitleDone: 'Synchronization complete',
    intgSyncProgTitle: 'Weezevent synchronization',
    intgSyncProgFrom: 'From',
    intgSyncProgTo: 'to',
    intgSyncProgDuration: 'Duration:',
    intgSyncProgPhase1Label: 'Phase 1 — Weezevent collection',
    intgSyncProgTransactions: 'transactions',
    intgSyncProgSegments: 'segments',
    intgSyncProgPhase2Label: 'Phase 2 — Database insertion',
    intgSyncProgStatCollected: 'Collected',
    intgSyncProgStatNew: 'New',
    intgSyncProgStatDuplicates: 'Duplicates ignored',
    intgSyncProgSyncFailed: 'Synchronization failed.',
    intgSyncProgInDb: 'in database',
    intgSyncProgNewPlural: 'new',
    intgSyncProgInDbEllipsis: 'in database…',
    intgSyncProgStarting: 'starting...',
    intgSyncProgError: 'Error',
    intgSyncProgDataInDb: 'Data in database',
    intgSyncProgStatTransactions: 'Transactions',
    intgSyncProgStatEvents: 'Events',
    intgSyncProgStatProducts: 'Products',
    intgSyncProgStatLocations: 'Locations',
    intgSyncProgStatMerchants: 'Merchants',
    intgSyncProgHasMore: 'More transactions are available — re-run the synchronization to import the rest.',
    intgSyncProgLocationsDetected: 'Locations detected',
    intgSyncProgUnmapped: 'unmapped',
    intgSyncProgNotYetMapped: '→ not yet mapped',
    intgSyncProgLocationsHint: 'These locations must be associated with spaces to enable data analysis.',
    intgSyncProgLastTransaction: 'Last Weezevent transaction:',
    intgSyncProgUnknown: 'unknown',
    intgSyncProgLastSync: 'Last synchronization:',
    intgSyncProgNever: 'never',
    intgSyncProgCloseBackground: 'Close — sync continues in the background',
    intgSyncProgClose: 'Close',
    intgSyncProgResyncPeriod: 'Re-sync another period',
    intgSyncProgCancel: 'Cancel',
    intgSyncProgRetrySync: 'Re-run synchronization',
    intgSyncProgConfigureLocations: 'Configure locations',
    intgSyncProgRelSecondsAgo: 'a few seconds ago',
    intgSyncProgRelAgo: '',
    intgProviderActive: 'Active integration',
    intgProviderSync: 'Synchronize',
    intgProviderImporting: 'Importing Weezevent data...',
    intgProviderImportingHint: 'This may take a few moments',
    intgProviderLocations: 'Locations',
    intgProviderNoLocation: 'No location found',
    intgProviderNoLocationHint: 'Click Synchronize to import your Weezevent data.',
    intgProviderImportData: 'Import data',
    intgLocationFallback: 'Location',
    intgLocationSpace: 'Space:',
    intgLocationNoSpace: 'No space associated',
    intgLocationBtnConfigure: 'Configure',
    intgLocationBtnContinue: 'Continue',
    intgLocationBtnDetails: 'View details',
    intgOverviewTitle: 'Integration setup',
    intgOverviewDescPrefix: 'Before data appears in your analytics, this location must be configured in',
    intgOverviewDescSteps: '4 steps',
    intgOverviewDescSuffix: '.',
    intgOverviewDone: 'Done',
    intgOverviewTodo: 'To do',
    intgOverviewStart: 'Start configuration',
    intgOverviewFallbackName: 'Integration',
    intgOverviewStepSpaceLabel: 'Associate a space',
    intgOverviewStepSpaceDesc: 'Link this location to a DataFriday space',
    intgOverviewStepShopsLabel: 'Map the Locations (points of sale)',
    intgOverviewStepShopsDesc: 'Associate Weezevent locations (points of sale) with your internal shops',
    intgOverviewStepProductsLabel: 'Map the products',
    intgOverviewStepProductsDesc: 'Associate products with your menu items',
    intgOverviewStepEventsLabel: 'Processing & Synchronization',
    intgOverviewStepEventsDesc: 'Aggregate data by event and synchronize summaries',
    intgWizardFallbackName: 'Integration',
    intgWizardHeaderSub: 'Weezevent configuration',
    intgWizardStepsLabel: 'steps',
    intgWizardClose: 'Close',
    intgWizardPrevious: 'Previous',
    intgWizardStepSpace: 'Space',
    intgWizardStepLocations: 'Locations',
    intgWizardStepMenu: 'Menu',
    intgWizardStepEvents: 'Events',
    intgSuccessReady: 'is ready!',
    intgSuccessSub: 'Data is now available in your F&B analytics.',
    intgSuccessSummaryLabel: 'Configuration summary',
    intgSuccessMerchants: 'Merchants mapped',
    intgSuccessProducts: 'Products mapped',
    intgSuccessEvents: 'Events processed',
    intgSuccessOtherLocationsPlural: 'other locations to configure',
    intgSuccessOtherLocationsSingular: 'other location to configure',
    intgSuccessStepsLabel: 'steps',
    intgSuccessConfigure: 'Configure',
    intgSuccessBackToIntegrations: 'Back to integrations',
    intgSuccessViewAnalytics: 'View analytics',
    intgSuccessFallbackName: 'Location',
    // === ProfileView (i18n) ===
    profileCopied: 'Copied!',
    profileCopy: 'Copy',
    profilePersonalInfoTitle: 'Personal information',
    profilePersonalInfoSubtitle: 'Edit your first name, last name and contact details',
    profileFirstName: 'First name',
    profileFirstNamePlaceholder: 'Your first name',
    profileLastName: 'Last name',
    profileLastNamePlaceholder: 'Your last name',
    profileEmail: 'Email',
    profileReadonly: 'read-only',
    profilePhone: 'Phone',
    profilePhonePlaceholder: '+33 6 00 00 00 00',
    profileUpdated: 'Profile updated',
    profileSave: 'Save',
    profileSecurity: 'Security',
    profileSecuritySubtitle: 'Update your password',
    profileNewPassword: 'New password',
    profileConfirmPassword: 'Confirm password',
    profilePasswordMismatch: 'Passwords do not match',
    profilePasswordUpdated: 'Password updated',
    profileUpdate: 'Update',
    profileUserFallback: 'User',
    profilePwdVeryWeak: 'Very weak',
    profilePwdWeak: 'Weak',
    profilePwdMedium: 'Medium',
    profilePwdStrong: 'Strong',
    profileErrorGeneric: 'An error occurred',
    profilePasswordError: 'Unable to update password',
    // inv — all F&B shops of the config visible (zero-item shops marked, not hidden)
    invCardNoMenuAssigned: 'No menu items assigned to this shop.',
    invShopClosed: 'Closed',
    invShopOpen: 'Open',
    invSort: 'Sort',
    invSortName: 'Name',
    invSortToCount: 'To count first',
    invSortStockAsc: 'Low stock first',
    // inv — storage tab: left filters + right aggregate
    invFilterStorages: 'Storages',
    invFilterFloors: 'Floors',
    invFilterInventoryItems: 'Inventory items',
    invSearchStorage: 'Search a storage',
    invStorageAggTitle: 'Storage summary',
    invAggDetailByStorage: 'Detail by storage',
    invStorageAggEmpty: 'No storage items to count.',
    invStorageAggFocusHint: 'Counting in progress — this storage only.',
    // === Analyse screen (i18n) ===
    anDemoDataShown: 'demo data displayed.',
    anWeezeventIncompleteTitle: 'Incomplete Weezevent configuration',
    anWeezeventIncompleteBody: 'The data tables have not been created yet for this tenant. Complete the Weezevent integration (wizard steps 1–4) to see sales data.',
    anPredictModeActive: 'Forecast mode enabled',
    anFutureEventsIncluded: 'future events included',
    anFutureEventIncluded: 'future event included',
    anPredictModeExplanation: 'Forecast figures are calculated from similar past events (weighted scoring + attendance scaling).',
    anCalculatingForecasts: 'Calculating forecasts…',
    anLoadingTimelineFor: 'Loading the timeline for',
    anEventsPlural: 'events',
    anEventSingular: 'event',
    anAggregating15Min: 'Aggregating in 15-minute intervals.',
    anSpaceDefault: 'Space',
    anLoadingEventPredict: 'Loading Event Predict…',
    anLoadingPredict: 'Loading Predict…',
    anLoadingAnalyse: 'Loading Analyse…',
    anHeaderChangeSpace: 'Change space',
    anHeaderSearchSpace: 'Search for a space…',
    anHeaderLoading: 'Loading…',
    anHeaderNoSpaceAvailable: 'No space available',
    anHeaderNoSpaceFound: 'No space found',
    anHeaderAllSpaces: 'All spaces',
    anHeaderHome: 'Home',
    anHeaderSignOut: 'Sign out',
    breadcrumbHome: 'Home',
    breadcrumbMenuFb: 'F&B Menu',
    analyseTitle: 'Analytics',
    analyseSubtitle: 'Analytical view',
    anHeaderAnalysisAssistant: 'Analysis assistant',
    anHeaderUser: 'User',
    anHeaderKpiRevenue: 'Revenue',
    anHeaderKpiAvgPerEvent: 'Avg./Event',
    anHeaderKpiCost: 'Cost',
    anHeaderKpiTransactions: 'Transac.',
    anHeaderKpiBasket: 'Basket',
    anHeaderKpiAttendees: 'Attendees',
    anHeaderKpiTransformation: 'Conversion',
    anHeaderKpiPerCap: 'Per cap',
    anKpiCardMargin: '% Margin',
    anKpiCardTransactionRate: 'tx/min',
    anHeaderAlertRevenueUp: 'sharply up',
    anHeaderAlertRevenueDown: 'markedly down',
    anHeaderAlertVsPreviousPeriod: 'vs previous period',
    anHeaderQueryVsPreviousPeriod: 'vs previous period',
    anHeaderAlertCostFasterTitle: 'Costs rising faster than revenue',
    anHeaderQueryTotalCost: 'total cost',
    anHeaderAlertMarginBelow: 'Margin below',
    anHeaderAlertMarginDetail: 'Check the product mix and food costs.',
    anHeaderQueryAvgMargin: 'average margin',
    anHeaderAlertLowTransferTitle: 'Low transaction rate',
    anHeaderAlertLowTransferDetail: 'Fewer than one in two attendees makes a purchase.',
    anHeaderQueryKpiSummary: 'KPI summary',
    anHeaderAlertAvgBasket: 'Average basket',
    anHeaderAlertAvgTransaction: 'Average transaction',
    anHeaderQueryAvgBasket: 'average basket',
    anHeaderAlertSpendPerAttendee: 'Spend per attendee',
    anHeaderQueryPerCap: 'per cap',
    anHeaderCaptureFailed: 'Capture failed',
    anHeaderCaptureCopied: 'Capture copied to clipboard',
    anHeaderCaptureDownloaded: 'Capture downloaded (clipboard unavailable)',
    anHeaderCopyFailed: 'Unable to copy the capture',
    anHeaderDashboard: 'Dashboard',
    anHeaderShared: 'Shared',
    anHeaderLinkShared: 'Link shared (image downloaded separately)',
    anHeaderNativeShareUnavailable: 'Native sharing unavailable — capture downloaded',
    anHeaderShareFailed: 'Unable to share',
    anFilterAllConfigurations: 'All Configurations',
    anSummaryYearOverYearShort: 'YoY',
    anPanelAssistant: 'Assistant',
    anPanelAi: 'AI',
    anPanelTxnPerMin: 'txn/min',
    anTblShopXlsShop: 'Shop',
    anTblShopXlsItem: 'Item',
    anTblShopXlsType: 'Type',
    anTblShopXlsCategory: 'Category',
    anTblShopXlsQuantity: 'Quantity',
    anTblShopXlsRevenue: 'Revenue',
    anTblShopXlsEvents: 'Events',
    anTblShopXlsSheetByShop: 'Items by shop',
    anTblShopXlsSheetByItem: 'Shops by item',
    anTblShopXlsFileByShop: 'items-by-shop.xlsx',
    anTblShopXlsFileByItem: 'shops-by-item.xlsx',
    anTimelineTitlePrefix: 'Timeline —',
    anSearchMenuItems: 'Search menu items…',
    anNoResults: 'No results',
  },

  fr: {
    // Common
    cancel: 'Annuler',
    save: 'Enregistrer',
    saveChanges: 'Enregistrer les modifications',
    create: 'Créer',
    edit: 'Modifier',
    delete: 'Supprimer',
    close: 'Fermer',
    search: 'Rechercher',
    actions: 'Actions',
    yes: 'Oui',
    no: 'Non',
    confirm: 'Confirmer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    of: 'de',
    
    // Suppliers
    suppliers: 'Fournisseurs',
    supplier: 'Fournisseur',
    addSupplier: 'Ajouter un fournisseur',
    editSupplier: 'Modifier le fournisseur',
    deleteSupplier: 'Supprimer le fournisseur',
    supplierName: 'Nom du fournisseur',
    contactName: 'Nom du contact',
    email: 'Email',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    postcode: 'Code postal',
    notes: 'Notes',
    sites: 'Sites',
    available: 'disponibles',
    totalSuppliers: 'Total des fournisseurs',
    noSuppliersFound: 'Aucun fournisseur trouvé',
    noSuppliersMessage: 'Commencez par ajouter votre premier fournisseur',
    tryAdjusting: 'Essayez d\'ajuster vos termes de recherche',
    searchPlaceholder: 'Rechercher par nom, email, ville...',
    addFirstSupplier: 'Ajoutez votre premier fournisseur',
    title: 'Fournisseurs',
    subtitle: 'Gérez vos fournisseurs et leurs informations de contact',
    
    // Market Prices
    marketPrices: 'Prix du Marché',
    addMarketPrice: 'Ajouter Prix du Marché',
    editMarketPrice: 'Modifier Prix du Marché',
    itemName: 'Nom de l\'article',
    goodType: 'Type de produit',
    ingredientCategory: 'Catégorie d\'ingrédient',
    recipeUnit: 'Unité de recette',
    purchaseUnitConversion: 'Conversion unité d\'achat',
    supplierItem: 'Article fournisseur',
    unit: 'Unité',
    unitsPerPurchase: 'Unités par achat',
    price: 'Prix',
    packaging: 'Emballage',
    step: 'Étape',
    basicInfo: 'Informations de base',
    selectExistingItem: 'Sélectionner un article existant',
    enterItemName: 'Entrer le nom de l\'article',
    selectSupplier: 'Sélectionner un fournisseur',
    clickToUpload: 'Cliquez pour télécharger une image',
    fileFormat: 'PNG, JPG jusqu\'à 5 Mo',
    clickToChange: 'Cliquez pour changer',
    addingSupplierTo: 'Ajout d\'un fournisseur à',
    recipeUnitQuestion: 'Quelle unité utilisez-vous dans les recettes ?',
    conversionQuestion: 'Combien d\'unités de recette dans une unité d\'achat ?',
    editItemName: 'Modifier l\'article',
    updateItemInfo: 'Mettre à jour les informations de l\'article',
    marketPriceListSubtitle: 'Gérez les prix et fournisseurs de tous vos produits',
    marketPriceListExportCsv: 'Exporter CSV',
    marketPriceListImportCsv: 'Importer CSV',
    marketPriceListNewPrice: 'Nouveau Prix',
    
    // Form fields
    required: 'Requis',
    optional: 'Optionnel',
    streetAddress: 'Adresse',
    phonePlaceholder: 'Numéro de téléphone',
    emailPlaceholder: 'Adresse email',
    addNotes: 'Ajoutez des notes supplémentaires...',
    
    // Good Types
    food: 'Nourriture',
    beverage: 'Boisson',
    nonFood: 'Non-alimentaire',
    supply: 'Fourniture',
    equipment: 'Équipement',

    // Space Menu
    spaceMenuTitle: 'Menus des Espaces',
    spaceMenuSubtitle: 'Gérez vos boutiques et menus par espace',
    spaceMenuShop: 'boutique',
    spaceMenuShops: 'boutiques',
    spaceMenuSpace: 'Espace',
    spaceMenuSelectSpace: 'Sélectionner un espace',
    spaceMenuConfiguration: 'Configuration',
    spaceMenuSelectConfiguration: 'Sélectionner une configuration',
    spaceMenuView: 'Vue',
    spaceMenuByShop: 'Par boutique',
    spaceMenuByMenuItem: 'Par menu item',
    spaceMenuSaveConfiguration: 'Enregistrer la configuration',
    spaceMenuOpen: 'Ouvert',
    spaceMenuClosed: 'Fermé',
    spaceMenuSearchShops: 'Rechercher des boutiques...',
    spaceMenuSearchMenuItems: 'Rechercher par menu item...',
    spaceMenuSelectASpace: 'Sélectionnez un espace',
    spaceMenuChooseSpaceToSeeShops: 'Choisissez un espace pour voir ses boutiques',
    spaceMenuFoodAndBeverages: 'Food and Beverages',
    spaceMenuNoMatchingShops: 'Aucune boutique correspondante',
    spaceMenuTryAdjustingFilters: 'Essayez d\'ajuster vos filtres',
    spaceMenuNoShopsFound: 'Aucune boutique trouvée',
    spaceMenuSpaceHasNoShops: 'Cet espace n\'a pas encore de boutiques',
    spaceMenuMenuItems: 'Menu Items',
    spaceMenuItems: 'items',
    spaceMenuLoadingMenuItems: 'Chargement des menu items...',
    spaceMenuNoMenuItemsFound: 'Aucun menu item trouvé',
    spaceMenuAvailable: 'Disponible',
    spaceMenuNotAvailable: 'Non disponible',
    spaceMenuReasonInactive: 'ingrédient indisponible',
    spaceMenuReasonNoSupplier: 'sans fournisseur',
    spaceMenuReasonSupplierNotInSpace: 'fournisseur ne livre pas cet espace',
    spaceMenuNoRecipe: 'Pas de recette',
    spaceMenuMissingIngredients: 'Ingrédients manquants :',
    spaceMenuLoadError: 'Échec du chargement des données',
    spaceMenuRetry: 'Réessayer',
    spaceMenuMenuItem: 'Menu Item',
    spaceMenuValidateSelection: 'Valider la sélection',
    spaceMenuMenuItemsAttached: 'Menu items rattachés au shop avec succès.',
    spaceMenuFailedToAttachMenuItems: 'Échec du rattachement des menu items au shop.',
    spaceMenuEditShop: 'Modifier la boutique',
    spaceMenuShopImage: 'Image de la boutique',
    spaceMenuClickToChange: 'Cliquer pour modifier',
    spaceMenuUploadShopImage: 'Télécharger une image de boutique',
    spaceMenuClickToBrowseOrDrag: 'Cliquez pour parcourir ou glissez-déposez',
    spaceMenuFileTypes: 'PNG, JPG jusqu\'à 5 Mo',
    spaceMenuShopTypes: 'Types de boutiques',
    spaceMenuSelected: 'sélectionné(s)',
    spaceMenuActiveConfiguration: 'Configuration active',
    spaceMenuActive: 'Actif',
    spaceMenuNoConfigurationSelected: 'Aucune configuration sélectionnée',
    spaceMenuUnknownConfiguration: 'Configuration inconnue',
    spaceMenuFailedToLoadSpaces: 'Impossible de charger les espaces',
    spaceMenuFailedToLoadShops: 'Impossible de charger les boutiques',
    spaceMenuShopTypeBeer: 'Bière',
    spaceMenuShopTypeGpPremium: 'GP Premium',
    spaceMenuShopTypeTemporary: 'Temporaire',
    spaceMenuShopTypeDrinkee: 'Drinkee',
    spaceMenuAttachMenuItems: 'Rattacher les menus',

    // Settings Drawer Navigation
    navSettings: 'Paramètres',
    navConfiguration: 'Configuration',
    navPreferences: 'Préférences',
    navLanguage: 'Langue',
    navTheme: 'Thème',
    signOut: 'Se déconnecter',
    // Sidebar gauche (MAIN_NAVIGATION)
    navMenu: 'Menu',
    navAnalytics: 'Analytiques',
    navSpaces: 'Espaces',
    navFb: 'F&B',
    navHospitality: 'Hospitalité',
    navMerch: 'Merch',
    navTicketing: 'Billetterie',
    navStorage: 'Stockage',
    navMenuFB: 'Menu F&B',
    navMarketPricesList: 'Prix du marché',
    navComponents: 'Composants',
    navSpaceMenu: 'Menu des espaces',
    navMenuItems: 'Items du menu',
    navEvents: 'Événements',
    navEventTypes: 'Types d\'événements',
    navEventCategories: 'Catégories d\'événements',
    navEventSubcategories: 'Sous-catégories d\'événements',
    navConfigurations: 'Configurations',
    navProductCategories: 'Catégories Menu Item',
    navProductTypes: 'Types Menu Item',
    navMarketPriceTypes: 'Good Types',
    navMarketPriceCategories: 'Good Categories',
    navComponentTypes: 'Component Types',
    navComponentCategories: 'Component Categories',
    navBrandNames: 'Noms de marque',
    navDisplayNames: 'Noms d\'affichage',
    navIndustrials: 'Industriels',
    navPackingTypes: 'Types de conditionnement',
    brandNameListTitle: 'Noms de marque',
    brandNameListSubtitle: 'Gérez vos noms de marque',
    brandNameListAddBrand: 'Ajouter une marque',
    brandNameListTotalBrands: 'Total marques',
    brandNameListSearchPlaceholder: 'Rechercher une marque...',
    brandNameListColName: 'Nom',
    brandNameListColCreated: 'Créé le',
    brandNameListColActions: 'Actions',
    brandNameListDialogCreateTitle: 'Nouvelle marque',
    brandNameListDialogCreateSubtitle: 'Ajoutez un nouveau nom de marque',
    brandNameListDialogEditTitle: 'Modifier la marque',
    brandNameListDialogEditSubtitle: 'Mettre à jour le nom de marque',
    brandNameListLabelName: 'Nom de la marque',
    brandNameListNamePlaceholder: 'ex. Nike, Coca-Cola...',
    brandNameListCancel: 'Annuler',
    brandNameListSave: 'Enregistrer',
    brandNameListCreate: 'Créer',
    brandNameListDeleteTitle: 'Supprimer la marque',
    brandNameListDeleteSubtitle: 'Cette action est irréversible',
    brandNameListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    brandNameListDelete: 'Supprimer',
    navIngredients: 'Ingrédients',
    navDataIntegration: 'Intégration de données',
    navOrganisation: 'Organisation',
    navAccount: 'Compte',
    navUsers: 'Utilisateurs',
    navProfile: 'Profil',
    navAccess: 'Accès',
    navRoles: 'Rôles',
    navPermissions: 'Permissions',
    permissionListTitle: 'Permissions',
    permissionListSubtitle: 'Gérez les permissions d\'accès de votre organisation',
    permissionListAddPermission: 'Ajouter une permission',
    permissionListTotalPermissions: 'Total permissions',
    permissionListSearchPlaceholder: 'Rechercher une permission...',
    permissionListColName: 'Nom',
    permissionListColDescription: 'Description',
    permissionListColType: 'Type',
    permissionListColCreated: 'Créé le',
    permissionListColActions: 'Actions',
    permissionListTypeSystem: 'Système',
    permissionListTypeCustom: 'Personnalisée',
    permissionListDialogCreateTitle: 'Nouvelle permission',
    permissionListDialogCreateSubtitle: 'Ajoutez une nouvelle permission à votre organisation',
    permissionListDialogEditTitle: 'Modifier la permission',
    permissionListDialogEditSubtitle: 'Mettre à jour les détails de la permission',
    permissionListLabelName: 'Nom de la permission',
    permissionListNamePlaceholder: 'ex. read:factures, write:utilisateurs...',
    permissionListLabelCode: 'Code',
    permissionListCodePlaceholder: 'ex. custom.export.pdf',
    permissionListCodeHint: 'Lettres minuscules, chiffres, points et underscores uniquement. Non modifiable après création.',
    permissionListLabelCategory: 'Catégorie',
    permissionListCategoryPlaceholder: 'ex. Organisation, F&B...',
    permissionListLabelDescription: 'Description',
    permissionListDescriptionPlaceholder: 'Décrivez ce que cette permission autorise...',
    permissionListCancel: 'Annuler',
    permissionListSave: 'Enregistrer',
    permissionListCreate: 'Créer',
    permissionListDeleteTitle: 'Supprimer la permission',
    permissionListDeleteSubtitle: 'Cette action est irréversible',
    permissionListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    permissionListDelete: 'Supprimer',
    roleListTitle: 'Rôles',
    roleListSubtitle: 'Gérez les rôles et leurs permissions associées',
    roleListAddRole: 'Ajouter un rôle',
    roleListTotalRoles: 'Total rôles',
    roleListSearchPlaceholder: 'Rechercher un rôle...',
    roleListDialogCreateTitle: 'Nouveau rôle',
    roleListDialogCreateSubtitle: 'Définissez un nouveau rôle et assignez des permissions',
    roleListDialogEditTitle: 'Modifier le rôle',
    roleListDialogEditSubtitle: 'Mettre à jour le rôle et ses permissions',
    roleListLabelName: 'Nom du rôle',
    roleListNamePlaceholder: 'ex. Administrateur, Éditeur...',
    roleListLabelDescription: 'Description',
    roleListDescriptionPlaceholder: 'Décrivez ce que ce rôle autorise...',
    roleListSectionPermissions: 'Permissions',
    roleListSearchPermissions: 'Rechercher des permissions...',
    roleListNoPermissionsAvailable: 'Aucune permission définie pour l\'instant',
    roleListPermissionsSelected: 'permission(s) sélectionnée(s)',
    roleListPermissions: 'permission(s)',
    roleListNoPermissions: 'Aucune permission assignée',
    roleListEmptyTitle: 'Aucun rôle défini',
    roleListEmptySubtitle: 'Créez votre premier rôle pour gérer les accès de votre organisation',
    roleListNoResults: 'Aucun rôle trouvé',
    roleListNoResultsSubtitle: 'Essayez un autre terme de recherche',
    roleListCancel: 'Annuler',
    roleListSave: 'Enregistrer',
    roleListCreate: 'Créer',
    roleListDeleteTitle: 'Supprimer le rôle',
    roleListDeleteSubtitle: 'Cette action est irréversible',
    roleListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    roleListDelete: 'Supprimer',
    roleListSystemBadge: 'Système',
    roleListAdminAllPermissionsNote: 'Le rôle Admin dispose toujours de toutes les permissions.',
    userListTitle: 'Utilisateurs',
    userListSubtitle: 'Gérez les membres de votre organisation',
    userListAddUser: 'Ajouter un utilisateur',
    userListImport: 'Importer',
    userListExport: 'Exporter',
    userListSearchPlaceholder: 'Rechercher par nom ou email...',
    userListAllRoles: 'Tous les rôles',
    userListUserFound: 'utilisateur trouvé',
    userListUsersFound: 'utilisateurs trouvés',
    userListClearFilters: 'Effacer les filtres',
    userListColName: 'Nom',
    userListColEmail: 'Email',
    userListColPhone: 'Téléphone',
    userListColRole: 'Rôle',
    userListColCreated: 'Créé le',
    userListColActions: 'Actions',
    userListStatusActive: 'Actif',
    userListStatusPending: 'En attente',
    userListLastSeen: 'Vu le',
    userListReinvite: 'Renvoyer l\'invitation',
    userListReinviteSuccess: 'Invitation renvoyée',
    userListReinviteError: 'Impossible de renvoyer l\'invitation',
    userListEmptyTitle: 'Aucun utilisateur',
    userListEmptySubtitle: 'Ajoutez votre premier utilisateur pour commencer',
    userListDrawerEditTitle: 'Modifier l\'utilisateur',
    userListDrawerEditSubtitle: 'Mettre à jour les informations',
    userListLabelFirstName: 'Prénom',
    userListFirstNamePlaceholder: 'Jean',
    userListLabelLastName: 'Nom',
    userListLastNamePlaceholder: 'Dupont',
    userListLabelEmail: 'Email',
    userListEmailPlaceholder: 'jean@exemple.com',
    userListLabelPhone: 'Téléphone',
    userListPhonePlaceholder: '+33 6 12 34 56 78',
    userListLabelRole: 'Rôle',
    userListRolePlaceholder: 'Sélectionner un rôle',
    userListNoName: 'Sans nom',
    userListSectionIdentity: 'Identité',
    userListSectionContact: 'Contact',
    userListSectionAccess: 'Accès',
    userListCancel: 'Annuler',
    userListSave: 'Enregistrer',
    userListDeleteTitle: 'Supprimer l\'utilisateur',
    userListDeleteSubtitle: 'Cette action est irréversible',
    userListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    userListDelete: 'Supprimer',
    userCreateTitle: 'Créer des utilisateurs',
    userCreateSubtitle: 'Ajoutez un ou plusieurs utilisateurs avant de sauvegarder',
    userCreateCancel: 'Annuler',
    userCreateSaveAll: 'Tout sauvegarder',
    userCreateUser: 'utilisateur',
    userCreateUsers: 'utilisateurs',
    userCreateStagingTitle: 'Utilisateurs à créer',
    userCreateStagingEmptyTitle: 'Aucun utilisateur ajouté',
    userCreateStagingEmptySubtitle: 'Remplissez le formulaire à droite et cliquez "Ajouter à la liste"',
    userCreateFormTitle: 'Nouvel utilisateur',
    userCreateFormEditTitle: 'Modifier l\'utilisateur',
    userCreateFormSubtitle: 'Remplissez les champs et ajoutez à la liste',
    userCreateSectionIdentity: 'Identité',
    userCreateSectionContact: 'Contact',
    userCreateSectionAccess: 'Accès',
    userCreateLabelFirstName: 'Prénom',
    userCreateFirstNamePlaceholder: 'Jean',
    userCreateLabelLastName: 'Nom',
    userCreateLastNamePlaceholder: 'Dupont',
    userCreateLabelEmail: 'Email',
    userCreateEmailPlaceholder: 'jean@exemple.com',
    userCreateLabelPhone: 'Téléphone',
    userCreatePhonePlaceholder: '+33 6 12 34 56 78',
    userCreateLabelRole: 'Rôle',
    userCreateRolePlaceholder: 'Sélectionner un rôle',
    userCreateAddToList: 'Ajouter à la liste',
    userCreateUpdateInList: 'Mettre à jour',
    userCreateCancelEdit: 'Annuler l\'édition',
    userCreateColName: 'Nom',
    userCreateColEmail: 'Email',
    userCreateColPhone: 'Téléphone',
    userCreateColRole: 'Rôle',
    userCreateColStatus: 'Statut',
    userCreateStatusPending: 'En attente',
    userCreateStatusSaved: 'Sauvegardé',
    userCreateStatusError: 'Erreur',

    // Component List View
    compListTitle: 'Bibliothèque de composants',
    compListSubtitle: 'Gérez et organisez vos composants de menu',
    compListExportCsv: 'Exporter CSV',
    compListAddComponent: 'Ajouter un composant',
    compListSearchPlaceholder: 'Rechercher des composants par nom...',
    compListAllCategories: 'Toutes les catégories',
    compListAllTypes: 'Tous les types',
    compListFound: 'trouvé(s)',
    compListComponent: 'composant',
    compListComponents: 'composants',
    compListColName: 'Nom du composant',
    compListColCategory: 'Catégorie',
    compListColType: 'Type',
    compListColUnit: 'Unité',
    compListColUnitsRecipe: 'Unités/Recette',
    compListColStorageType: 'Type de stockage',
    compListColUnitCost: 'Coût unitaire (€)',
    compListColSubItems: 'Sous-éléments',
    compListColActions: 'Actions',
    compListItems: 'éléments',
    compListDeleteTitle: 'Supprimer le composant',
    compListDeleteSubtitle: 'Cette action est irréversible.',
    compListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    compListDeleteThisComponent: 'ce composant',
    compListSubItemsTitle: 'Sous-composants :',
    compListSubItemsSubtitle: 'Voir les ingrédients et composants qui constituent ce composant',
    compListSubColItemName: "Nom de l'\u00e9l\u00e9ment",
    compListSubColType: 'Type',
    compListSubColCategory: 'Catégorie',
    compListSubColUnits: "Nombre d'unités",
    compListSubColUnit: 'Unité',
    compListSubColCost: 'Coût (€)',
    compListNoComponentsFound: 'Aucun composant trouvé',
    compListNoComponentsMessage: 'Commencez par ajouter votre premier composant',
    compListTryAdjusting: 'Essayez d\'ajuster votre recherche ou vos filtres',

    // ComponentCreateView
    compCreateTitleCreate: 'Créer un composant',
    compCreateTitleEdit: 'Modifier le composant',
    compCreateSubtitleCreate: 'Construisez un composant réutilisable à partir d\'ingrédients et d\'autres composants',
    compCreateSubtitleEdit: 'Mettez à jour les détails et les ingrédients du composant',
    compCreateBack: 'Retour',
    compCreateSubItemsTitle: 'Sous-composants & Ingrédients',
    compCreateSubItemsSubtitleCreate: 'Ajoutez les ingrédients et composants qui constituent ce composant',
    compCreateSubItemsSubtitleEdit: 'Modifiez les ingrédients et composants qui constituent ce composant',
    compCreateAddIngredient: 'Ajouter un ingrédient',
    compCreateAddComponent: 'Ajouter un composant',
    compCreateStatTotalItems: 'Total éléments',
    compCreateStatSubItemsCost: 'Coût sous-éléments',
    compCreateStatFinalUnitCost: 'Coût unitaire final',
    compCreateEmptyTitle: 'Aucun élément ajouté',
    compCreateEmptySubtitle: 'Cliquez sur "Ajouter un ingrédient" ou "Ajouter un composant" pour construire ce composant',
    compCreateDetailsTitle: 'Détails du composant',
    compCreateDetailsSubtitle: 'Configurez les propriétés du composant',
    compCreateFieldName: 'Nom du composant',
    compCreateFieldNamePlaceholder: 'ex. : Steak haché, Sauce César',
    compCreateFieldCategory: 'Catégorie',
    compCreateFieldType: 'Type de composant',
    compCreateFieldUnit: 'Unité',
    compCreateFieldUnitsPerRecipe: 'Nombre d\'unités par recette',
    compCreateFieldUnitsHint: 'Combien d\'unités cette recette produit',
    compCreateFieldStorageType: 'Type de stockage',
    compCreateFieldReadyForSale: 'Prêt à la vente',
    compCreateFieldKitchenType: 'Cuisine',
    compKitchenCentral: 'Cuisine Centrale',
    compKitchenLocal: 'Cuisine Locale',
    compCreateCalcTitle: 'Coût unitaire calculé',
    compCreateCalcSubItems: 'Total sous-éléments :',
    compCreateCalcPerUnit: 'par unité',
    compCreateFieldAllergens: 'Allergènes',
    compCreateFieldDescription: 'Description (Optionnel)',
    compCreateFieldDescriptionPlaceholder: 'Ajoutez des notes de préparation, instructions de stockage ou autres détails...',
    compCreateSaveCreate: 'Créer le composant',
    compCreateSaveEdit: 'Mettre à jour le composant',
    compCreateIngrDrawerTitle: 'Sélectionner les ingrédients',
    compCreateIngrDrawerSubtitle: 'Choisissez des ingrédients dans la liste des prix du marché',
    compCreateIngrSearchPlaceholder: 'Rechercher des éléments...',
    compCreateCompDrawerTitle: 'Sélectionner les composants',
    compCreateCompDrawerSubtitle: 'Choisissez des composants dans la bibliothèque de composants',
    compCreateCompSearchPlaceholder: 'Rechercher des composants...',
    compCreateSubTableColType: 'Type',
    compCreateSubTableColName: 'Nom',
    compCreateSubTableColCategory: 'Catégorie',
    compCreateSubTableColUnits: 'Nombre d\'unités',
    compCreateSubTableColUnit: 'Unité',
    compCreateSubTableColCost: 'Coût (€)',
    compCreateSubTableColStorage: 'Stockage',
    compCreateSubTableColActions: 'Actions',
    compCreateCompColName: 'Nom',
    compCreateCompColType: 'Type',
    compCreateCompColCategory: 'Catégorie',
    compCreateCompColUnit: 'Unité',
    compCreateCompColUnitCost: 'Coût unitaire (€)',
    compCreateItemsSelected: 'éléments sélectionnés',
    compCreateAddSelected: 'Ajouter la sélection',
    compCreateCancel: 'Annuler',
    compCreateCalcUnits: 'unités',
    compCreateIngrTableColIngredient: 'Ingrédient',
    compCreateIngrTableColUnit: 'Unité',
    compCreateIngrTableColCostUnit: 'Coût/Unité',
    compCreateNewCategoryOption: '+ Créer une nouvelle catégorie',
    compCreateNewTypeOption: '+ Créer un nouveau type',
    compCreateNewCategoryDialogTitle: 'Créer une nouvelle catégorie',
    compCreateNewCategoryDialogSubtitle: 'Saisissez le nom de la nouvelle catégorie de composant.',
    compCreateNewCategoryDialogLabel: 'Nom de la catégorie',
    compCreateNewTypeDialogTitle: 'Créer un nouveau type',
    compCreateNewTypeDialogSubtitle: 'Saisissez le nom du nouveau type de composant.',
    compCreateNewTypeDialogLabel: 'Nom du type',
    compCreateDialogConfirm: 'Créer',
    compCreateDialogCancel: 'Annuler',
    // Menu Items Library
    menuItemLibTitle: 'Bibliothèque de Menu Items',
    menuItemLibSubtitle: 'Gérez vos menu items, prix et coûts',
    menuItemLibExportCsv: 'Exporter CSV',
    menuItemLibRefreshCosts: 'Actualiser les coûts',
    menuItemLibSyncCategories: 'Synchroniser les catégories',
    menuItemLibAddMenuItem: 'Ajouter un menu item',
    menuItemLibSearchPlaceholder: 'Rechercher des menu items par nom...',
    menuItemLibAllSpaces: 'Tous les espaces',
    menuItemLibAllTypes: 'Tous les types',
    menuItemLibAllCategories: 'Toutes les catégories',
    menuItemLibReadyStatus: 'Statut prêt',
    menuItemLibReadyAll: 'Tous',
    menuItemLibReadyYes: 'Oui',
    menuItemLibReadyNo: 'Non',
    menuItemLibMenuItem: 'menu item',
    menuItemLibMenuItems: 'menu items',
    menuItemLibFound: 'trouvé(s)',
    menuItemLibClearFilters: 'Effacer tous les filtres',
    menuItemLibNoDataFound: 'Aucun menu item trouvé',
    menuItemLibNoDataSubtitle: 'Essayez d\'ajuster votre recherche ou vos filtres.',
    menuItemLibTotalCost: 'Coût total',
    menuItemLibTotalPrice: 'Prix total',
    menuItemLibAvgMargin: 'Marge moy.',
    menuItemLibItems: 'éléments',
    menuItemLibColPicture: 'Image',
    menuItemLibColName: 'Nom',
    menuItemLibColCategory: 'Catégorie',
    menuItemLibColReady: 'Prêt',
    menuItemLibColCombo: 'Combo',
    menuItemLibColPrice: 'Prix',
    menuItemLibColTotalCost: 'Coût / pièce',
    menuItemLibColMargin: 'Marge %',
    menuItemLibColDiet: 'Régime',
    menuItemLibColStorage: 'Stockage',
    menuItemLibColActions: 'Actions',
    menuItemLibReady: 'Prêt',
    menuItemLibNotReady: 'Pas prêt',
    menuItemLibCombo: 'Combo',
    menuItemLibEdit: 'Modifier',
    menuItemLibThisMenuItem: 'ce menu item',
    menuItemLibDeleteTitle: 'Supprimer le menu item',
    menuItemLibDeleteSubtitle: 'Cette action est irréversible.',
    menuItemLibDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    menuItemLibDeleteBtn: 'Supprimer le menu item',
    // Menu Item CSV Import
    menuItemImportTitle: 'Importer des articles',
    menuItemImportStep1: 'Fichier',
    menuItemImportStep2: 'Aperçu',
    menuItemImportStep3: 'Résultat',
    menuItemImportStep1Desc: 'Choisissez un fichier CSV',
    menuItemImportStep2Desc: 'Vérifiez les données',
    menuItemImportStep3Desc: 'Import terminé',
    menuItemImportDropzone: 'Glissez un fichier CSV ici',
    menuItemImportDropzoneOr: 'ou cliquez pour parcourir',
    menuItemImportChooseFile: 'Choisir un fichier',
    menuItemImportKnownCols: 'Colonnes reconnues',
    menuItemImportRequired: 'requis',
    menuItemImportFormatDesc: 'Première ligne = en-têtes · Séparateur virgule · Encodage UTF-8',
    menuItemImportBack: 'Retour',
    menuItemImportCancel: 'Annuler',
    menuItemImportClose: 'Fermer',
    menuItemImportRun: 'Importer',
    menuItemImportPreviewFile: 'Lignes valides',
    menuItemImportErrors: 'erreurs',
    menuItemImportSkipped: 'ligne(s) ignorée(s) (champ "name" manquant).',
    menuItemImportInProgress: 'Import en cours…',
    menuItemImportSuccess: 'Import réussi',
    menuItemImportError: 'Erreur lors de l\'import',
    menuItemImportMoreRows: 'autres articles',
    menuItemImportValid: 'valide(s)',
    menuItemImportItems: 'article(s) importé(s)',
    // Menu Item Create/Edit
    menuItemCreateTitle: 'Créer un nouveau menu item',
    menuItemCreateEditTitle: 'Modifier le menu item',
    menuItemCreateSubtitle: 'Construisez un menu item à partir de composants et d\'ingrédients',
    menuItemCreateEditSubtitle: 'Mettez à jour les détails de votre menu item',
    menuItemCreateCancel: 'Retour',
    menuItemCreateSave: 'Créer le menu item',
    menuItemCreateSaveEdit: 'Mettre à jour le menu item',
    menuItemCreateComponentsTitle: 'Composants & Ingrédients',
    menuItemCreateAddIngredient: 'Ajouter un ingrédient',
    menuItemCreateAddComponent: 'Ajouter un composant',
    menuItemCreateAddComboItem: 'Ajouter un combo',
    menuItemCreateAddPackaging: 'Ajouter un emballage',
    menuItemCreateNoItems: 'Aucun composant ou ingrédient ajouté. Cliquez sur "Ajouter un composant" ou "Ajouter un ingrédient" pour commencer.',
    menuItemCreateIngrTitle: 'Ajouter un ingrédient',
    menuItemCreateIngrSubtitle: 'Sélectionner des ingrédients depuis vos prix du marché',
    menuItemCreateIngrSearchPlaceholder: 'Rechercher un ingrédient...',
    menuItemCreateIngrNoData: 'Aucun ingrédient trouvé',
    menuItemCreateIngrAddBtn: 'Ajouter',
    menuItemCreateCancel: 'Annuler',
    menuItemCreateClose: 'Fermer',
    menuItemCreatePkgTitle: 'Ajouter un emballage',
    menuItemCreatePkgSubtitle: 'Sélectionner des emballages depuis votre inventaire',
    menuItemCreatePkgSearchPlaceholder: 'Rechercher un emballage...',
    menuItemCreatePkgNoData: 'Aucun emballage trouvé',
    menuItemCreatePkgAddBtn: 'Ajouter',
    menuItemCreateColName: 'Nom',
    menuItemCreateColType: 'Type',
    menuItemCreateColCategory: 'Catégorie',
    menuItemCreateColUnit: 'Unité',
    menuItemCreateColQuantity: 'Quantité',
    menuItemCreateColUnitCost: 'Coût unitaire',
    menuItemCreateColTotalCost: 'Coût total',
    menuItemCreateColStorage: 'Stockage',
    menuItemCreateColActions: 'Actions',
    menuItemCreateDetailsTitle: 'Détails du menu item',
    menuItemCreateLabelPicture: 'Image',
    menuItemCreateUploadPicture: 'Télécharger une image',
    menuItemCreateLabelName: 'Nom',
    menuItemCreateNamePlaceholder: 'ex. Burger classique',
    menuItemCreateLabelSpace: 'Espace',
    menuItemCreateSpacePlaceholder: 'Sélectionner des espaces...',
    menuItemCreateSpacesNoneSelected: 'Aucun espace sélectionné',
    menuItemCreateSpacesCount: 'espace(s) sélectionné(s)',
    menuItemCreateSpacesDrawerTitle: 'Espaces',
    menuItemCreateSpacesDrawerSubtitle: 'Sélectionnez les espaces et définissez le prix pour chacun',
    menuItemCreateSpacesDrawerSearch: 'Rechercher un espace...',
    menuItemCreateSpacesDrawerNoData: 'Aucun espace trouvé',
    menuItemCreateSpacesDrawerPriceLabel: 'Prix dans cet espace',
    menuItemCreateSpacesDrawerDept: 'Dpt.',
    menuItemCreateSpacesDrawerConfirm: 'Confirmer',
    menuItemCreateLabelBrand: 'Marque',
    menuItemCreateBrandPlaceholder: 'Sélectionner une marque...',
    menuItemCreateLabelType: 'Type Menu Item',
    menuItemCreateTypePlaceholder: 'Sélectionner un type Menu Item...',
    menuItemCreateLabelCategory: 'Catégorie Menu Item',
    menuItemCreateCategoryPlaceholder: 'Sélectionner une catégorie Menu Item...',
    menuItemCreateLabelReady: 'Prêt à vendre',
    menuItemCreateInventoryInfo: 'Informations de stock',
    menuItemCreatePackagingType: 'Type d\'emballage',
    menuItemCreateNumberOfUnits: 'Nombre d\'unités',
    menuItemCreateNone: 'Aucun',
    menuItemCreateLabelCombo: 'Article combo',
    menuItemCreateLabelBasePrice: 'Prix de base (€) *',
    menuItemCreateBasePriceHint: 'Veuillez sélectionner des espaces ci-dessus pour définir des prix spécifiques',
    menuItemCreateSummaryTotalCost: 'Coût total par pièce :',
    menuItemCreateSummaryBasePrice: 'Prix de base :',
    menuItemCreateSummaryMargin: 'Marge :',
    menuItemCreateLabelStorage: 'Type de stockage',
    menuItemCreateStorageDry: 'Sec',
    menuItemCreateStorageCold: 'Froid',
    menuItemCreateStorageFreezer: 'Congélateur',
    menuItemCreateLabelDiet: 'Régime alimentaire',
    menuItemCreateDietVegan: 'Végan',
    menuItemCreateDietVegetarian: 'Végétarien',
    menuItemCreateDietHalal: 'Halal',
    menuItemCreateDietKosher: 'Kosher',
    menuItemCreateDietHot: 'Chaud',
    menuItemCreateLabelDescription: 'Description',
    menuItemCreateDescriptionPlaceholder: 'Description optionnelle du menu item...',
    menuItemCreateIngrTitle: 'Sélectionner les ingrédients',
    menuItemCreateIngrSubtitle: 'Choisissez des ingrédients dans la liste des prix du marché',
    menuItemCreateIngrSearchPlaceholder: 'Rechercher des éléments...',
    menuItemCreateIngrNoData: 'Aucun ingrédient trouvé',
    menuItemCreateIngrColIngredient: 'Ingrédient',
    menuItemCreateIngrColUnit: 'Unité',
    menuItemCreateIngrColCostUnit: 'Coût/Unité',
    menuItemCreateIngrAddBtn: 'Ajouter',
    menuItemCreateIngrItem: 'Élément',
    menuItemCreateIngrItems: 'Éléments',
    menuItemCreateCompTitle: 'Sélectionner les composants',
    menuItemCreateCompSubtitle: 'Choisissez des composants dans la bibliothèque de composants',
    menuItemCreateCompSearchPlaceholder: 'Rechercher des composants...',
    menuItemCreateCompAddBtn: 'Ajouter la sélection',
    menuItemCreatePkgTitle: 'Sélectionner les emballages',
    menuItemCreatePkgSubtitle: 'Choisissez des emballages dans la liste des prix du marché',
    menuItemCreatePkgSearchPlaceholder: 'Rechercher des emballages...',
    menuItemCreatePkgNoData: 'Aucun emballage trouvé',
    menuItemCreatePkgColName: 'Nom',
    menuItemCreatePkgColSupplier: 'Fournisseur',
    menuItemCreatePkgColUnit: 'Unité',
    menuItemCreatePkgColCostUnit: 'Coût/Unité',
    menuItemCreatePkgAddBtn: 'Ajouter la sélection',
    menuItemCreateTypeCreateOption: '+ Créer un type de produit',
    menuItemCreateCategoryCreateOption: '+ Créer une catégorie de produit',
    menuItemCreateTypeDialogTitle: 'Créer un type Menu Item',
    menuItemCreateTypeDialogSubtitle: 'Ajouter un nouveau type Menu Item',
    menuItemCreateTypeDialogLabel: 'Nom du type *',
    menuItemCreateTypeDialogPlaceholder: 'Ex: Boisson, Nourriture...',
    menuItemCreateTypeDialogCancel: 'Annuler',
    menuItemCreateTypeDialogCreate: 'Créer',
    menuItemCreateCategoryDialogTitle: 'Créer une catégorie Menu Item',
    menuItemCreateCategoryDialogSubtitle: 'Ajouter une nouvelle catégorie Menu Item',
    menuItemCreateCategoryDialogTypeLabel: 'Type :',
    menuItemCreateCategoryDialogLabel: 'Nom de la catégorie *',
    menuItemCreateCategoryDialogPlaceholder: 'Ex: Jus, Snack...',
    menuItemCreateCategoryDialogCancel: 'Annuler',
    menuItemCreateCategoryDialogCreate: 'Créer',
    menuItemCreateUnsavedTitle: 'Modifications non enregistrées',
    menuItemCreateUnsavedMessage: 'Vous avez des modifications non enregistrées. Que souhaitez-vous faire ?',
    menuItemCreateLeaveWithoutSaving: 'Continuer sans sauvegarder',
    menuItemCreateSaveAndLeave: 'Continuer et sauvegarder',

    // Event Types
    eventTypeListTitle: 'Types d\'Événements',
    eventTypeListSubtitle: 'Définissez et gérez les différents types d\'événements',
    eventTypeListExportCsv: 'Export CSV',
    eventTypeListImportCsv: 'Import CSV',
    eventTypeListNewType: 'Nouveau Type',
    eventTypeListSearchPlaceholder: 'Rechercher un type d\'événement...',
    eventTypeListColName: 'Nom',
    eventTypeListColCategories: 'Catégories',
    eventTypeListColCreatedAt: 'Créé le',
    eventTypeListColUpdatedAt: 'Mis à jour',
    eventTypeListColActions: 'Actions',
    eventTypeListDrawerCreateTitle: 'Nouveau type d\'événement',
    eventTypeListDrawerCreateSubtitle: 'Renseignez les informations ci-dessous pour créer un nouveau type',
    eventTypeListDrawerEditTitle: 'Modifier le type d\'événement',
    eventTypeListDrawerEditSubtitle: 'Modifiez les informations de ce type d\'événement',
    eventTypeListLabelName: 'Nom du type *',
    eventTypeListNamePlaceholder: 'ex : Concert, Sport...',
    eventTypeListSave: 'Enregistrer',
    eventTypeListCancel: 'Annuler',
    // Event Category List
    eventCategoryListTitle: 'Catégories d\'Événements',
    eventCategoryListSubtitle: 'Gérez et organisez toutes vos catégories d\'événements',
    eventCategoryListExportCsv: 'Export CSV',
    eventCategoryListImportCsv: 'Import CSV',
    eventCategoryListNewCategory: 'Nouvelle Catégorie',
    eventCategoryListSearchPlaceholder: 'Rechercher une catégorie...',
    eventCategoryListColName: 'Nom',
    eventCategoryListColType: 'Type d\'événement',
    eventCategoryListColHomeTeam: 'Équipe à domicile',
    eventCategoryListColActions: 'Actions',
    eventCategoryListDrawerCreateTitle: 'Nouvelle catégorie d\'événement',
    eventCategoryListDrawerCreateSubtitle: 'Renseignez les informations ci-dessous pour créer une nouvelle catégorie',
    eventCategoryListDrawerEditTitle: 'Modifier la catégorie',
    eventCategoryListDrawerEditSubtitle: 'Modifiez les informations de cette catégorie',
    eventCategoryListLabelName: 'Nom de la catégorie *',
    eventCategoryListNamePlaceholder: 'ex : Football, Musique...',
    eventCategoryListLabelEventType: 'Type d\'événement *',
    eventCategoryListSelectType: 'Sélectionner un type',
    eventCategoryListLabelHasHomeTeam: 'Équipe à domicile',
    eventCategoryListSave: 'Enregistrer',
    eventCategoryListCancel: 'Annuler',
    // Event Subcategory List
    eventSubcategoryListTitle: 'Sous-Catégories d\'Événements',
    eventSubcategoryListSubtitle: 'Organisez vos événements en sous-catégories détaillées',
    eventSubcategoryListExportCsv: 'Export CSV',
    eventSubcategoryListImportCsv: 'Import CSV',
    eventSubcategoryListNewSubcategory: 'Nouvelle Sous-Catégorie',
    eventSubcategoryListSearchPlaceholder: 'Rechercher une sous-catégorie...',
    eventSubcategoryListColName: 'Nom',
    eventSubcategoryListColCategory: 'Catégorie d\'événement',
    eventSubcategoryListColActions: 'Actions',
    eventSubcategoryListDrawerCreateTitle: 'Nouvelle sous-catégorie d\'événement',
    eventSubcategoryListDrawerCreateSubtitle: 'Renseignez les informations ci-dessous pour créer une nouvelle sous-catégorie',
    eventSubcategoryListDrawerEditTitle: 'Modifier la sous-catégorie',
    eventSubcategoryListDrawerEditSubtitle: 'Modifiez les informations de cette sous-catégorie',
    eventSubcategoryListLabelName: 'Nom de la sous-catégorie *',
    eventSubcategoryListNamePlaceholder: 'ex : Finale, Phase de groupes...',
    eventSubcategoryListLabelCategory: 'Catégorie d\'événement *',
    eventSubcategoryListSelectCategory: 'Sélectionner une catégorie',
    eventSubcategoryListSave: 'Enregistrer',
    eventSubcategoryListCancel: 'Annuler',
    // Event Type Dialog
    eventTypeDialogTitle: 'Créer un type d\'événement',
    eventTypeDialogSubtitle: 'Formulaire de création d\'un nouveau type',
    eventTypeDialogNameLabel: 'Nom du type *',
    eventTypeDialogNamePlaceholder: 'Ex : Concert, Sport...',
    eventTypeDialogSave: 'Enregistrer',
    eventTypeDialogCancel: 'Annuler',
    // Event Category Dialog
    eventCategoryDialogTitle: 'Créer une catégorie d\'événement',
    eventCategoryDialogSubtitle: 'Formulaire de création d\'une nouvelle catégorie',
    eventCategoryDialogTypeLabel: 'Type d\'événement *',
    eventCategoryDialogTypePlaceholder: 'Sélectionner un type',
    eventCategoryDialogNameLabel: 'Nom de la catégorie *',
    eventCategoryDialogNamePlaceholder: 'Ex : Football, Musique...',
    eventCategoryDialogHasHomeTeam: 'Équipe à domicile',
    eventCategoryDialogSave: 'Enregistrer',
    eventCategoryDialogCancel: 'Annuler',
    // Event Subcategory Dialog
    eventSubcategoryDialogTitle: 'Créer une sous-catégorie d\'événement',
    eventSubcategoryDialogSubtitle: 'Formulaire de création d\'une nouvelle sous-catégorie',
    eventSubcategoryDialogCategoryLabel: 'Catégorie d\'événement *',
    eventSubcategoryDialogCategoryPlaceholder: 'Sélectionner une catégorie',
    eventSubcategoryDialogNameLabel: 'Nom de la sous-catégorie *',
    eventSubcategoryDialogNamePlaceholder: 'Ex : Finale, Phase de groupes...',
    eventSubcategoryDialogSave: 'Enregistrer',
    eventSubcategoryDialogCancel: 'Annuler',
    // Events List
    eventsListTitle: "Bibliothèque d'Événements",
    eventsListSubtitle: 'Gérez tous vos événements en un seul endroit',
    eventsListExportCsv: 'Export CSV',
    eventsListImportCsv: 'Import CSV',
    eventsListCalculateRevenue: 'Calculer Revenus',
    eventsListNewEvent: 'Nouvel Événement',
    eventsListSearchPlaceholder: 'Rechercher un événement...',
    eventsListAllLocations: 'Tous les lieux',
    eventsListColSpace: 'Espace',
    eventsListColDate: 'Date',
    eventsListColName: "Nom de l'événement",
    eventsListColType: 'Type',
    eventsListColCategory: 'Catégorie',
    eventsListColSubcategory: 'Sous-catégorie',
    eventsListColStatus: 'Statut',
    eventsListColRevenue: 'Revenu',
    eventsListColTransactions: 'Transactions',
    eventsListColActions: 'Actions',
    eventsListDrawerCreateTitle: 'Nouvel événement',
    eventsListDrawerCreateSubtitle: 'Renseignez les informations ci-dessous pour créer un nouvel événement',
    eventsListDrawerEditTitle: "Modifier l'événement",
    eventsListDrawerEditSubtitle: 'Modifiez les informations de cet événement',
    eventsListLabelName: "Nom de l'événement",
    eventsListNamePlaceholder: "Entrez le nom de l'événement",
    eventsListLabelSpace: 'Espace',
    eventsListSelectSpace: 'Sélectionner un espace',
    eventsListLabelStartDate: 'Date de début',
    eventsListLabelEndDate: 'Date de fin',
    eventsListLabelEndTime: 'Heure de fin',
    eventsListLabelEventType: "Type d'événement",
    eventsListSelectType: 'Sélectionner un type',
    eventsListLabelCategory: "Catégorie d'événement",
    eventsListSelectCategory: 'Sélectionner une catégorie',
    eventsListLabelSubcategory: "Sous-catégorie d'événement",
    eventsListSelectSubcategory: 'Sélectionner une sous-catégorie',
    eventsListLabelSessions: 'Nombre de sessions',
    eventsListLabelSessionsDetail: 'Sessions',
    eventsListLabelDoorsOpening: 'Ouverture des portes',
    eventsListLabelShowTime: 'Heure du spectacle',
    eventsListLabelOptions: "Options de l'événement",
    eventsListLabelOpeningAct: "Acte d'ouverture",
    eventsListLabelOpeningActDesc: "L'événement a-t-il un acte d'ouverture ?",
    eventsListLabelIntermission: 'Entracte',
    eventsListLabelIntermissionDesc: "L'événement a-t-il un entracte ?",
    eventsListSave: 'Enregistrer',
    eventsListCancel: 'Annuler',

    // Product Type List
    productTypeListTitle: 'Menu Item Types',
    productTypeListSubtitle: 'Gérez vos types de produits et classifications',
    productTypeListAddType: 'Ajouter un type',
    productTypeListTotalTypes: 'Total des types',
    productTypeListSearchPlaceholder: 'Rechercher des types par nom...',
    productTypeListCategory: 'catégorie',
    productTypeListCategories: 'catégories',
    productTypeListNoCategories: 'Aucune catégorie',
    productTypeListColName: 'Nom',
    productTypeListColCategories: 'Catégories',
    productTypeListColCreated: 'Créé',
    productTypeListColActions: 'Actions',
    productTypeListDialogCreateTitle: 'Ajouter un type',
    productTypeListDialogCreateSubtitle: 'Créer un nouveau type de produit',
    productTypeListDialogEditTitle: 'Modifier le type',
    productTypeListDialogEditSubtitle: 'Mettre à jour les détails du type',
    productTypeListLabelName: 'Nom *',
    productTypeListNamePlaceholder: 'Saisir le nom du type',
    productTypeListCancel: 'Annuler',
    productTypeListSave: 'Enregistrer',
    productTypeListCreate: 'Créer',
    productTypeListDeleteTitle: 'Supprimer le type',
    productTypeListDeleteSubtitle: 'Cette action est irréversible.',
    productTypeListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    productTypeListDelete: 'Supprimer',
    productTypeListCategoriesTitle: 'Catégories pour',
    productTypeListClose: 'Fermer',
    productTypeListNoCategoriesFound: 'Aucune catégorie trouvée',

    // Product Category List
    productCategoryListTitle: 'Menu Item Categories',
    productCategoryListSubtitle: 'Gérez vos catégories de produits et leurs types',
    productCategoryListAddCategory: 'Ajouter une catégorie',
    productCategoryListTotalCategories: 'Total des catégories',
    productCategoryListSearchPlaceholder: 'Rechercher des catégories par nom...',
    productCategoryListNoType: 'Aucun type',
    productCategoryListColName: 'Nom',
    productCategoryListColType: 'Type',
    productCategoryListColCreated: 'Créé',
    productCategoryListColActions: 'Actions',
    productCategoryListDialogCreateTitle: 'Ajouter une catégorie',
    productCategoryListDialogCreateSubtitle: 'Créer une nouvelle catégorie de produit',
    productCategoryListDialogEditTitle: 'Modifier la catégorie',
    productCategoryListDialogEditSubtitle: 'Mettre à jour les détails de la catégorie',
    productCategoryListLabelType: 'Type *',
    productCategoryListSelectType: 'Sélectionner le type',
    productCategoryListLabelName: 'Nom *',
    productCategoryListNamePlaceholder: 'Saisir le nom de la catégorie',
    productCategoryListCancel: 'Annuler',
    productCategoryListSave: 'Enregistrer',
    productCategoryListCreate: 'Créer',
    productCategoryListDeleteTitle: 'Supprimer la catégorie',
    productCategoryListDeleteSubtitle: 'Cette action est irréversible.',
    productCategoryListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    productCategoryListDelete: 'Supprimer',

    // Market Price Types
    marketPriceTypeListTitle: 'Good Types',
    marketPriceTypeListSubtitle: 'Gérez vos types Market Price et classifications',
    marketPriceTypeListAddType: 'Ajouter un type',
    marketPriceTypeListTotalTypes: 'Total des types',
    marketPriceTypeListSearchPlaceholder: 'Rechercher des types par nom...',
    marketPriceTypeListCategory: 'catégorie',
    marketPriceTypeListCategories: 'catégories',
    marketPriceTypeListNoCategories: 'Aucune catégorie',
    marketPriceTypeListColName: 'Nom',
    marketPriceTypeListColCategories: 'Catégories',
    marketPriceTypeListColCreated: 'Créé',
    marketPriceTypeListColActions: 'Actions',
    marketPriceTypeListDialogCreateTitle: 'Ajouter un type',
    marketPriceTypeListDialogCreateSubtitle: 'Créer un nouveau type Market Price',
    marketPriceTypeListDialogEditTitle: 'Modifier le type',
    marketPriceTypeListDialogEditSubtitle: 'Mettre à jour les détails du type',
    marketPriceTypeListLabelName: 'Nom *',
    marketPriceTypeListNamePlaceholder: 'Saisir le nom du type',
    marketPriceTypeListCancel: 'Annuler',
    marketPriceTypeListSave: 'Enregistrer',
    marketPriceTypeListCreate: 'Créer',
    marketPriceTypeListDeleteTitle: 'Supprimer le type',
    marketPriceTypeListDeleteSubtitle: 'Cette action est irréversible.',
    marketPriceTypeListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    marketPriceTypeListDelete: 'Supprimer',
    marketPriceTypeListCategoriesTitle: 'Catégories pour',
    marketPriceTypeListClose: 'Fermer',
    marketPriceTypeListNoCategoriesFound: 'Aucune catégorie trouvée',

    // Market Price Categories
    marketPriceCategoryListTitle: 'Good Categories',
    marketPriceCategoryListSubtitle: 'Gérez vos catégories Market Price et leurs types',
    marketPriceCategoryListAddCategory: 'Ajouter une catégorie',
    marketPriceCategoryListTotalCategories: 'Total des catégories',
    marketPriceCategoryListSearchPlaceholder: 'Rechercher des catégories par nom...',
    marketPriceCategoryListNoType: 'Aucun type',
    marketPriceCategoryListColName: 'Nom',
    marketPriceCategoryListColType: 'Type',
    marketPriceCategoryListColCreated: 'Créé',
    marketPriceCategoryListColActions: 'Actions',
    marketPriceCategoryListDialogCreateTitle: 'Ajouter une catégorie',
    marketPriceCategoryListDialogCreateSubtitle: 'Créer une nouvelle catégorie Market Price',
    marketPriceCategoryListDialogEditTitle: 'Modifier la catégorie',
    marketPriceCategoryListDialogEditSubtitle: 'Mettre à jour les détails de la catégorie',
    marketPriceCategoryListLabelType: 'Type *',
    marketPriceCategoryListSelectType: 'Sélectionner le type',
    marketPriceCategoryListLabelName: 'Nom *',
    marketPriceCategoryListNamePlaceholder: 'Saisir le nom de la catégorie',
    marketPriceCategoryListCancel: 'Annuler',
    marketPriceCategoryListSave: 'Enregistrer',
    marketPriceCategoryListCreate: 'Créer',
    marketPriceCategoryListDeleteTitle: 'Supprimer la catégorie',
    marketPriceCategoryListDeleteSubtitle: 'Cette action est irréversible.',
    marketPriceCategoryListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    marketPriceCategoryListDelete: 'Supprimer',

    // Component Types
    componentTypeListTitle: 'Component Types',
    componentTypeListSubtitle: 'Gérez vos types de composants et classifications',
    componentTypeListAddType: 'Ajouter un type',
    componentTypeListTotalTypes: 'Total des types',
    componentTypeListSearchPlaceholder: 'Rechercher des types par nom...',
    componentTypeListCategory: 'catégorie',
    componentTypeListCategories: 'catégories',
    componentTypeListNoCategories: 'Aucune catégorie',
    componentTypeListColName: 'Nom',
    componentTypeListColCategories: 'Catégories',
    componentTypeListColCreated: 'Créé',
    componentTypeListColActions: 'Actions',
    componentTypeListDialogCreateTitle: 'Ajouter un type',
    componentTypeListDialogCreateSubtitle: 'Créer un nouveau type de composant',
    componentTypeListDialogEditTitle: 'Modifier le type',
    componentTypeListDialogEditSubtitle: 'Mettre à jour les détails du type',
    componentTypeListLabelName: 'Nom *',
    componentTypeListNamePlaceholder: 'Saisir le nom du type',
    componentTypeListCancel: 'Annuler',
    componentTypeListSave: 'Enregistrer',
    componentTypeListCreate: 'Créer',
    componentTypeListDeleteTitle: 'Supprimer le type',
    componentTypeListDeleteSubtitle: 'Cette action est irréversible.',
    componentTypeListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    componentTypeListDelete: 'Supprimer',
    componentTypeListCategoriesTitle: 'Catégories pour',
    componentTypeListClose: 'Fermer',
    componentTypeListNoCategoriesFound: 'Aucune catégorie trouvée',

    // Component Categories
    componentCategoryListTitle: 'Component Categories',
    componentCategoryListSubtitle: 'Gérez vos catégories de composants et leurs types',
    componentCategoryListAddCategory: 'Ajouter une catégorie',
    componentCategoryListTotalCategories: 'Total des catégories',
    componentCategoryListSearchPlaceholder: 'Rechercher des catégories par nom...',
    componentCategoryListNoType: 'Aucun type',
    componentCategoryListColName: 'Nom',
    componentCategoryListColType: 'Type',
    componentCategoryListColCreated: 'Créé',
    componentCategoryListColActions: 'Actions',
    componentCategoryListDialogCreateTitle: 'Ajouter une catégorie',
    componentCategoryListDialogCreateSubtitle: 'Créer une nouvelle catégorie de composant',
    componentCategoryListDialogEditTitle: 'Modifier la catégorie',
    componentCategoryListDialogEditSubtitle: 'Mettre à jour les détails de la catégorie',
    componentCategoryListLabelType: 'Type *',
    componentCategoryListSelectType: 'Sélectionner le type',
    componentCategoryListLabelName: 'Nom *',
    componentCategoryListNamePlaceholder: 'Saisir le nom de la catégorie',
    componentCategoryListCancel: 'Annuler',
    componentCategoryListSave: 'Enregistrer',
    componentCategoryListCreate: 'Créer',
    componentCategoryListDeleteTitle: 'Supprimer la catégorie',
    componentCategoryListDeleteSubtitle: 'Cette action est irréversible.',
    componentCategoryListDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer',
    componentCategoryListDelete: 'Supprimer',

    // Space List
    spaceListTitle: 'Mes Espaces',
    spaceListSubtitle: 'Pilotez la performance de tous vos établissements F&B',
    spaceListNewSpace: 'Nouvel espace',
    spaceListSearchPlaceholder: 'Rechercher un espace...',
    spaceListTypePlaceholder: 'Type d\'espace',
    spaceListFilterSearch: 'Recherche',
    spaceListFilterType: 'Type',
    spaceListLoading: 'Chargement des espaces...',
    spaceListRetry: 'Réessayer',
    spaceListEmptyFound: 'Aucun espace trouvé',
    spaceListEmptyNone: 'Aucun espace disponible',
    spaceListEmptyFoundDesc: 'Essayez de modifier vos filtres de recherche',
    spaceListEmptyNoneDesc: 'Commencez par créer votre premier espace pour gérer vos établissements F&B',
    spaceListCreateFirst: 'Créer mon premier espace',
    spaceListResetFilters: 'Réinitialiser les filtres',
    spaceListCityUnknown: 'Ville non renseignée',
    spaceListTypeUnknown: 'Type non renseigné',
    spaceListStepInfo: 'Informations',
    spaceListStepAddress: 'Adresse',
    spaceListStepContact: 'Contact',
    spaceListStepSocial: 'Social',
    spaceListAddImage: 'Ajouter une image',
    spaceListImageHint: 'PNG, JPG · Max 5 MB',
    spaceListChangeImage: 'Cliquer pour changer l\'image',
    spaceListLabelName: 'Nom de l\'espace',
    spaceListLabelSpaceType: 'Type d\'espace',
    spaceListLabelDepartment: 'Département',
    spaceListLabelCapacity: 'Capacité max',
    spaceListLabelAddress: 'Adresse',
    spaceListLabelAddress2: 'Adresse 2',
    spaceListLabelCity: 'Ville',
    spaceListLabelPostcode: 'Code postal',
    spaceListLabelCountry: 'Pays',
    spaceListLabelEmail: 'Email',
    spaceListLabelPhone: 'Téléphone',
    spaceListLabelFullName: 'Nom complet',
    spaceListLabelContactEmail: 'Email du contact',
    spaceListLabelContactPhone: 'Téléphone',
    spaceListSocialTitle: 'Connectez vos réseaux pour plus de visibilité',
    spaceListBack: '< Retour',
    spaceListContinue: 'Continuer',
    spaceListDeleteTitle: 'Supprimer l\'espace',
    spaceListDeleteConfirm: 'Voulez-vous vraiment supprimer l\'espace',
    spaceListCancel: 'Annuler',
    spaceListDelete: 'Supprimer',
    spaceListDialogCreateTitle: 'Nouvel espace',
    spaceListDialogEditTitle: 'Modifier l\'espace',
    spaceListDialogSubmitCreate: 'Créer l\'espace',
    spaceListDialogSubmitEdit: 'Enregistrer',
    spaceListSubtitleStep0: 'Renseignez les informations principales de l\'espace',
    spaceListSubtitleStep1: 'Ajoutez l\'adresse de votre espace',
    spaceListSubtitleStep2: 'Ajoutez les informations de contact',
    spaceListSubtitleStep3: 'Ajoutez les liens vers vos réseaux (optionnel)',
    spaceListSortName: 'Nom (A-Z)',
    spaceListSortRevenue: 'Revenu (décroissant)',
    spaceListSortCapacity: 'Capacité (décroissant)',
    spaceListSortRecent: 'Récent',
    spaceListErrorCreate: 'Impossible de créer l\'espace',
    spaceListErrorLoad: 'Impossible de charger les espaces',
    spaceListErrorDelete: 'Impossible de supprimer l\'espace',
    spaceListDeleteSubtitle: 'Cette action est irréversible.',
    spaceListSpace: 'espace',
    spaceListSpaces: 'espaces',

    // Space Builder
    spaceBuilderNewSpace: 'Nouvel Espace',
    spaceBuilderNewConfig: 'Nouvelle configuration',
    spaceBuilderBack: 'Retour',
    spaceBuilderSave: 'Enregistrer',
    spaceBuilderSaveUpdate: 'Enregistrer les modifications',
    spaceBuilderSelectFloor: 'Sélectionnez un étage',
    spaceBuilderSelectFloorDesc: 'Choisissez un étage pour visualiser le plan',
    spaceBuilderNoElement: 'Aucun élément sélectionné',
    spaceBuilderNoElementDesc: 'Sélectionnez un élément dans le plan pour modifier ses propriétés',
    spaceBuilderFBShopsList: 'Shops F&B',
    spaceBuilderFBShopsListDesc: 'Cliquez sur un shop pour voir et modifier ses propriétés',
    spaceBuilderNoFBShops: 'Aucun shop F&B pour le moment',
    spaceBuilderElementsListDesc: 'Cliquez sur un élément pour voir et modifier ses propriétés',
    spaceBuilderNoElementsInCategory: 'Aucun élément dans cette catégorie pour le moment',
    spaceBuilderAllAreas: 'Toutes les Areas',
    spaceBuilderUnsavedTitle: 'Modifications non enregistrées',
    spaceBuilderUnsavedConfirmLeave: 'Vous avez des modifications non enregistrées. Que souhaitez-vous faire ?',
    spaceBuilderLeaveWithoutSaving: 'Continuer sans sauvegarder',
    spaceBuilderSaveAndLeave: 'Continuer et sauvegarder',
    spaceBuilderSaveDialogTitle: 'Enregistrer la configuration',
    spaceBuilderSaveDialogDesc: 'Donnez un nom à cette configuration pour la retrouver facilement.',
    spaceBuilderSaveDialogLabel: 'Nom de la configuration',
    spaceBuilderSaveDialogPlaceholder: 'Ex: Configuration Événement 2024',
    spaceBuilderSaveSuccess: 'Configuration "{name}" enregistrée avec succès !',
    spaceBuilderSaveError: 'Erreur lors de l\'enregistrement de la configuration',
    spaceBuilderLoadError: 'Erreur lors du chargement de la configuration',
    spaceBuilderRename: 'Renommer',
    spaceBuilderRenameDialogTitle: 'Renommer la configuration',
    spaceBuilderRenameDialogLabel: 'Nouveau nom',
    spaceBuilderSaving: 'Sauvegarde en cours…',
    spaceBuilderSavingWait: 'Veuillez patienter',
    elevationBuilder3DView: 'Vue 3D de l\'espace',
    elevationBuilderSearch: 'Rechercher un élément...',
    elevationBuilderResetView: 'Réinitialiser la vue',

    // Properties Panel
    ppProperties: 'Propriétés',
    ppImage: 'Image',
    ppDuplicate: 'Dupliquer',
    ppElementName: 'Nom de l\'élément',
    ppElementNamePlaceholder: 'Entrez le nom de l\'élément...',
    ppShopType: 'Type de shop',
    ppPerformanceMetrics: 'Indicateurs de performance',
    ppRevenue: 'Revenu',
    ppNumberOfPOS: 'Nombre de PDV',
    ppTransactions: 'Transactions',
    ppTransPerMin: 'Trans/Min',
    ppStaffCost: 'Coût du personnel',
    ppRevPerEmployee: 'Rev/Employé',
    ppMenu: 'Menu',
    ppSearchMenuItems: 'Rechercher des articles...',
    ppNoMenuItemsQuery: 'Aucun article trouvé pour',
    ppNoMenuItemsConfigured: 'Aucun article de menu configuré',
    ppGoToSpaceMenusConfigure: 'Accédez à Space Menus pour configurer',
    ppInventory: 'Inventaire',
    ppSearchInventory: 'Rechercher dans l\'inventaire...',
    ppInventoryItems: 'Articles d\'inventaire',
    ppUsedIn: 'Utilisé dans :',
    ppCustomInventoryItems: 'Articles personnalisés',
    ppNoCustomInventory: 'Aucun article personnalisé.',
    ppNoInventory: 'Aucun article d\'inventaire pour le moment.',
    ppStaffManagement: 'Gestion du personnel',
    ppStaffPositionPlaceholder: 'ex. Caissier, Cuisinier, Sécurité',
    ppNoStaffPositions: 'Aucun poste défini',
    ppAddStaffHint: 'Ajoutez-en un ci-dessus pour commencer',
    ppPositionDimensions: 'Position & Dimensions',
    ppPosition: 'Position',
    ppDimensions: 'Dimensions',
    ppXMeters: 'X (m)',
    ppYMeters: 'Y (m)',
    ppWidthMeters: 'Largeur (m)',
    ppDepthMeters: 'Profondeur (m)',
    ppHeightMeters: 'Hauteur (m)',
    ppCornerRadius: 'Rayon des coins',
    ppAllCorners: 'Tous les coins (m)',
    ppTopLeft: 'Haut gauche (m)',
    ppTopRight: 'Haut droite (m)',
    ppBottomLeft: 'Bas gauche (m)',
    ppBottomRight: 'Bas droite (m)',
    ppCalculations: 'Calculs',
    ppFloorArea: 'Surface au sol',
    ppVolume: 'Volume',
    ppConfiguration: 'Configuration',
    ppConfigurationDesc: 'Sélectionnez les configurations où cet élément doit apparaître',
    ppCurrent: '(actuelle)',
    ppShops: 'Shops',
    ppShopsDesc: 'Sélectionnez les éléments F&B qui utilisent ce stockage',
    ppShopsDescShop: 'Sélectionnez les éléments F&B associés',
    ppShopsDescKitchen: 'Sélectionnez les shops Food & Beverages desservis par cette cuisine',
    ppStorageType: 'Type de stockage',
    ppHospitalityType: 'Type d\'hospitalité',
    ppMerchType: 'Type de merch',
    ppAccessType: 'Type d\'accès',
    ppEntertainmentType: 'Type de divertissement',
    ppTicketingType: 'Type de billetterie',
    ppKitchenType: 'Type de cuisine',
    ppItems: 'Articles',
    ppItemsPlaceholder: 'ex. T-shirt, Casquette, Écharpe',
    ppNoItems: 'Aucun article pour le moment.',
    ppDeleteTitle: 'Supprimer l\'élément',
    ppDeleteDesc: 'Cette action est irréversible. Vous pouvez choisir de conserver les données historiques.',
    ppKeepHistoricalData: 'Conserver les données historiques',

    // Data Integration
    diTitle: 'Intégration de données',
    diFB: 'F&B',
    diFBIntegration: 'Intégration F&B',
    diAddIntegration: 'Ajouter une intégration',
    diNoIntegrations: 'Aucune intégration ajoutée',
    diNoIntegrationsHint: 'Cliquez sur "Ajouter une intégration" pour commencer',
    diReconfigure: 'Reconfigurer',
    diRemove: 'Supprimer',
    diConnected: 'Connecté',
    diCreated: 'Créé le',
    diOrg: 'Org',
    diFrom: 'Depuis',
    diUntil: "Jusqu'au",
    diSyncing: 'Synchronisation...',
    diSyncImport: 'Sync & Importer',
    diSyncHistory: 'Historique',
    diLinkSpace: 'Lier un espace',
    diLocations: 'Emplacements',
    diNoLocations: 'Aucun emplacement — lancez une synchronisation',
    diSpaces: 'Espace',
    diNoSpaces: 'Aucun espace lié — cliquez sur + pour configurer',
    diConfigureSpace: 'Configurer l\'espace',
    diLinkedSpace: 'Espace lié',
    diWeezeventLocations: 'Locations Weezevent (points de vente)',
    diInternalShops: 'Shops internes',
    diNoWeezeventLocations: 'Aucune location Weezevent trouvée pour cette intégration',
    diAssociateIntegrationToSpace: 'Associer cette intégration à un Espace DataFriday',
    diAssociateIntegrationToSpaceDesc: 'Sélectionnez ou créez un Espace représentant ce lieu (ex. Stade Français).',
    diAssociateLocationsToShops: 'Étape 2 : Associer les Locations aux Shops internes',
    diAssociateLocationsToShopsDesc: 'Mappez chaque point de vente Weezevent (location) à un élément de votre configuration.',
    diLocationColumn: 'Location (Weezevent)',
    diIntegrationLevelSpaceStep: 'Étape 1 : Lier à un Espace',
    diIntegrationLevelShopStep: 'Étape 2 : Mapper les Locations',
    diIntegrationNoLocations: 'Aucune location trouvée — lancez d\'abord un Sync & Import.',
    diIntegrationShopsSaved: 'Locations mappées avec succès',
    diIntegrationShopsSkipped: 'Locations non mappées ignorées',
    diNoSpaceMappedHint: 'Lancez Sync & Import, puis cliquez sur + pour lier cette intégration à un Espace.',
    diAddIntegrationTitle: 'Ajouter une intégration',
    diAddIntegrationDesc: 'Sélectionnez une intégration à ajouter à votre configuration F&B',
    diWeezeventDesc: 'Billetterie et cashless événementiel',
    diDigifoodDesc: 'Commande digitale de repas',
    diSoon: 'Bientôt',
    diConfigureDigifood: 'Configurer Digifood',
    diReconfigureDigifood: 'Reconfigurer Digifood',
    diDigifoodRealtime: 'Temps réel — webhooks',
    diDigifoodRealtimeHint: 'Les ventes arrivent automatiquement au fil de l\'eau. Aucun sync à lancer.',
    diDigifoodWebhookUrl: 'URL de webhook',
    diDigifoodWebhookUrlHint: 'Communiquez cette URL à Digifood pour activer l\'envoi des ventes en temps réel.',
    diDigifoodSecret: 'Secret webhook',
    diDigifoodSecretHint: 'Secret HMAC remis par Digifood (signature des webhooks).',
    diDigifoodSecretKeepPlaceholder: 'Laisser vide pour conserver le secret actuel',
    diDigifoodSecretRequired: 'Le secret webhook est requis',
    diDigifoodCheckReception: 'Vérifier la réception',
    diDigifoodLastWebhook: 'Dernier webhook reçu',
    diDigifoodNoWebhook: 'Aucun webhook reçu pour l\'instant — vérifiez le provisioning côté Digifood.',
    diDigifoodImportCsv: 'Importer un historique CSV',
    diDigifoodImportCsvTitle: 'Import d\'historique CSV',
    diDigifoodImportCsvHint: 'Amorce le catalogue et les points de vente avant les premières ventes webhook (ou rattrape un trou de réception). Aperçu d\'abord, rien n\'est écrit.',
    diDigifoodDryRunReport: 'Aperçu (aucune donnée écrite)',
    diDigifoodConfirmImport: 'Confirmer l\'import',
    diDigifoodImportDone: 'Import terminé',
    diDigifoodOrdersDetected: 'commandes détectées',
    diDigifoodOrdersCreated: 'nouvelles commandes',
    diDigifoodOrdersUpdated: 'déjà connues (mises à jour)',
    diDigifoodOrdersSkipped: 'ignorées',
    diDigifoodProductsCreated: 'nouveaux produits',
    diDigifoodLocationsCreated: 'nouveaux points de vente',
    diDigifoodRejectedRows: 'lignes rejetées',
    diDigifoodPosVersion: 'Version POS',
    diCopy: 'Copier',
    diCopied: 'Copié !',
    diDigifoodNoLocationsHint: 'Aucun point de vente encore reçu. Importez un historique CSV ou attendez les premières ventes webhook.',
    diDigifoodTemplateHint: 'Format attendu (ou mappez vos propres colonnes ci-dessous)',
    diDigifoodDownloadTemplate: 'Télécharger le modèle CSV',
    diDigifoodMappingTitle: 'Correspondance des colonnes',
    diDigifoodMappingHint: 'Associez les colonnes de votre fichier aux champs attendus — pré-rempli automatiquement, ajustez si besoin.',
    diDigifoodMappingIgnore: '— ignorer —',
    diDigifoodMappingRequired: 'Mappez les champs obligatoires : ID de commande, article, quantité, et un prix (unitaire en centimes OU total de ligne en €).',
    diDigifoodPeriodDetected: 'Période détectée',
    diDigifoodMappingBadHint: 'Aucune commande détectée — vos colonnes ne correspondent probablement pas. Vérifiez la correspondance ci-dessus puis relancez l\'aperçu.',
    diConfigureWeezevent: 'Configurer Weezevent',
    diReconfigureWeezevent: 'Reconfigurer Weezevent',
    diConfigureDesc: 'Entrez vos identifiants API Weezevent pour connecter votre compte.',
    diReconfigureDesc: 'Mettez à jour vos identifiants API Weezevent.',
    diInstanceName: 'Nom de l\'instance',
    diInstanceNamePlaceholder: 'ex. Hellfest 2025',
    diInstanceNameHint: 'Un label pour identifier cette intégration',
    diClientId: 'Client ID',
    diClientIdPlaceholder: 'ex. app_eat-is-family-datafriday_...',
    diClientSecret: 'Client Secret',
    diClientSecretPlaceholder: 'ex. votre-client-secret',
    diClientSecretKeepPlaceholder: 'Laisser vide pour conserver le secret actuel',
    diOrgId: 'ID Organisation',
    diOrgIdPlaceholder: 'ex. 182509',
    diConnectionSuccess: 'Connexion à Weezevent établie avec succès',
    diConfigSaved: 'Configuration enregistrée ! Importation en cours...',
    diConfigUpdated: 'Configuration mise à jour !',
    diTestConnection: 'Tester la connexion',
    diSaveConnect: 'Enregistrer & Connecter',
    diUpdateSave: 'Mettre à jour & Enregistrer',
    diModifyCredentials: 'Modifier les identifiants',
    diClientIdRequired: 'Client ID et ID Organisation sont obligatoires',
    diClientSecretRequired: 'Client Secret est obligatoire',
    diConnectionFailed: 'Connexion échouée — vérifiez vos identifiants',
    diSaveFailed: 'Échec de l\'enregistrement de la configuration',

    // StepMapShops
    smsTitle: 'Étape 2 : Associer les Locations aux Shops internes',
    smsSubtitle: 'Mappez chaque location (point de vente) Weezevent à un shop interne de votre configuration.',
    smsMappedChip: 'mappées',
    smsAutoSuggestion: 'suggestion automatique',
    smsAutoSuggestions: 'suggestions automatiques',
    smsAutoSuggestionAvailable: 'disponible',
    smsApplyAll: 'Appliquer tout',
    smsMapped: 'Mappées',
    smsUnmapped: 'Non mappées',
    smsAll: 'Tous',
    smsColLocation: 'Location (Weezevent)',
    smsColShop: 'Shop interne (DataFriday)',
    smsColMatch: 'Match',
    smsSelectPlaceholder: 'Sélectionner...',
    smsCreateShopTitle: 'Créer un shop DataFriday',
    smsCreateShopDesc: 'Ce shop sera créé dans votre espace et mappé au shop Weezevent',
    smsShopName: 'Nom du shop',
    smsShopNameRequired: 'Nom requis',
    smsShopType: 'Type',
    smsCreateAndMap: 'Créer et mapper',
    smsCancel: 'Annuler',
    smmCreateTitle: 'Créer un article menu',
    smmCreateFor: 'Pour',
    smmCreateSectionId: 'Identification',
    smmCreateLabelName: "Nom de l'article",
    smmCreatePlaceholderName: 'Ex. Bière pression 50cl',
    smmCreateLabelType: 'Type',
    smmCreateLabelCategory: 'Catégorie',
    smmCreateChoose: '— Choisir —',
    smmCreateSectionPrice: 'Prix de vente',
    smmCreateLabelPrice: 'Prix (€)',
    smmCreatePlaceholderPrice: '0.00',
    smmCreateLabelPriceTtc: 'Prix TTC (€)',
    smmCreateLabelVat: 'TVA (%)',
    smmCreateVatPlaceholder: 'Défaut tenant',
    smmCreateLabelDiscountType: 'Remise',
    smmCreateLabelDiscountValue: 'Valeur remise',
    smmCreateDiscountNone: 'Aucune',
    smmCreateDiscountPercent: 'Pourcentage',
    smmCreateDiscountAmount: 'Montant (€)',
    smmPriceGrossTtc: 'TTC brut',
    smmPriceDiscount: 'Remise',
    smmPriceNetTtc: 'TTC net',
    smmPriceHt: 'dont HT',
    smmPriceVat: 'dont TVA',
    smmPriceVatUnknown: 'Saisissez un taux de TVA pour voir la décomposition HT / taxe (sinon le défaut tenant s\'applique côté serveur).',
    smmCreateConfirm: 'Créer et mapper',
    smmCreateCancel: 'Annuler',
    smsSkipUnmapped: 'Ignorer les non-mappés',
    smsSave: 'Sauvegarder',
    smsNoMerchants: 'Aucune location (point de vente) trouvée. Lancez d\'abord un Sync & Import.',
    smsShopGeneric: 'Shop générique',
    smsShopFnbFood: 'Food & Beverage - Nourriture',
    smsShopFnbBeverages: 'Food & Beverage - Boissons',
    smsShopFnbBar: 'Food & Beverage - Bar',
    smsShopFnbSnack: 'Food & Beverage - Snacks',
    smsShopFnbIcecream: 'Food & Beverage - Glaces',
    smsShopMerch: 'Merchandising',

    // Types de PdV canoniques (Analyse) — alignés sur l'enum Space Menu
    anShopTypeFood: 'Nourriture',
    anShopTypeBeverages: 'Boissons',
    anShopTypeBeer: 'Bière',
    anShopTypeGpPremium: 'GP Premium',
    anShopTypeTemporary: 'Temporaire',
    anShopTypeDrinkee: 'Drinkee',
    anShopTypeOther: 'Autre',
    anWeezeventUnmatchedToast: '{n} produit(s) Weezevent sans catégorie app — catégories incomplètes',
    anUnmatchedItems: 'Non rattachés',
    anUnmatchedShops: 'PdV non rattachés',
    anUnmatchedCoverageToast: '{n} vente(s) non rattachée(s) au catalogue DataFriday · {pct}% de couverture',
    anNoEventsForConfig: 'Aucun event rattaché à cette configuration.',
    anCatalogLoadError: 'Impossible de charger le catalogue.',
    anCatalogLoading: 'Chargement du catalogue…',
    anCatalogNoConfig: 'Aucune configuration exploitable.',
    anCatalogNoShops: 'Aucun point de vente disponible pour cette configuration.',
    anCatalogNoItems: 'Aucun article disponible pour cette configuration.',
    anRetry: 'Réessayer',
    anNoComparisonData: 'Pas de données N-1 / période précédente sur la période',
    anComparisonNeedsDates: 'Saisissez les dates de début et de fin pour comparer',
    anNoItemData: 'Pas de données article sur cette période',
    diImportHistory: "Importer l'historique (N-1)",
    anOpenMenuItem: "Ouvrir l'article (vérifier le mapping)",

    // Module Analyse
    anConfiguration: 'Configuration',
    anTools: 'Outils',
    anToolAnalyse: 'Analyse',
    anToolPredict: 'Prédire',
    anToolEventPredict: 'Préd. Événement',
    anToolInventory: 'Inventaire',
    anToolLogistic: 'Logistique',
    anToolRestock: 'Réarmement',
    anEvents: 'Événements',
    anAll: 'Tous',
    anNone: 'Aucun',
    anDates: 'Dates',
    anStartDate: 'Date de début',
    anEndDate: 'Date de fin',
    anAttendance: 'Affluence',
    anTicketsSold: 'Billets vendus',
    anTicketsScanned: 'Billets scannés',
    anAdvancedFilters: 'Filtres avancés',
    anEventCategory: "Catégorie d'événement",
    anEventType: "Type d'événement",
    anTeam: 'Équipe',
    anSponsor: 'Sponsor',
    anSubcategory: 'Sous-catégorie',
    anSessions: 'Sessions',
    anDoorsOpening: 'Ouverture des portes',
    anShowTime: 'Horaire du show',
    anVisitingTeam: 'Équipe visiteur',
    anPerformer: 'Performer',
    anOpeningAct: 'Première partie',
    anIntermission: "Entr'acte",
    anYes: 'Oui',
    anNo: 'Non',
    anComparisonMode: 'Mode de comparaison',
    anCopyImage: 'Copier en image',
    anShowActiveFilters: 'Afficher les filtres actifs',
    anShops: 'Points de vente',
    anShopTypes: 'Types de PdV',
    anTypes: 'Types',
    anZones: 'Zones',
    anMenuItems: 'Articles du menu',
    anItems: 'Articles',
    anTypeCategory: 'Type & Catégorie',
    anItemType: 'Type (Nourriture/Boissons/Verres)',
    anCategory: 'Catégorie',
    anComparison: 'Comparaison',
    anPrevPeriod: 'Période préc.',
    anYearOverYear: 'Gliss. ann.',
    anResetFilters: 'Réinitialiser les filtres',
    anAllConfigurations: 'Toutes les configurations',
    anScheduled: 'Prévu',
    anSearchEvent: 'Rechercher un événement...',
    anSearchShop: 'Rechercher un PdV...',
    anActiveFilters: 'Filtres actifs',
    anNoActiveFilters: 'Aucun filtre actif. Tous les évènements et points de vente sont inclus.',
    anResetAllFilters: 'Réinitialiser tous les filtres',
    anClose: 'Fermer',
    anFrom: 'Du',
    anRangeAll: "Tout l'historique",
    anRangeToday: "Aujourd'hui",
    anRangeYesterday: 'Hier',
    anRangeThisWeek: 'Cette semaine',
    anRangeLastWeek: 'Semaine dernière',
    anRangeThisMonth: 'Ce mois-ci',
    anRangeLastMonth: 'Mois dernier',
    anRangeNextMonth: 'Mois prochain',
    anRangeThisQuarter: 'Ce trimestre',
    anRangeLastQuarter: 'Trimestre dernier',
    anRangeNextQuarter: 'Trimestre prochain',
    anRangeThisYear: 'Cette année',
    anRangeLastYear: 'Année dernière',
    anRangeNextYear: 'Année prochaine',
    anRangeCustom: 'Période personnalisée',
    anRangeLast7Days: '7 derniers jours',
    anRangeLast30Days: '30 derniers jours',
    anRangeLast90Days: '90 derniers jours',
    anChipDates: 'Dates',
    anChipTimeRange: 'Plage horaire',
    anAlertsInsights: 'Alertes & insights',
    anMarkAllRead: 'Tout marquer lu',
    anNoAlerts: 'Aucune alerte. Tout va bien sur la période courante.',
    anCopy: 'Copier',
    anShare: 'Partager',
    anEventsSelected: 'événement(s) sélectionné(s)',
    anThisYear: 'Cette année',
    anClearAll: 'Tout effacer',
    anEventsPerformance: 'Performance des évènements',
    anCollapse: 'Réduire',
    anSeeAll: 'Voir tout',
    anSemanticMatch: 'Réponse trouvée par compréhension sémantique',
    anClear: 'Effacer',
    anAssistantTip: '💡 Tapez **aide** pour voir toutes les questions supportées.',
    anClick: 'Cliquer',
    anDataAnalysis: 'Analyse des données',
    anQueryPlaceholder: 'ex. : Quel est le CA...',
    anAnalyze: 'Analyser',
    anSmartUnderstanding: 'Compréhension intelligente',
    anSemanticTooltip: "Active un modèle d'IA local (Transformers.js, ~25 Mo) qui comprend les paraphrases. Téléchargé une seule fois, mis en cache. Aucune donnée envoyée à l'extérieur.",
    anModelDownloading: 'Téléchargement du modèle…',
    anShopPerformance: 'Performance des PdV',
    anTotal: 'Total',
    anAvg: 'Moy.',
    anUnits: 'unités',
    anPerEvent: '/ évén.',
    anSeeAllShops: 'Voir tous les PdV',
    anItemPerformance: 'Performance des articles',
    anCompareTo: 'Comparer à',
    anComparedToWindow: 'Comparé à :',
    anEventsWord: 'événements',
    anEditFilter: 'Éditer le filtre',
    anPrevious: 'Précédent',
    anLoading: 'Chargement…',
    anAvgPerEvent: 'Moy. par évén.',
    anMenuItemsByShop: 'Articles du menu par PdV',
    anSearchItemsByShop: 'Rechercher par PdV, type, catégorie ou article...',
    anGroupByItem: 'Regrouper par article',
    anGroupByShop: 'Regrouper par PdV',
    anByShop: 'Par PdV',
    anByItem: 'Par article',
    anScopeAll: 'Tous',
    anScopeShop: 'PdV',
    anScopeType: 'Type',
    anScopeCategory: 'Catégorie',
    anScopeItem: 'Article',
    anSearchByShop: 'Rechercher par PdV…',
    anSearchByType: 'Rechercher par type…',
    anSearchByCategory: 'Rechercher par catégorie…',
    anSearchByItem: 'Rechercher par article…',
    anAvgQty: 'Qté moy.',
    anTotalQty: 'Qté totale',
    anMenuItemDistTitle: 'Répartition du CA par article',
    anTotalRevenue: 'CA total',
    anQuantityMode: 'Quantité',
    anRevenueMode: 'CA',
    anCatTotal: 'CA total',
    anTopItemsByRevenue: 'Top articles par CA',
    anSubtitleItems: 'Top 10 sur {n} articles',
    anUnidentifiedItem: 'Article transactionnel non identifié',
    anByItemType: "Type d'article",
    anSubtitleTypes: '{n} types',
    anByItemCategory: "Catégorie d'article",
    anSubtitleCategories: '{n} catégories',
    anTypes: 'Types',
    anCategories: 'Catégories',
    anAllCategories: 'Toutes les catégories',
    anItem: 'Article',
    anType: 'Type',
    anQuantity: 'Quantité',
    anRevenue: 'CA',
    anShop: 'PdV',
    anPeriod: 'Période',
    anFoodBev: 'Restauration',
    anEventLabel: 'Évènement',
    anTo: 'Au',

    // Charts – Analyse
    // Metric labels (GenericByEventChart toggles)
    anMetricCA: 'CA',
    anMetricCost: 'Coût',
    anMetricTransactions: 'Transactions',
    anMetricAttendees: 'Spectateurs',
    anMetricAvgBasket: 'Panier',
    anMetricPerCap: 'Per cap',
    anMetricTransferRate: 'Taux transact.',
    anSortDate: 'Date',
    // GenericByEventChart – config strings
    anChartPerEvent: 'par événement',
    anChartEventCount: 'événement(s)',
    anChartDisplayLabel: '· affichage :',
    // EventRevenueByShopChart
    anChartChangeAggLabel: "Changer l'agrégation",
    anChartPredictionsIncluded: 'Prédictions incluses',
    anChartCumulativeRev: 'CA cumulé',
    anChartSortByDate: 'Par date',
    anChartSortByRevenue: 'Par CA',
    anChartViewShops: 'Shops',
    anChartViewMenuTypes: 'Types de menu',
    anChartAverage: 'Moyenne',
    anChartNoRevenueByShop: 'Aucune donnée de revenu par shop',
    anChartNoRevenueByMenuType: 'Aucune donnée de revenu par type de menu',
    anChartAvailableForSelection: 'disponible pour la sélection.',
    anChartAdjustFiltersHint: 'Modifiez vos filtres ou la plage de dates pour afficher des données.',
    anChartLegendCollapse: 'Réduire',
    anChartShowMore: 'Afficher les',
    anChartLegendTypes: 'types',
    anChartAggPerEvent: 'Par événement',
    anChartAggMonthly: 'Mensuel',
    anChartAggQuarterly: 'Trimestriel',
    anChartAggYearly: 'Annuel',
    anChartSubtitleMonthly: 'CA mensuel',
    anChartSubtitleQuarterly: 'CA trimestriel',
    anChartSubtitleYearly: 'CA annuel',
    anChartSubtitleEvent: 'CA évènement',
    anChartShopDim: 'shop',
    anChartMenuTypeDim: 'type de menu',
    anChartTitleBy: 'par',
    anChartTitleExTax: '(HT)',
    anChartTooltipPredictedPrefix: 'PRÉDIT',
    anChartTooltipLowConf: 'FIABILITÉ FAIBLE',
    anChartTooltipPeriod: 'Période :',
    anChartTooltipDate: 'Date :',
    anChartTooltipCumulRev: 'CA cumulé :',
    anChartTooltipTotal: 'Total :',
    anChartTooltipGlobalShare: '· Part globale :',
    anChartTooltipEventSuffix: 'évènement(s)',
    // EventTimelineChart
    anTimelineDefaultEvent: 'Évènement',
    anTimelinePredictiveData: 'Données prédictives',
    anTimelineBreakdownMenu: 'Menu',
    anTimelineBreakdownShop: 'Shop',
    anTimelineReset: 'Réinitialiser',
    anTimelineStart: 'Début',
    anTimelineEnd: 'Fin',
    anTimelineNoData: 'Aucune donnée temporelle disponible.',
    anTimelineOthers: 'Autres',
    anTimelineAvgPrefix: 'Moyenne sur',
    anTimelineAvgAlignedEvents: 'évènements alignés',
    anTimelineAvgUnalignedSuffix: '(non alignée)',
    anUnalignedAlert: 'écartés de la moyenne — pas d\'heure de coup d\'envoi',
    anUnalignedAlertView: 'Voir',
    anUnalignedDialogTitle: 'Évènements sans heure de coup d\'envoi',
    anUnalignedDialogSubtitle: 'Ces évènements n\'ont pas d\'heure de coup d\'envoi exploitable : impossible de les caler, ils sont écartés de la moyenne. Ajoute une heure pour les inclure.',
    anUnalignedDialogAddTime: 'Ajouter l\'heure',
    anUnalignedDialogClose: 'Fermer',
    // ShopDistributionPieChart
    anPieDistributionTitle: 'Répartition des PdV par CA',
    anPieTotalRevenue: 'CA total :',
    anPieByShopTitle: 'Répartition des PdV',
    anPieByShopSubtitle: 'points de vente',
    anPieByTypeTitle: 'Par type de PdV',
    anPieByTypeSubtitleSuffix: 'types',
    anPieByAreaTitle: 'Par zone',
    anPieByAreaSubtitleSuffix: 'zones',
    // ShopPerformanceByTransactionRate
    anShopPerfTitle: 'Performance des shops par taux de transaction',
    anShopPerfSubtitle: 'Shops classés par CA total',
    anShopPerfShopName: 'Nom du shop',
    anShopPerfExportTooltip: 'Exporter Excel',
    anShopPerfCalculating: 'Calcul des taux de transaction…',
    anShopPerfNoData: 'Aucune donnée de taux de transaction disponible.',
    anShopPerfTotalRevenue: 'CA total',
    anShopPerfAvgEvent: 'Moy./Évén.',
    anShopPerfTxnPerMin: 'txn/min',
    anShopPerfFirstHour: '1ère heure',
    anShopPerfTotalTransactions: 'Total Transactions :',
    anShopPerfEventsLabel: 'Évènements :',
    anShopPerfOperatingMinutes: 'Minutes actives :',
    anShopPerfPeak: 'Pic (15 min) :',
    anShopPerfPage: 'page',
    // DonutChartCard
    anDonutCollapse: '↑ Réduire',
    anDonutShowAll: '↩ Tout afficher',

    // Ex-DoorsOpeningDialog (supprimé) — clés conservées : ShopItemEventsDialog les utilise.
    anDoorsDialogEvent: 'évènement',
    anDoorsDialogEvents: 'évènements',
    anEventsDialogTitle: 'Évènements',
    anEventsDialogShop: 'PdV',
    anEventsDialogItem: 'Article',
    anEventsDialogOrdered: 'classés chronologiquement',
    anEventsDialogEmpty: 'Aucun évènement trouvé pour cet article',
    anEventsDialogClose: 'Fermer',
    invCountTitle: 'Compter',
    invCountCounted: 'Compté',
    invCountPackedUnits: 'Unités emballées',
    invCountNumberOf: 'Nombre de',
    invCountOf: 'de',
    invCountLooseUnits: "Nombre d'unités en vrac",
    invCountTotal: 'Total',
    invCountMarkCounted: 'Marquer compté',
    invCountReset: 'Réinitialiser',
    invCountPerPack: '/lot',
    invCountUnitFallback: 'pc',
    invCountEmptyTitle: 'Aucun article à compter',
    invCountEmptyHint: 'Ce point de vente n\'a aucun article de menu rattaché. Complétez le mapping des menus (étape 3 du wizard) pour cet espace afin de peupler l\'inventaire.',
    invCardItems: 'articles',
    invCardNoItems: 'Aucun article',
    invCardStartCount: 'Commencer le comptage',
    invCardContinueCount: 'Continuer le comptage',
    invCardReviewCount: 'Revoir le comptage',
    invAllCountedToast: 'tous les articles sont comptés ✓',
    invPageTitle: "Inventaire de l'espace",
    invChangeSpace: "Changer d'espace",
    invSearchSpace: 'Rechercher un espace…',
    invNoSpaces: 'Aucun espace disponible',
    invNoSpaceFound: 'Aucun espace trouvé',
    invEventLabel: 'Évènement',
    invDemoData: 'Données démo',
    invFiltersBtn: 'Filtres',
    invDemoActive: 'Démo active',
    invDemoMode: 'Mode démo',
    invEventSource: 'Source évènement',
    invSearchShopsItems: 'Rechercher PdV ou articles',
    invPrint: 'Imprimer',
    invPrintInventory: "Imprimer l'inventaire",
    invSave: 'Sauvegarder',
    invConfiguration: 'Configuration',
    invTools: 'Outils',
    invFilters: 'Filtres',
    invTabShops: 'Boutiques F&B',
    invTabStorage: 'Stockages',
    invTabMerch: 'Merch externe',
    invToolAnalyse: 'Analyse',
    invToolPredict: 'Prédire',
    invToolEventPredict: 'Préd. Événement',
    invToolInventory: "Inventaire de l'espace",
    invToolLogistic: 'Logistique',
    invToolRestock: 'Réarmement',

    // ── Logistic (stock temps réel par PDV/Storage) ──
    logiPageTitle: 'Logistique',
    logiSince: 'depuis',
    logiSearchPlaceholder: 'Rechercher une denrée…',
    logiResetBtn: "Reset de l'inventaire",
    logiTabShops: 'Boutiques F&B',
    logiTabStorage: 'Stockage',
    logiManageStock: 'Gérer le stock',
    logiRowItemsSuffix: 'denrées suivies',
    logiFilters: 'Filtres',
    logiFilterElements: 'Rechercher un PDV…',
    logiItemKind: 'Type de denrée',
    logiKindIngredient: 'Ingrédient',
    logiKindComponent: 'Composant',
    logiKindPackaging: 'Emballage',
    logiKindProduct: 'Produit',
    logiSummary: 'Résumé',
    logiSummaryElements: 'PDV/storages suivis',
    logiSummaryItems: 'denrées suivies',
    logiSort: 'Tri',
    logiSortName: 'Nom',
    logiSortRuptures: "Ruptures d'abord",
    logiSortStock: 'Stock croissant',
    logiRowRuptures: 'en rupture',
    logiRowLowStock: 'stock bas',
    logiAggTitle: 'Ruptures & réappro',
    logiAggShopsSuffix: 'PDV',
    logiAggStatRuptures: 'ruptures',
    logiAggStatLow: 'stock bas',
    logiAggStatUncounted: 'jamais compté',
    logiAggEmpty: 'Rien à signaler — tout est ok.',
    logiAggGo: 'Gérer',
    logiReconciliation: 'Réconciliation',
    logiReconciliationEmpty: 'Aucune réconciliation pour le moment.',
    logiReconciliationNoEvent: 'Inventaire',
    logiLines: 'lignes',
    logiDownloadCsv: 'Télécharger le CSV',
    logiEmpty: 'Aucun PDV dans cette configuration.',
    logiItems: 'denrées',
    logiNoItems: 'Aucune denrée pour cet élément.',
    logiHistoryBtn: 'Historique',
    logiUnits: 'unités',
    logiPackedShort: 'emballé',
    logiLooseShort: 'vrac',
    logiAddTitle: 'Ajouter un produit',
    logiRemoveTitle: 'Supprimer un produit',
    logiProduct: 'Produit',
    logiMarketPrice: 'Nom du produit',
    logiMarketPricePlaceholder: 'Market price pour ce produit',
    logiPacked: 'Emballé',
    logiLoose: "Nombre d'unités en vrac",
    logiPackagingOf: 'de',
    logiNumberOf: 'Nombre de',
    logiTotal: 'Total',
    logiAvailable: 'Disponible',
    logiReason: 'Raison',
    logiReasonDelivery: 'Livraison',
    logiReasonFromShop: "Transfert d'un PDV",
    logiReasonFromStorage: "Transfert d'un Storage",
    logiReasonToShop: 'Transfert vers un PDV',
    logiReasonToStorage: 'Transfert vers un Storage',
    logiReasonExpiry: 'Date Limite de Consommation',
    logiReasonOther: 'Autre',
    logiReasonTransferShop: 'Transfert PDV',
    logiReasonTransferStorage: 'Transfert Storage',
    logiReasonSale: 'Ventes',
    logiReasonReset: "Reset d'inventaire",
    logiFromShop: 'Nom du PDV',
    logiToShop: 'Nom du PDV',
    logiFromStorage: 'Nom du Storage',
    logiToStorage: 'Nom du Storage',
    logiExpiryDate: 'Date limite de consommation',
    logiOtherReason: 'Raison',
    logiOtherReasonPlaceholder: 'Précisez la raison…',
    logiCancel: 'Annuler',
    logiAddBtn: 'Ajouter',
    logiRemoveBtn: 'Supprimer',
    logiHistoryTitle: 'Historique de logistique',
    logiToday: "Aujourd'hui",
    logiYesterday: 'Hier',
    logiHistoryEmpty: 'Aucune opération enregistrée pour le moment.',
    logiHistoryError: "Impossible de charger l'historique.",
    logiHistoryMore: 'Charger plus',
    logiHistoryTo: 'vers',
    logiHistoryFrom: 'depuis',
    logiHistorySales: 'ventes (agrégées par événement)',
    logiHistorySalesNoEvent: 'Ventes hors événement',
    logiRetry: 'Réessayer',
    logiMovementSaved: 'Mouvement enregistré.',
    logiMovementError: "Impossible d'enregistrer le mouvement.",
    logiResetConfirm: "Remplacer toutes les valeurs attendues par les quantités comptées au dernier inventaire ? Les écarts seront archivés dans la section Réconciliation.",
    logiResetEvent: 'Inventaire de référence',
    logiResetGo: 'Reset',
    logiResetDone: "Reset d'inventaire effectué — écarts archivés.",
    logiResetError: "Échec du reset d'inventaire.",
    logiResetNothing: 'Aucune valeur comptée ou suivie à reseter.',
    logiDownloadError: 'Échec du téléchargement.',

    invMetricShops: 'Boutiques',
    invMetricStorages: 'Stockages',
    invMetricItems: 'Articles',
    invMetricCounted: 'Comptés',
    invLoadingInventory: "Chargement de l'inventaire…",
    invEmptyMappedTitle: 'Aucun produit mappé pour cet espace',
    invEmptyMappedHint: "Cet espace n'a pas encore d'articles de menu rattachés (mapping menu — étape 3 du wizard). Tant que ce n'est pas fait, il n'y a rien à compter ici.",
    invConfigReadonly: 'Configuration',
    invEmptyConfigTitle: 'Aucun article assigné pour cette configuration',
    invEmptyConfigHint: "Les points de vente ouverts de cette configuration n'ont aucun article assigné. Assignez des articles dans Space Menus.",
    invOpenFromEventPredictTitle: 'Aucun évènement sélectionné',
    invOpenFromEventPredict: "Ouvrez l'inventaire depuis Event Predict pour choisir l'espace et la configuration à inventorier.",
    invAssignmentLoadError: "Impossible de charger l'assignation des points de vente pour cette configuration.",
    invAssignmentRetry: 'Réessayer',
    invAssignmentPartialWarning: "Certains points de vente n'ont pas pu être chargés — la liste peut être incomplète.",
    invUseDemo: 'Utiliser les données de démo',
    invNothingTitle: 'Rien à afficher',
    invResetFilters: 'Réinitialiser les filtres',
    invDemoSheetTitle: 'Mode démonstration',
    invDemoSheetBody: "Active des données mock (Adidas Arena) pour faire tourner l'inventaire, l'agrégat et la liste de courses sans backend : shops, comptages, types de packaging et ventes de référence sont simulés.",
    invDemoActiveChip: 'Mode démo actif',
    invRealModeChip: 'Mode réel (API)',
    invClose: 'Fermer',
    invEnableDemo: 'Activer la démo',
    invExitDemo: 'Quitter la démo',
    invEventIndependent: "Indépendant d'un évènement",
    invColItem: 'Article',
    invColPacked: 'Emballées',
    invColLoose: 'Vrac',
    invColLooseUnits: 'Unités libres',
    invColShops: 'PdV',
    invUsedIn: 'Utilisé dans :',
    invPrintInvTitle: 'Inventaire',
    invPrintShopTitle: 'Liste de courses',
    invExportInventory: "Exporter l'inventaire (CSV)",
    invStatusToCount: 'À compter',
    invStatusCounted: 'Comptés',
    invNoSearchResult: 'Aucun résultat pour cette recherche.',
    invNoItemsInFilter: 'Aucun élément dans ce filtre.',
    invAggSummaryTitle: 'Résumé inventaire',
    invAggTabInventory: 'Inventaire compté',
    invAggChooseEvent: 'Choisir un évènement de référence…',
    invAggTotalItems: 'Total articles',
    invAggTotalUnits: 'Total unités',
    invAggItemsToRestock: 'Articles à réarmer',
    invAggUnitsToRestock: 'Unités à réarmer',
    invAggNoCount: 'Aucun inventaire compté',
    invAggNoCountHint: 'Commencez à compter les articles dans les boutiques pour voir le résumé ici',
    invAggCalcShopping: 'Calcul de la liste de courses…',
    invAggPickEventRestock: 'Choisissez un évènement de référence pour calculer le réarmement.',
    invAggAllInStock: 'Tout est en stock — rien à réarmer.',
    invAggRestockPacks: 'À réarmer (colis) :',
    invAggRestockLoose: 'À réarmer (libre) :',
    invAggRestockTotal: 'Total à réarmer :',
    invAggDetailByShop: 'Détail par PdV',
    invPackaging: 'emballage',
    invFilterTitle: 'Filtres inventaire',
    invFilterStatus: 'Statut',
    invFilterShops: 'Boutiques',
    invFilterShopTypes: 'Types de boutique',
    invFilterZones: 'Zones',
    invStorageCollapse: 'Réduire',
    invStorageShowAll: 'Voir tout',
    // inv — SpaceInventoryView / InventoryAggregateView / InventoryCountingInterface
    invOptions: 'Options',
    invOptionsTitle: 'Options inventaire',
    invToolsLabel: 'Outils',
    invVerifyCoverage: 'Vérifier stocks ↔ menus',
    invBack: 'Retour',
    invToolboxNav: 'Navigation outils',
    invSummaryAria: 'Résumé inventaire',
    invLoadingAria: 'Chargement inventaire',
    invPrevShop: 'Boutique précédente',
    invNextShop: 'Boutique suivante',
    invCountedTooltip: '« Comptés » = boutiques dont TOUS les articles sont comptés. Un comptage partiel garde la boutique dans « À compter » — d\'où un « Comptés » à 0 tant qu\'aucune boutique n\'est terminée à 100 %.',
    invIncompleteTitle: 'Inventaire incomplet',
    invIncompleteMsgPrefix: 'articles comptés. Sauvegarder et passer au réarmement quand même ?',
    invSaveAnyway: 'Sauvegarder quand même',
    invContinueCounting: 'Continuer le comptage',
    invSaveError: 'Échec de la sauvegarde de l\'inventaire',
    invFocusCounting: 'Comptage en cours :',
    invAggGoalLabel: "Objectif dérivé des ventes d'un event passé",
    invAggNoPastEvent: 'Aucun event passé disponible comme référence.',
    invAggDegraded: 'Détail des ventes indisponible pour cet event — objectif en mode dégradé.',
    invAggTodoTitle: 'PdV à compter',
    invChangeShop: 'Changer de boutique',
    hdrSecSpaces: 'Espaces',
    hdrSecEvents: 'Évènements',
    hdrSecDashboard: 'Tableau de bord',
    hdrSecSuppliers: 'Fournisseurs',
    hdrSecEventTypes: "Types d'évènement",
    hdrSecEventCategories: 'Catégories',
    hdrSecEventSubcategories: 'Sous-catégories',
    hdrSecBuilder: 'Builder',
    hdrSecEventPredict: 'Event Predict',
    hdrSecInventory: 'Inventaire',
    // eps — EventPredictStockUpSection
    epsNoConfigSelected: 'Aucune configuration sélectionnée',
    epsNoStockItems: 'Aucun article de stock à afficher',
    epsSelectMenuItemsHint: 'Sélectionnez des articles de menu dans la section Paramètres de configuration ci-dessus',
    epsTotalEstimatedCost: 'Coût total estimé du stock-up',
    epsOtherCategory: 'Autres',
    epsUnitCostTitle: 'Coût unitaire',
    epsItem: 'article',
    epsItems: 'articles',
    epsFrom: 'depuis',
    epsPackagingOf: 'de',
    epsNoShopType: 'Aucun type de point de vente',
    epsAndJoiner: 'et',
    epsTypeFood: 'Nourriture',
    epsTypeBeverages: 'Boissons',
    epsTypeBeer: 'Bière',
    epsTypeGpPremium: 'GP Premium',
    epsTypeTemporary: 'Temporaire',
    epsTypeDrinkee: 'Drinkee',
    // epm — EventPredictMenusSection
    epmEmptyNoConfig: 'Aucune vente ni configuration pour cet évènement',
    epmEmptyNoFbElements: 'Aucun élément F&B trouvé dans cette configuration',
    epmSearchShopsItems: 'Rechercher des points de vente ou des articles...',
    epmTabOpen: 'Ouverts',
    epmTabClosed: 'Fermés',
    epmNoShopsFoundPrefix: 'Aucun point de vente ',
    epmNoShopsFoundSuffix: ' trouvé',
    epmPred: 'Préd.',
    epmAdjusted: 'Ajusté',
    epmShopAdjustment: 'Ajustement du point de vente',
    epmResetTo100: 'Réinitialiser à 100%',
    epmCollapseShop: 'Réduire les détails du point de vente',
    epmExpandShop: 'Afficher les détails du point de vente',
    epmNoItemsForFilter: 'Aucun article trouvé pour ce filtre',
    epItemsLoading: 'Chargement des articles…',
    epNoItems: 'Aucun article à afficher pour le moment.',
    epNoItemsPrediction: 'Aucun article disponible pour cette prédiction. Vérifiez la configuration, le mapping des articles ou relancez le calcul.',
    epmSelectAllItems: 'Tout sélectionner',
    epmCostLabel: 'coût',
    epmMarginLabel: 'marge',
    epmManualQty: 'Qté manuelle :',
    epmUnits: 'unités',
    epmUnitsLabel: 'Unités :',
    epmMinusUnit: '−1 unité',
    epmPlusUnit: '+1 unité',
    epmUnitAbbr: 'u',
    epmMissing: 'Manquant :',
    epmAdjustedColon: 'Ajusté :',
    epmSearchItemsShops: 'Rechercher des articles ou des points de vente...',
    epmScrollLeft: 'Défiler les catégories vers la gauche',
    epmScrollRight: 'Défiler les catégories vers la droite',
    epmTabAll: 'Tous',
    epmTabFood: 'Nourriture',
    epmTabBeverage: 'Boisson',
    epmTabCombo: 'Combo',
    epmNoMenuItems: 'Aucun article trouvé',
    epmNoCategory: 'Aucune catégorie',
    epmShopsSuffix: 'points de vente',
    epmItemAdjustment: 'Ajustement de l\'article',
    epmMixed: 'Mixte',
    epmCollapseItem: 'Réduire les détails de l\'article',
    epmExpandItem: 'Afficher les détails de l\'article',
    epmSelectAllShops: 'Sélectionner tous les points de vente',

    // ep — EventPredictView
    epBack: 'Retour',
    epTitle: 'Prédiction événement',
        b2Back: "Retour",
        b2ElpAllAreas: "Toutes les zones",
        b2ElpScrollLeft: "Défiler à gauche",
        b2ElpScrollRight: "Défiler à droite",
        invToggleFilters: "Afficher/masquer les filtres",
        srToggleFilters: "Afficher/masquer les filtres",
        logiToggleFilters: "Afficher/masquer les filtres",
        anHeaderToggleFilters: "Afficher/masquer les filtres",
        anHeaderToggleNav: "Afficher/masquer la navigation",
        diAll: 'Tout',
        diApplySuggestions: 'Tout appliquer',
        diAutoSuggestionBanner: '{n} suggestion{s} automatique disponible',
        diBasements: 'Sous-sols',
        diCancelSync: 'Annuler',
        diConfigureLocations: 'Configurer les emplacements',
        diCount: '{n} importé(s)',
        diCreateSpace: 'Créer un nouveau Space',
        diCreateSpaceBtn: 'Créer le Space',
        diDetectedLocations: 'Emplacements détectés',
        diError: 'Erreur',
        diExternalArea: 'Zone externe',
        diFloors: 'Étages',
        diForecourt: 'Parvis',
        diImportDone: 'Import terminé !',
        diImportedData: 'Données importées',
        diLastSync: 'Dernière synchro :',
        diMapped: 'mappé',
        diMatchScore: 'Correspondance',
        diModifyCredentialsBtn: 'Modifier les identifiants',
        diNeverSynced: 'jamais',
        diOrUse: '— ou —',
        diRunning: 'en cours...',
        diSaveAndNext: 'Enregistrer & Suivant',
        diSaveConnectBtn: 'Enregistrer & Connecter',
        diSelectSpace: 'Sélectionner un Space',
        diSkipUnmapped: 'Ignorer les non mappés',
        diSpaceMappingDisabled: 'Sélectionnez un space pour continuer',
        diSpaceMappingNext: 'Suivant',
        diSpaceName: 'Nom du space',
        diSuggestion: 'Suggestion',
        diSyncDone: 'Voir les résultats',
        diSyncError: 'Erreur de synchro',
        diSyncFailed: 'Fermer',
        diSyncSuccess: 'Événements synchronisés ({n} éléments)',
        diTestConnectionBtn: 'Tester la connexion',
        diUnmapped: 'non mappé',
        diUpdateSaveBtn: 'Mettre à jour & Enregistrer',
        diUseSuggestion: 'Utiliser',
        diWeezeventDescCard: 'Billetterie événementielle et paiement cashless',
        diWeezeventSyncTitle: 'Synchronisation Weezevent',
        f_itemName: "Nom de l'article",
        f_unit: "Unité",
        f_price: "Prix",
        f_goodType: "Type de bien",
        f_recipeUnit: "Unité de recette",
        f_purchaseUnitConversion: "Conversion d'unité d'achat",
        f_category: "Catégorie",
        f_supplierName: "Nom du fournisseur",
        f_supplierItemName: "Nom de l'article fournisseur",
        f_unitsPerPurchase: "Unités par achat",
        f_pricePerUnit: "Prix par unité",
        f_purchasePackaging: "Conditionnement d'achat",
        roleListEdit: "Modifier",
        spaceMenuSelectItemsToAttach: "Sélectionner les éléments à attacher",
    displayNameListAddDisplayName: "Ajouter un nom d'affichage",
    displayNameListCancel: 'Annuler',
    displayNameListColActions: 'Actions',
    displayNameListColCreated: 'Créé le',
    displayNameListColName: 'Nom',
    displayNameListCreate: 'Créer',
    displayNameListDelete: 'Supprimer',
    displayNameListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    displayNameListDeleteSubtitle: 'Cette action est irréversible',
    displayNameListDeleteTitle: "Supprimer le nom d'affichage",
    displayNameListDialogCreateSubtitle: "Ajoutez un nouveau nom d'affichage à votre liste",
    displayNameListDialogCreateTitle: "Nouveau nom d'affichage",
    displayNameListDialogEditSubtitle: "Mettre à jour le nom d'affichage",
    displayNameListDialogEditTitle: "Modifier le nom d'affichage",
    displayNameListLabelName: "Nom d'affichage",
    displayNameListNamePlaceholder: 'ex. Burger Deluxe...',
    displayNameListSave: 'Enregistrer',
    displayNameListSearchPlaceholder: "Rechercher un nom d'affichage...",
    displayNameListSubtitle: "Gérez vos noms d'affichage",
    displayNameListTitle: "Noms d'affichage",
    displayNameListTotalDisplayNames: "Total noms d'affichage",
    industrialListAddIndustrial: 'Ajouter un industriel',
    industrialListCancel: 'Annuler',
    industrialListColActions: 'Actions',
    industrialListColCreated: 'Créé le',
    industrialListColName: 'Nom',
    industrialListCreate: 'Créer',
    industrialListDelete: 'Supprimer',
    industrialListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    industrialListDeleteSubtitle: 'Cette action est irréversible',
    industrialListDeleteTitle: "Supprimer l'industriel",
    industrialListDialogCreateSubtitle: 'Ajoutez un nouvel industriel à votre liste',
    industrialListDialogCreateTitle: 'Nouvel industriel',
    industrialListDialogEditSubtitle: "Mettre à jour l'industriel",
    industrialListDialogEditTitle: "Modifier l'industriel",
    industrialListLabelName: 'Industriel',
    industrialListNamePlaceholder: 'ex. Sysco, Metro...',
    industrialListSave: 'Enregistrer',
    industrialListSearchPlaceholder: 'Rechercher un industriel...',
    industrialListSubtitle: 'Gérez vos industriels',
    industrialListTitle: 'Industriels',
    industrialListTotalIndustrials: 'Total industriels',
    menuItemCreateDisplayNamePlaceholder: 'Sélectionner un nom d\'affichage...',
    menuItemCreateLabelDisplayName: 'Nom d\'affichage',
    packingTypeListAddPackingType: 'Ajouter un packing type',
    packingTypeListCancel: 'Annuler',
    packingTypeListColActions: 'Actions',
    packingTypeListColCreated: 'Créé le',
    packingTypeListColName: 'Nom',
    packingTypeListCreate: 'Créer',
    packingTypeListDelete: 'Supprimer',
    packingTypeListDeleteConfirm: 'Voulez-vous vraiment supprimer',
    packingTypeListDeleteSubtitle: 'Cette action est irréversible',
    packingTypeListDeleteTitle: 'Supprimer le packing type',
    packingTypeListDialogCreateSubtitle: 'Ajoutez un nouveau packing type à votre liste',
    packingTypeListDialogCreateTitle: 'Nouveau packing type',
    packingTypeListDialogEditSubtitle: 'Mettre à jour le packing type',
    packingTypeListDialogEditTitle: 'Modifier le packing type',
    packingTypeListLabelName: 'Packing type',
    packingTypeListNamePlaceholder: 'ex. Cup, Fût, Bottle...',
    packingTypeListSave: 'Enregistrer',
    packingTypeListSearchPlaceholder: 'Rechercher un packing type...',
    packingTypeListSubtitle: 'Gérez vos types de conditionnement',
    packingTypeListTitle: 'Packing Types',
    packingTypeListTotalPackingTypes: 'Total packing types',
    addNewSupplier: 'Ajouter un nouveau fournisseur',
    addSupplierItem: 'Ajouter un article fournisseur',
    addSupplierSubtitle: 'Ajouter un fournisseur à cet article',
    addSupplierTitle: 'Ajouter un fournisseur',
    back: 'Retour',
    chooseFile: 'Choisir un fichier',
    createNew: 'Créer',
    deleteConfirm: 'Voulez-vous vraiment supprimer ?',
    deleteSupplierTitle: 'Supprimer le fournisseur',
    downloadTemplate: 'Télécharger le modèle',
    drawerTitle: 'Détails',
    dropSub: 'ou glissez-déposez-le ici',
    dropTitle: 'Déposez votre fichier ici',
    editSupplierSubtitle: 'Modifier ce lien fournisseur',
    editSupplierTitle: 'Modifier le fournisseur',
    err_invalidGoodType: 'Type de produit invalide',
    err_missingGoodType: 'Le type de produit est requis',
    err_missingName: 'Le nom est requis',
    err_missingPrice: 'Le prix est requis',
    err_missingUnit: 'L\'unité est requise',
    errors: 'Erreurs',
    expectedFormat: 'Format attendu',
    forTheAmountOf: 'pour un montant de',
    formatDesc: 'Le fichier doit respecter ce format.',
    goodCategory: 'Catégorie',
    height: 'Hauteur',
    imageOptional: 'Image (facultatif)',
    importAnother: 'Importer un autre fichier',
    importBtn: 'Importer',
    importedOk: 'Import réussi',
    importing: 'Import en cours…',
    invClear: 'Effacer',
    inventoryInfo: 'Informations d\'inventaire',
    itemIsPurchasedIn: 'Cet article est acheté en',
    itemIsStoredIn: 'Cet article est stocké en',
    componentIsStoredIn: 'Ce composant est stocké en',
    kitchenCentral: 'Cuisine Centrale',
    kitchenLocal: 'Cuisine Locale',
    kitchenType: 'Cuisine',
    length: 'Longueur',
    logiClear: 'Effacer',
    mapColumns: 'Associer les colonnes',
    missingRequiredMapping: 'Certaines colonnes requises ne sont pas associées.',
    next: 'Suivant',
    noRows: 'Aucune ligne',
    numberOfUnits: 'Nombre d\'unités',
    packedUnits: 'Unités emballées',
    packingInfo: 'Informations d\'emballage',
    purchaseInfo: 'Informations d\'achat',
    row: 'Ligne',
    rowsLabel: 'lignes',
    sectionIdentity: 'Identité',
    selectAll: 'Tout sélectionner',
    selectExisting: 'Sélectionner un existant',
    selectUnit: 'Sélectionner une unité',
    srClear: 'Effacer',
    stepFile: 'Fichier',
    stepLabelFile: 'Fichier',
    stepLabelMapping: 'Association',
    stepLabelResults: 'Résultats',
    stepMapping: 'Association',
    stepResults: 'Résultats',
    supplierConfigurations: 'Configurations',
    supplierContactName: 'Nom du contact',
    supplierCreateSubtitle: 'Créer un nouveau fournisseur',
    supplierEmail: 'E-mail',
    supplierPhone: 'Téléphone',
    supplierSectors: 'Secteurs',
    supplierSpaces: 'Espaces',
    unselectAll: 'Tout désélectionner',
    uploadPicture: 'Téléverser une image',
    width: 'Largeur',
    epmAddShopsSpaceMenus: 'Ajouter des shops (Space Menus)',
    epmAssignmentMissing: 'Aucun menu item n\'est attribué aux points de vente de cette configuration. Les quantités prédites s\'affichent quand même, mais utilisez « remapper » pour rattacher chaque article au menu du shop.',
    epmCostAbovePriceBadge: 'coût > prix',
    epmCostAbovePriceTitle: 'Coût unitaire supérieur au prix de vente HT — donnée de coût probablement erronée',
    epmDisabledBadge: 'désactivé',
    epmDisabledTitle: 'Article présent dans le Space Menu du shop mais désactivé — non compté dans le CA',
    epmGhostBadge: 'fantôme — hors catalogue',
    epmGhostTitle: 'Ligne d\'assignation dont l\'article n\'existe pas au catalogue (assignée par erreur) — invisible dans Space Menus, retirez-la ici',
    epmGross: 'Brut',
    epmManualQtyWhy: 'Pourquoi une quantité manuelle ?',
    epmNeverSold: 'Jamais vendu ici',
    epmNeverSoldHint: 'Ce point de vente n\'a aucune vente passée pour cet article — rien à prédire.',
    epmNoConfigShopsHint: 'Ajoutez des shops à la configuration pour préparer la prédiction par point de vente.',
    epmNoConfigShopsTitle: 'Aucun point de vente dans cette configuration.',
    epmOutsideMenuBadge: 'hors menu',
    epmOutsideMenuTitle: 'Article hors du Space Menu de ce point de vente — non compté dans le CA',
    epmRemappedBadge: 'remappé',
    epmRemappedTitle: 'Rattaché au menu du shop par correspondance de nom',
    epmRemoveFromMenu: 'Retirer du menu',
    epmRemoveFromMenuTitle: 'Retirer cette ligne du menu du shop (Space Menus)',
    epmShopSearchPlaceholder: 'Rechercher un article...',
    epmShopTabNoSales: 'Sans ventes prévues',
    epmShopTabNoSalesHint: 'Articles attachés au menu de ce point de vente, mais sans aucune vente prédite pour cet évènement.',
    epmShopTabSales: 'Ventes prévues',
    epmShopTabSalesHint: 'Articles attachés au menu de ce point de vente avec au moins une vente prédite pour cet évènement.',
    epmShopTabUnmapped: 'Non attachés au menu',
    epmShopTabUnmappedHint: 'Ventes prédites sur des articles absents du Space Menu de ce point de vente — rattachez-les pour qu\'ils comptent dans l\'ajustement du CA.',
    epmUnmappedBadge: 'non mappé',
    epmUnmappedItemViewHint: 'Des ventes sont prévues sur ces articles non rattachés — à intégrer à l\'ajustement du CA',
    epmUnmappedTitle: 'Vendu mais absent du menu assigné — à rattacher',
    epraActions: 'Actions',
    epraAddToMenu: 'Ajouter au menu',
    epraReactivate: 'Réactiver au menu',
    epraRemap: 'Remapper',
    epsdAttendance: 'Affl',
    epsdCategory: 'Cat',
    epsdDay: 'Jour',
    epsdExcluded: 'Exclu',
    epsdNoAlgoEvent: 'Aucun évènement retenu par l\'algorithme.',
    epsdNoOtherPastEvent: 'Aucun autre évènement passé disponible.',
    epsdPerformer: 'Perf',
    epsdRecalculating: 'Recalcul…',
    epsdSaveRecalculate: 'Enregistrer et recalculer',
    epsdScale: 'Échelle',
    epsdScore: 'Score',
    epsdSelectedByAlgo: 'Sélectionnés par l\'algorithme',
    epsdSelectedPlural: 'évènements sélectionnés',
    epsdSelectedSingular: 'évènement sélectionné',
    epsdSponsor: 'Spons',
    epsdSubcategory: 'Sub',
    epsdSubtitle: 'Choisissez les évènements passés servant de base au calcul.',
    epsdTeam: 'Équipe',
    epsdTime: 'Heure',
    epsdTitle: 'Évènements utilisés pour la prédiction',
    epsdType: 'Type',
    epsdUnselected: 'Non sélectionnés',
    epsdWeight: 'Poids',
    logiClose: 'Fermer',
    logiPackNotConfigured: 'Pack non configuré',
    logiSimulateAddLine: 'Ajouter une ligne',
    logiSimulateAfter: 'Après',
    logiSimulateAnother: 'Simuler une autre vente',
    logiSimulateBefore: 'Avant',
    logiSimulateBtn: 'Simuler une vente',
    logiSimulateError: 'Impossible de simuler cette vente.',
    logiSimulateGo: 'Simuler',
    logiSimulateIntro: 'Crée une transaction Weezevent synthétique pour tester la déduction de stock, sans attendre une vraie vente.',
    logiSimulateItem: 'Denrée',
    logiSimulateMenuItem: 'Article',
    logiSimulateNoMenuItems: "Aucun menu item mappé à Weezevent pour ce PDV — vente non simulable ici.",
    logiSimulatePurge: 'Purger les ventes simulées de ce PDV',
    logiSimulatePurgeError: 'Impossible de purger les ventes simulées.',
    logiSimulatePurged: 'Ventes simulées purgées.',
    logiSimulateShop: 'PDV',
    logiSimulateTitle: 'Simuler une vente (QA)',
    logiSimulateWarning: 'Cette vente simulée apparaîtra aussi dans les tableaux de revenus/analytics tant que non purgée.',
    epToolAnalyse: 'Analyse',
    epToolPredict: 'Prédire',
    epToolEventPredict: 'Préd. Événement',
    epToolSpaceInventory: 'Inventaire de l\'espace',
    epToolLogistic: 'Logistique',
    epToolRestock: 'Réarmement',
    edeDateTimeAt: 'à',
    epActivateThisVersion: 'Activer cette version',
    epActive: 'Active',
    epAdjustmentsLoadingAria: 'Chargement des ajustements',
    epAlgoInfoMessage: 'La prédiction pondère les événements passés selon leur similarité avec l’événement cible.',
    epAlgoInfoTitle: 'Fonctionnement de l’algorithme',
    epAlgoSelectionTitle: 'Sélection de l’algorithme',
    epApply: 'Appliquer',
    epAssignReplaceLabel: 'Assigner / remplacer par',
    epCalculatingAria: 'Calcul en cours',
    epChooseUpcomingEventDate: 'Choisir la date de l’événement à venir',
    epCollapsePanel: 'Réduire le panneau',
    epConfigLabel: 'Configuration :',
    epConfigurationTab: 'Configuration',
    epDebugMode: 'Mode debug',
    epDetailedDataLoading: 'Chargement des données détaillées…',
    epDialogDate: 'Date',
    epDisplayMode: 'Mode d’affichage',
    epDuplicate: 'Dupliquer',
    epEmptyText: 'Sélectionnez un événement pour lancer la prédiction.',
    epEmptyTitle: 'Aucun événement sélectionné',
    epEventFallbackName: 'Événement',
    epEventWordPlural: 'événements',
    epEventWordSingular: 'événement',
    epGoToRestock: 'Aller au réarmement',
    epHome: 'Accueil',
    epInventoryLink: 'Inventaire',
    epLowConfidenceWarning: 'Prédiction à faible confiance',
    epManualQtyInfoMessage: 'Les quantités saisies manuellement remplacent la prédiction.',
    epManualQtyInfoTitle: 'Quantités manuelles',
    epMetricBasket: 'Panier',
    epMetricCost: 'Coût',
    epMetricMargin: 'Marge',
    epMetricTransformation: 'Transformation',
    epMultiDescPrefix: 'Prédiction agrégée sur',
    epMultiTip: 'Sélectionnez plusieurs événements pour agréger leur prédiction.',
    epMultiTitle: 'Multi-événements',
    epNavToggle: 'Afficher/masquer la navigation',
    epNextMonth: 'Mois suivant',
    epNoEventAvailable: 'Aucun événement disponible',
    epNoTimelineData: 'Aucune donnée de timeline',
    epNotifications: 'Notifications',
    epOpenInventoryForEvent: 'Ouvrir l’inventaire pour cet événement',
    epOpenRestockForEvent: 'Ouvrir le réarmement pour cet événement',
    epPastEventPlural: 'événements passés',
    epPastEventSingular: 'événement passé',
    epPerCap: 'Per cap',
    epPosLabel: 'PdV :',
    epPredictionBasedOn: 'Prédiction basée sur',
    epPredictionSourcesDescription: 'Événements passés utilisés pour pondérer la prédiction.',
    epPredictiveDataLoadingAria: 'Chargement des données prédictives',
    epPreviousMonth: 'Mois précédent',
    epRealTimelineDesc: 'Timeline réelle du chiffre d’affaires pour cet événement passé.',
    epRealTimelineLoading: 'Chargement de la timeline…',
    epRealTimelineTitle: 'Timeline réelle',
    epReload: 'Recharger',
    epRemapDialogTitle: 'Rattacher au menu',
    epRename: 'Renommer',
    epRestockReadyText: 'Le réarmement est prêt à être généré.',
    epRestockReadyTitle: 'Réarmement prêt',
    epRevenueHt: 'CA (HT)',
    epSavedVersions: 'Versions enregistrées',
    epScoringLoading: 'Calcul…',
    epScoringLoadingAria: 'Scoring des événements passés',
    epSectionsAria: 'Sections',
    epSettings: 'Réglages',
    epShareLinkCopy: 'Copier le lien',
    epShopBackendMissing: 'Point de vente introuvable côté serveur.',
    epShowPanel: 'Afficher le panneau',
    epSignOut: 'Se déconnecter',
    epSoldItemLabel: 'Article vendu :',
    epSources: 'Sources',
    epSpaceInventory: 'Inventaire de l’espace',
    epSpaceLabel: 'Espace :',
    epStockTab: 'Réappro',
    epSummary: 'Résumé',
    epTenantLabel: 'Tenant :',
    epTickets: 'Billets',
    epTimeLabel: 'Heure',
    epTimeRange: 'Plage horaire',
    epTimeline: 'Timeline',
    epTimelineAlignmentUnavailableText: 'L’alignement de la timeline n’est pas disponible pour cette sélection.',
    epTimelineAlignmentUnavailableTitle: 'Alignement indisponible',
    epTimelineCalcAria: 'Calcul de la timeline',
    epTimelineCalcErrorText: 'Une erreur est survenue lors du calcul de la timeline.',
    epTimelineCalcErrorTitle: 'Erreur de timeline',
    epTimelineFallbackNoSales: 'Aucune donnée de vente pour la timeline.',
    epTimelineNoComparable: 'Aucun événement comparable pour la timeline.',
    epTimelineNoUsableSales: 'Aucune vente exploitable pour la timeline.',
    epTimelineUnavailableTitle: 'Timeline indisponible',
    epTip: 'Astuce',
    epTools: 'Outils',
    epToolsNavigation: 'Navigation des outils',
    epTotalRevenueHt: 'CA total (HT)',
    epUnsavedClickSaveTitle: 'Modifications non enregistrées — cliquez sur Enregistrer sous',
    epUpcomingEventPlural: 'événements à venir',
    epUpcomingEventSingular: 'événement à venir',
    epUpdate: 'Mettre à jour',
    epVersion: 'Version',
    epViewModeItem: 'Par article',
    epViewModeShop: 'Par PDV',
    epWaitingSpaceMenuAria: 'En attente du menu de l’espace',
    edeAdd: 'Ajouter',
    edeCancel: 'Annuler',
    edeCreate: 'Créer',
    edeCreateTeam: 'Créer une nouvelle équipe',
    edeCreateTeamTitle: 'Créer une équipe',
    edeCreateTeamError: 'Impossible de créer l\'équipe',
    edeTeamName: 'Nom de l\'équipe',
    edeCategory: 'Catégorie',
    edeConfigUndefined: 'Configuration non définie',
    edeConfiguration: 'Configuration',
    edeDatesTimes: 'Dates et horaires',
    edeDoorsOpening: 'Ouverture des portes',
    edeDrawerSubtitle: 'Informations complètes',
    edeDrawerTitle: 'Détail de l\'évènement',
    edeEndDate: 'Date de fin',
    edeEndTime: 'Heure de fin',
    edeEventName: 'Nom de l\'évènement',
    edeEventType: 'Type d\'évènement',
    edeGeneralInfo: 'Informations générales',
    edeHomeTeam: 'Équipe à domicile',
    edeNone: 'Aucun',
    edeNotSaved: 'Non sauvegardé',
    edeRemoveSession: 'Supprimer la session',
    edeSave: 'Enregistrer',
    edeSaving: 'Enregistrement…',
    edeScanned: 'scannés',
    edeSearchTeam: 'Rechercher une équipe',
    edeSelectCategory: 'Sélectionner une catégorie',
    edeSelectConfig: 'Sélectionner une configuration',
    edeSelectEvent: 'Sélectionnez un évènement',
    edeSelectSubcategory: 'Sélectionner une sous-catégorie',
    edeSelectType: 'Sélectionner un type',
    edeSession: 'Session',
    edeSessions: 'Sessions',
    edeShowStart: 'Début du spectacle',
    edeStartDate: 'Date de début',
    edeSubcategory: 'Sous-catégorie',
    edeTaxonomy: 'Taxonomie',
    edeTeams: 'Équipes',
    edeTicketing: 'Billetterie',
    edeTicketsErrorA: 'Les billets scannés (',
    edeTicketsErrorB: ') ne peuvent pas dépasser les billets vendus (',
    edeTicketsErrorC: ').',
    edeTicketsScanned: 'Billets scannés',
    edeTicketsSold: 'Billets vendus',
    edeUnnamedEvent: 'Évènement sans nom',
    edeViewDetail: 'Voir détail',
    edeVisitingTeam: 'Équipe visiteuse',
    epNoUpcomingEvent: 'Aucun évènement à venir',
    epNotSaved: 'Non sauvegardé',
    epNotSavedTitle: 'Modifications non sauvegardées sur cette page',
    epSaveAs: 'Enregistrer sous',
    epSaveAsTitle: 'Enregistrer comme nouvelle version',
    epSelectEventPlaceholder: 'Sélectionner un évènement à prédire…',
    epTicketsScannedLabel: 'Billets scannés :',
    epSubtitle: 'Analyse prédictive pour les prochains événements — scoring pondéré sur les événements passés',
    epBannerSubtitle: 'Vue prédictive',
    epActiveVersion: 'Version active',
    epActiveVersionTitle: 'Version active',
    epUnnamed: 'sans nom',
    epDraftUnsaved: 'Brouillon · Non enregistré',
    epSaveHintFr: '« Enregistrer » fige les quantités ajustées dans une version.',
    epSaveHintEn: '« Enregistrer sous » stocke un instantané des quantités ajustées.',
    epReset: 'Réinitialiser',
    epResetTitle: 'Réinitialiser les ajustements',
    epSave: 'Enregistrer',
    epSaveTitle: 'Enregistrer une nouvelle version',

    // sr — SpaceRestockView
    srBack: 'Retour',
    srTitle: 'Réarmement',
    srObjectiveSalesPrefix: 'Objectif : ventes de',
    srEventSingular: 'événement',
    srEventPlural: 'événements',
    srSourceInventoryPrefix: 'Inventaire source :',
    srLastSnapshot: 'Dernier snapshot',
    srSettings: 'Paramètres',
    srShoppingList: 'Feuille de course',
    srToolboxNavLabel: 'Navigation outils',
    srOverviewLabel: 'Résumé réarmement',
    srLoadingLabel: 'Chargement réarmement',
    srEvents: 'Événements',
    srPredictedSingular: 'prédit',
    srPredictedPlural: 'prédits',
    srReferenceEventChip: 'Event de réf.',
    srSelectedSingular: 'sélectionné',
    srSelectedPlural: 'sélectionnés',
    srObjectiveSourceLabel: 'Source de l\'objectif',
    srForecast: 'Prévision',
    srSalesRefEvent: 'Ventes (event réf.)',
    srReferenceEventPlaceholder: 'Event de référence',
    srReferenceSalesDegraded: 'Détail des ventes indisponible pour cet event — objectif calculé en mode dégradé.',
    srNoPastEvent: 'Aucun event passé disponible comme référence.',
    srObjectiveSalesHint: 'Objectif basé sur les ventes de cet event passé. La sélection d\'events futurs est masquée dans ce mode.',
    srObjectiveSalesHintShort: 'Objectif basé sur les ventes de cet event passé.',
    srGenerateRestock: 'Générer le réarmement',
    srItemsToStock: 'Éléments à stocker',
    srItemsToStockDesc: 'Quantité à stocker par article (prédit → cible). Le slider ajuste le besoin ; 100% = prédiction.',
    srItemSingular: 'article',
    srItemPlural: 'articles',
    srFilterItems: 'Filtrer les items',
    srReset: 'Reset',
    srIncludeItem: 'Inclure cet élément dans le réarmement',
    srSelectAll: 'Tout sélectionner',
    srDeselectAll: 'Tout désélectionner',
    srPacked: 'Empaqueté',
    srUsedIn: 'Utilisé dans :',
    srSelectEventsEmpty: 'Sélectionnez un ou plusieurs événements dans le calendrier.',
    srNoStockNeed: 'Aucun besoin stock calculé pour la sélection.',
    srShopSingular: 'boutique',
    srShopPlural: 'boutiques',
    srTargetLabel: 'cible',
    srPredictedLabel: 'prédit',
    srScenarioRevenue: 'CA prédit HT',
    srScenarioUnits: 'unités',
    srAdjustNeedLabel: 'Ajuster le besoin',
    srTargetPresets: 'Objectif',
    srCompositeDishes: 'Composition des plats',
    srCompositeDishesHint: 'Recettes détectées dans la sélection. Les quantités suivent le réglage de chaque composant.',
    srCompositionLabel: 'Composition',
    srComponentSingular: 'composant',
    srComponentPlural: 'composants',
    srRestockTable: 'Tableau de réarmement',
    srRestockTableDesc: 'Différence entre la cible stock et l\'inventaire restant sauvegardé.',
    srToDeposit: 'à déposer',
    srConfirmed: 'confirmés',
    srNotGenerated: 'Non généré',
    srFilterShopItem: 'Filtrer shop / item',
    srByShop: 'Par shop',
    srByItem: 'Par item',
    srGenerateRestockHint: 'Cliquez sur « Générer le réarmement » pour figer le tableau.',
    srNoElementToDeposit: 'Aucun élément à déposer.',
    srConfirmAll: 'Tout confirmer',
    srUncheckAll: 'Tout décocher',
    srConfirmRow: 'Confirmer',
    srConfirmedRow: 'Confirmé',
    srUndoConfirmRow: 'Annuler la confirmation',
    srExportCsv: 'Exporter CSV',
    srColItem: 'Article',
    srColTarget: 'Cible',
    srColRemaining: 'Restant',
    srColToDeposit: 'À déposer',
    srColConfirmed: 'Confirmé',
    srColShop: 'Boutique',
    srShoppingListDesc: 'Achats consolidés et ordonnés par fournisseur.',
    srSupplierSingular: 'fournisseur',
    srSupplierPlural: 'fournisseurs',
    srArticleSingular: 'article',
    srArticlePlural: 'articles',
    srSuppliersPreviewTitle: 'Fournisseurs',
    srSuppliersPreviewHint: 'Générez la feuille de course pour l\'aperçu fournisseurs.',
    srSuppliersPreviewEmpty: 'Aucun fournisseur.',
    srSuppliersUnits: 'unités',
    srSuppliersEmailBtn: 'Envoyer commande',
    srSuppliersEmailDialogTitle: 'Email de commande',
    srSuppliersEmailTo: 'Destinataire',
    srSuppliersEmailSubject: 'Objet',
    srSuppliersEmailBody: 'Message',
    srSuppliersEmailSend: 'Envoyer',
    srSuppliersEmailCancel: 'Annuler',
    srSuppliersEmailBold: 'Gras',
    srSuppliersEmailItalic: 'Italique',
    srSuppliersEmailUnderline: 'Souligné',
    srSuppliersEmailBullets: 'Liste à puces',
    srNotGeneratedFem: 'Non générée',
    srFilterSupplierItem: 'Filtrer fournisseur / item',
    srPrint: 'Imprimer',
    srGenerateShoppingHint: 'Cliquez sur « Feuille de course » pour générer la liste d\'achat.',
    srNoPurchaseNeeded: 'Aucun achat nécessaire pour les lignes générées.',
    srShoppingModeFinished: 'Produits finis',
    srShoppingModeIngredients: 'Ingrédients',
    srShoppingIngredientsHint: 'Matière première à produire/acheter en cuisine centrale — chaque plat est éclaté en ingrédients, indépendamment de « Prêt à la vente ».',
    srFinishedProductsGroup: 'Produits finis',
    srRecipesLoading: 'Chargement des recettes…',
    srNoIngredientNeeded: 'Aucun ingrédient à produire pour les ventes prédites.',
    srEmail: 'Email',
    srCall: 'Appeler',
    srSupplierPhoneMissingTitle: 'Téléphone fournisseur non renseigné',
    srColQuantityToBuy: 'Quantité à acheter',
    srColToBuyShort: 'À acheter',
    srColShops: 'Boutiques',
    srDiagPredicted: 'Prévu',
    srDiagShop: 'en shop',
    srDiagStorage: 'storage',
    srDiagRestock: 'restock',
    srDiagBuy: 'achat',
    srStorageUnmatchedWarn: 'Stock Storage présent mais non rattaché à un item prédit :',
    srPosShort: 'PdV',
    srSettingsSheetTitle: 'Paramètres réarmement',
    srToolsLabel: 'Outils',
    srToolAnalyse: 'Analyse',
    srToolPredict: 'Prédire',
    srToolEventPredict: 'Préd. Événement',
    srToolSpaceInventory: 'Inventaire de l\'espace',
    srToolLogistic: 'Logistique',
    srToolRestock: 'Réarmement',
    srMetricEvents: 'Événements',
    srMetricStockItems: 'Items stock',
    srMetricShopsToDeliver: 'Shops à livrer',
    srMetricConfirmed: 'Confirmés',
    srCannotGenSalesNoRef: 'Sélectionnez un évènement de référence (passé) dans les paramètres.',
    srCannotGenForecastNoEvent: 'Aucun évènement futur à prévoir. Choisissez un évènement cible, ou passez en « Event de réf. » (paramètres).',
    srCannotGenSalesNoSales: 'Aucune vente trouvée pour l\'évènement de référence (indisponible en mode démo).',
    srCannotGenForecastNoForecast: 'Aucune prévision disponible pour l\'évènement sélectionné.',
    srCannotGenGeneric: 'Objectif ou besoin théorique indisponible.',
    srSnackRestockGenerated: 'Tableau de réarmement généré.',
    srSnackShoppingGenerated: 'Feuille de course générée.',
    srSnackLoadError: 'Erreur de chargement du réarmement',
    srSnackEmailMissing: 'Email fournisseur non renseigné — ajoutez le destinataire dans votre messagerie.',
    srSnackEmailBodyCopied: 'Liste trop longue pour l’email — copiée dans le presse-papier, collez-la dans le corps du message.',
    srSnackEmailTooLong: 'Liste trop longue pour l’email — utilisez Imprimer ou Exporter pour l’envoyer.',
    srSnackPhoneMissing: 'Téléphone fournisseur non renseigné.',
    srSnackPrintBlocked: 'Impression bloquée par le navigateur (pop-up). Autorisez les pop-ups.',
    srSnackPredictionDegraded: 'Quantités prédites par item indisponibles — rouvrez EventPredict pour les rafraîchir.',
    srSnackCatalogDegraded: 'Catalogue produits incomplet pour cet espace : les quantités prévues s\'affichent, mais recettes, packaging et liste de courses sont dégradés. Correctif données en cours.',
    srExportGeneratedPrefix: 'Export',
    srExportGeneratedSuffix: 'généré.',
    srSyntheticConfigName: 'Config reconstituée',
    srEventFallback: 'Événement',
    srSupplierUndefined: 'Fournisseur non défini',
    srEmailSubjectPrefix: 'Commande de réapprovisionnement -',
    srEmailGreeting: 'Bonjour',
    srEmailIntroPrefix: 'Nous souhaitons passer la commande de réapprovisionnement suivante pour',
    srEmailItemsHeading: 'Articles à livrer :',
    srEmailClosingRequest: 'Merci de bien vouloir nous confirmer la disponibilité, le délai de livraison et le montant correspondant.',
    srEmailSignOff: 'Bien cordialement,',
    srPrintColArticle: 'Article',
    srPrintColQuantityToBuy: 'Quantité à acheter',
    srPrintColPos: 'PdV',
    srPrintListTitle: 'Liste de courses',
    srCsvShop: 'Boutique',
    srCsvItem: 'Article',
    srCsvTarget: 'Cible',
    srCsvRemaining: 'Restant',
    srCsvToDeposit: 'A_deposer',
    srCsvUnit: 'Unite',
    srCsvConfirmed: 'Confirme',
    srCsvEvents: 'Evenements',
    srCsvYes: 'Oui',
    srCsvNo: 'Non',
    srCsvSupplier: 'Fournisseur',
    srCsvQuantity: 'Quantite',
    // sr — wizard
    srStep1: 'Éléments à stocker',
    srStep2: 'Réarmement',
    srStep3: 'Feuille de course',
    srPrevious: 'Précédent',
    srStepOf: 'Étape',
    // inv — counted shops summary (miroir de invAggTodoTitle / PdV à compter)
    invAggCountedTitle: 'PdV comptés',
    // inv — panneau de filtres gauche (groupes style Analyse pour Space Inventory)
    invFilterMenuItems: 'Articles du menu',
    invFilterTypeCategory: 'Type & Catégorie',
    invFilterItemType: 'Type',
    invFilterCategory: 'Catégorie',
    invFilterSearchMenuItem: 'Rechercher un article',
    invFilterNoOptions: 'Aucune option',
    invAll: 'Tous',
    invNone: 'Aucun',
    invSearchShop: 'Rechercher un point de vente',

    // 3D Builder (builder2)
    b2ToastElementChangedElsewhere: 'Élément modifié ailleurs — rechargement de l\'état.',
    b2ToastSaveElementFailed: 'Échec de l\'enregistrement de l\'élément',
    b2ToastCreateElementFailed: 'Échec de la création de l\'élément',
    b2ToastDuplicateFailed: 'Échec de la duplication',
    b2ToastLastConfigForElement: 'Dernière configuration de cet élément — supprimez l\'élément à la place.',
    b2ToastUpdateConfigsFailed: 'Échec de la mise à jour des configurations',
    b2ToastCreateZoneFailed: 'Échec de la création de la zone',
    b2ToastSaveZoneFailed: 'Échec de l\'enregistrement de la zone',
    b2ToastDuplicateZoneFailed: 'Échec de la duplication de la zone',
    b2ErrorApiUnavailable: 'API Builder v2 indisponible (endpoints à déployer — doc REFONTE_3D_BUILDER_V2 §3).',
    b2ErrorLoadingGeneric: 'Erreur de chargement',
    b2ZoneKindForecourt: 'Parvis',
    b2ZoneKindExternal: 'Espace externe',
    b2ZoneKindGroundFloor: 'RDC',
    b2ZoneKindBasement: 'Sous-sol',
    b2ZoneKindFloor: 'Étage',
    b2ErrorLoadTitle: 'Impossible de charger le builder',
    b2Retry: 'Réessayer',
    b2EmptyConfigsTitle: 'Aucune configuration',
    b2EmptyConfigsBody: 'Créez votre première configuration pour dessiner le plan de cet espace.',
    b2CreateConfigCta: 'Créer une configuration',
    b2ToastCreateFailedGeneric: 'Échec de la création',
    b2SpaceFallback: 'Espace',
    b2ChangeSpace: 'Changer d\'espace',
    b2UndoTitle: 'Annuler (Ctrl+Z)',
    b2RedoTitle: 'Rétablir (Ctrl+Y)',
    b2CloneConfigTitle: 'Cloner la configuration',
    b2NewConfigTitle: 'Nouvelle configuration',
    b2CloneConfigBody: 'Les mêmes éléments seront visibles dans la copie (copie des adhésions, instantanée).',
    b2NameLabel: 'Nom',
    b2Clone: 'Cloner',
    b2RenameConfigTitle: 'Renommer la configuration',
    b2Rename: 'Renommer',
    b2Saving: 'Enregistrement…',
    b2Offline: 'Hors ligne',
    b2Pending: 'en attente',
    b2SaveError: 'Erreur d\'enregistrement',
    b2Saved: 'Enregistré',
    b2SavedAgo: 'Enregistré · il y a {duration}',
    b2ToastCreateConfigFailed: 'Échec de la création de la configuration',
    b2ToastRenameFailed: 'Échec du renommage',
    b2CopySuffix: '(copie)',
    b2ConfigPlaceholder: 'Configuration',
    b2AreasTitle: 'Zones',
    b2NoZonesEmpty: 'Aucune zone — ajoutez un étage pour commencer.',
    b2ElementWord: 'élément',
    b2ElementsWord: 'éléments',
    b2ElementAbbrev: 'élém.',
    b2InThisConfig: 'dans cette config',
    b2ElementPaletteTitle: 'Palette d\'éléments',
    b2ExistingElementsSuffix: 'éléments existants',
    b2AllZones: 'Toutes',
    b2NoElementsInZone: 'Aucun élément de cette catégorie dans cette zone.',
    b2NoElementsCategory: 'Aucun élément de cette catégorie.',
    b2NoElementSelected: 'Aucun élément sélectionné',
    b2SelectElementHint: 'Cliquez sur un élément du plan, ou choisissez un outil dans la palette.',
    b2Duplicate: 'Dupliquer',
    b2PropertiesTitle: 'Propriétés',
    b2IdentityTitle: 'Identité',
    b2ChangeImage: 'Changer',
    b2Image: 'Image',
    b2RemoveImage: 'Retirer',
    b2GeometryTitle: 'Géométrie',
    b2PositionTitle: 'Position',
    b2CornerRadius: 'Rayon des coins',
    b2FloorArea: 'Surface au sol',
    b2Volume: 'Volume',
    b2AxisX: 'X',
    b2AxisY: 'Y',
    b2Width: 'Largeur',
    b2Depth: 'Profondeur',
    b2Height: 'Hauteur',
    b2Rotation: 'Rotation',
    b2RoundedCorners: 'Coins arrondis',
    b2CornersLinked: 'Coins liés',
    b2CornersIndependent: 'Coins indépendants',
    b2CornerTopLeft: 'Haut G',
    b2CornerTopRight: 'Haut D',
    b2CornerBottomLeft: 'Bas G',
    b2CornerBottomRight: 'Bas D',
    b2ConfigsTitle: 'Configurations',
    b2ConfigsVisibleIn: 'Configurations dans lesquelles cet élément est visible.',
    b2Active: 'active',
    b2ConfigsLastOneHint: 'Un élément appartient toujours à au moins une configuration — pour le retirer de la dernière, supprimez l\'élément.',
    b2UsageTitle: 'Utilisation',
    b2WeezeventMapped: 'Mappé Weezevent',
    b2WeezeventNotMapped: 'Non mappé Weezevent',
    b2MenuItems: 'menu item(s)',
    b2InOtherConfigs: 'dans d\'autres configs',
    b2ManageInSpaceMenu: 'Gérer dans Space Menu',
    b2UsageLinksHint: 'Ces liens sont préservés tant que l\'élément existe — sa suppression demandera une confirmation explicite.',
    b2PerformanceTitle: 'Performance',
    b2Revenue: 'Revenu total (€)',
    b2ElpRevenue: 'Revenu',
    b2SortByFloor: 'Par étage',
    b2SortByType: 'Par type',
    b2ElpItems: 'éléments',
    b2ElpSearchPlaceholder: 'Rechercher…',
    b2NumberOfPOS: 'Nb de POS',
    b2NumberOfTransactions: 'Total de transaction',
    b2TransactionsPerMinute: 'Trans./min',
    b2StaffCost: 'Coût staff (€)',
    b2RevenuePerEmployee: 'Revenu/employé (€)',
    b2ToastSavePerformanceFailed: 'Échec de l\'enregistrement des performances',
    b2MenuTitle: 'Menu',
    b2SearchMenuItemsPlaceholder: 'Rechercher des menu items...',
    b2NoResultsFor: 'Aucun résultat pour « {query} ».',
    b2MenuUnavailable: 'Menu indisponible pour ce shop ({error}).',
    b2NoMenuItemsAssigned: 'Aucun menu item assigné à ce shop.',
    b2ManageMenuInSpaceMenu: 'Gérer le menu dans Space Menu',
    b2InventoryTitle: 'Inventaire',
    b2SearchInventoryPlaceholder: 'Rechercher des articles d\'inventaire...',
    b2InventoryItemsLabel: 'Articles d\'inventaire',
    b2Component: 'Composant',
    b2Packaging: 'Packaging',
    b2UsedIn: 'Utilisé dans',
    b2MenuInventoryUnavailable: 'Inventaire du menu indisponible ({error}).',
    b2NoMenuItemsInventoryHint: 'Aucun menu item activé sur ce shop — l\'inventaire se dérive du menu.',
    b2CustomItems: 'Articles personnalisés',
    b2Remove: 'Retirer',
    b2AddCustomItemPlaceholder: 'Ajouter un article personnalisé...',
    b2ToastSaveInventoryFailed: 'Échec de l\'enregistrement de l\'inventaire',
    b2StorageWord: 'stockage',
    b2SoldIn: 'Vendu dans',
    b2AlertBelow: 'alerte ≤',
    b2InventoryUnavailable: 'Inventaire indisponible ({error}).',
    b2NoStockableShops: 'Aucun shop F&B ou Merch dans cette configuration — sélectionnez des shops dans la section Shops.',
    b2NoMenuItemsInventoryHintPlural: 'Aucun menu item activé sur les shops sélectionnés — l\'inventaire se dérive de leurs menus.',
    b2NoItemsMatchStorageTypes: 'Aucun item ne correspond aux types de stockage cochés.',
    b2ItemsFromFB: 'Articles des éléments F&B',
    b2ItemsFromMerch: 'Articles des éléments Merch',
    b2ShopsTitle: 'Shops',
    b2NoFbMerchElements: 'Aucun élément F&B ou Merch dans cette configuration.',
    b2SelectFbMerchHint: 'Sélectionnez les éléments F&B / Merch qui utilisent ce storage ({count} disponibles)',
    b2ThisStorage: 'Ce storage',
    b2Unassigned: 'Non assigné',
    b2SubtypesPrefix: 'Sous-types',
    b2WeezeventMappedWithLocation: 'Mappé Weezevent : {location}',
    b2MenuItemsAssignedTitle: '{count} menu item(s) assigné(s) dans cette configuration',
    b2StaffTitle: 'Staff',
    b2PositionPlaceholder: 'ex. Caissier, Cuisinier, Sécurité',
    b2Add: 'Ajouter',
    b2NoStaffYet: 'Aucun poste pour l’instant. Ajoutez-en un ci-dessus.',
    b2ToastSaveStaffFailed: 'Échec de l\'enregistrement du staff',
    b2SelectZoneToShowPlan: 'Sélectionnez une zone pour afficher le plan',
    b2ClickToEditDimensions: 'Cliquer pour éditer les dimensions',
    b2DrawingLabel: 'Dessin :',
    b2RotateElementTitle: 'Pivoter l\'élément de 15°',
    b2EditCornerRadiusTitle: 'Modifier le rayon des coins',
    b2ViewPropertiesTitle: 'Voir les propriétés',
    b2ExitFullscreen: 'Quitter le plein écran',
    b2EnterFullscreen: 'Passer en plein écran',
    b2ApplySameRadiusAllCorners: 'Appliquer le même rayon à tous les coins',
    b2CornerRadiusM: 'Rayon des coins (m)',
    b2CornerTopLeftFull: 'Haut gauche (m)',
    b2CornerTopRightFull: 'Haut droit (m)',
    b2CornerBottomLeftFull: 'Bas gauche (m)',
    b2CornerBottomRightFull: 'Bas droit (m)',
    b2IsoTitle: 'Vue 3D de l\'espace',
    b2DeleteEntityTitle: 'Supprimer « {name} » ?',
    b2OrphanWarning: '{count} élément(s) n\'appartiendront plus à aucune configuration :',
    b2ShopWeezeventLabel: 'shop Weezevent',
    b2ReassignToOtherConfig: 'Les rattacher à une autre configuration',
    b2DeleteAlsoDefinitive: 'Les supprimer aussi (définitif)',
    b2DeleteConfigNoOrphansHint: 'Les éléments visibles dans cette configuration restent disponibles dans leurs autres configurations. Cette action est définitive.',
    b2ToastDeleteConfigFailed: 'Échec de la suppression de la configuration',
    b2ElementIsUsed: 'Cet élément est utilisé :',
    b2WeezeventMappingLabel: 'Mapping Weezevent',
    b2MenuItemsAssignedCount: '{count} menu item(s) assigné(s)',
    b2DeleteElementLinksHint: 'Supprimer l\'élément supprimera aussi ces liens. Cette action est définitive.',
    b2DeleteElementNoRefsHint: 'Cet élément n\'est référencé nulle part. Cette action est définitive.',
    b2DeleteAnyway: 'Supprimer quand même',
    b2ElementReferencedFallback: 'Élément référencé',
    b2ToastDeleteFailed: 'Échec de la suppression',
    b2ZoneContainsLinkedElements: 'Cette zone contient {count} élément(s), dont {linkedCount} lié(s) :',
    b2ZoneHiddenElementsWillDelete: '{count} élément(s) de cette zone ne sont pas visibles dans la configuration active — ils seront supprimés aussi.',
    b2DeleteZoneLinkedHint: 'Supprimer la zone supprimera ces éléments et déliera leurs shops Weezevent et menus. Les locations Weezevent redeviendront non mappées (re-mappables dans Data Integration). Cette action est définitive.',
    b2ZoneContainsElementsWillDelete: 'Cette zone contient {count} élément(s) qui seront supprimés avec elle.',
    b2ZoneHiddenCountParenthetical: '({count} non visible(s) dans la configuration active.)',
    b2ActionIsFinal: 'Cette action est définitive.',
    b2ZoneEmptyHint: 'Cette zone est vide. Cette action est définitive.',
    b2UnlinkAndDelete: 'Délier et supprimer',
    b2ZoneNotDeletedUsedElements: 'Zone non supprimée : elle contient des éléments utilisés',
    b2ToastDeleteZoneFailed: 'Échec de la suppression de la zone',
    b2EditZoneTitle: 'Modifier la zone',
    b2EditZoneSubtitle: 'Modifier le nom et les dimensions',
    b2ZoneNamePlaceholder: 'Nom de la zone…',
    b2DimensionsLabel: 'Dimensions',
    b2WidthM: 'Largeur (m)',
    b2LengthM: 'Longueur (m)',
    b2HeightM: 'Hauteur (m)',
    b2AllCorners: 'Tous les coins',
    b2CornerTopLeftPlain: 'Haut gauche',
    b2CornerTopRightPlain: 'Haut droit',
    b2CornerBottomLeftPlain: 'Bas gauche',
    b2CornerBottomRightPlain: 'Bas droit',
    b2CreateHoleLabel: 'Créer un trou dans le sol (forme d\'anneau)',
    b2HoleWidthM: 'Largeur du trou (m)',
    b2HoleLengthM: 'Longueur du trou (m)',
    b2XPositionRange: 'Position X (0–1)',
    b2YPositionRange: 'Position Y (0–1)',
    b2HoleCornerRadiusLabel: 'Rayon des coins du trou',
    b2DragHoleHint: 'Faites glisser le trou dans la vue du plan pour le repositionner.',
    // === Integration (auto-i18n) ===
    intgShopsStep2: 'Étape 2',
    intgShopsUnmappedBulkHint: 'location(s) non mappée(s) — créer et mapper les shops DataFriday en masse.',
    intgShopsBulkCreateMap: 'Création & mapping en masse',
    intgShopsBulkProgressPrefix: 'Création & mapping en masse de',
    intgShopsBulkProgressSuffix: 'location(s)…',
    intgShopsSearchPlaceholder: 'Rechercher une location…',
    intgShopsTabAll: 'Tous',
    intgShopsTabMapped: 'Mappés',
    intgShopsTabUnmapped: 'Non mappés',
    intgShopsStatus: 'Statut',
    intgShopsNoLocationFound: 'Aucune location trouvée',
    intgShopsValidateSuggestion: 'Valider cette suggestion',
    intgShopsIgnore: 'Ignorer',
    intgShopsCreateShopFor: 'Créer un shop pour',
    intgShopsSaveError: 'Erreur de sauvegarde',
    intgShopsAssignFloor: 'Assigner un étage',
    intgShopsUnmappedWarnLabel: 'location(s) non-mappée(s)',
    intgShopsUnmappedWarnHint: 'Toutes les locations doivent être associées à un shop avant de continuer.',
    intgShopsStepConfig: 'Config',
    intgShopsStepZone: 'Zone',
    intgShopsStepPosition: 'Position',
    intgShopsConfiguration: 'Configuration',
    intgShopsLoading: 'Chargement…',
    intgShopsChange: 'Changer',
    intgShopsSelectConfig: 'Sélectionner une configuration…',
    intgShopsNoConfigAvailable: 'Aucune configuration disponible',
    intgShopsAddNewConfig: '+ Ajouter une nouvelle configuration',
    intgShopsZoneFloor: 'Zone / Étage',
    intgShopsGroundFloorShort: 'RDC',
    intgShopsElementsShort: 'él.',
    intgShopsExternalAreaShort: 'Espace Ext.',
    intgShopsNewFloor: 'Nouveau Floor',
    intgShopsNew: 'Nouveau',
    intgShopsNewBasement: 'Nouveau Sous-sol',
    intgShopsAdd: 'Ajouter',
    intgShopsAZone: 'une zone',
    intgShopsNoFloorInConfig: 'Aucun floor dans cette configuration — utilisez le bouton "Ajouter" ci-dessus',
    intgShopsZoneName: 'Nom de la zone',
    intgShopsZoneNamePlaceholder: 'Ex : RDC, Tribune Nord, Loges…',
    intgShopsZoneDimensions: 'Dimensions de la zone',
    intgShopsWidthM: 'Largeur (m)',
    intgShopsLengthM: 'Longueur (m)',
    intgShopsHeightM: 'Hauteur (m)',
    intgShopsDepthM: 'Profondeur (m)',
    intgShopsPositionOnPlan: 'Position sur le plan',
    intgShopsDragHint: 'Cliquez ou faites glisser pour positionner',
    intgShopsShopDimensions: 'Dimensions du shop',
    intgShopsApplyToLocations: 'Appliquer aussi à ces locations',
    intgShopsCancel: 'Annuler',
    intgShopsApply: 'Appliquer',
    intgShopsBulkMappingTitle: 'Mapping en masse',
    intgShopsUnmappedLocations: 'location(s) non mappée(s)',
    intgShopsMatchedNamePrefix: 'location(s) portent le même nom qu\'un shop existant :',
    intgShopsMatchedNameMid: 'elles seront simplement',
    intgShopsMapped: 'mappées',
    intgShopsMatchedNameSuffix: ', rien ne sera créé pour elles.',
    intgShopsNoNameMatch: 'Aucune location ne correspond à un shop existant par son nom.',
    intgShopsCreateMissingPrefix: 'Créer les',
    intgShopsCreateMissingSuffix: 'shop(s) manquant(s) dans le 3D Builder',
    intgShopsGridHint: 'Éléments 2×2 m posés en grille sur le RDC',
    intgShopsOfConfig: 'de la configuration',
    intgShopsBulkNotePrefix: 'Ces',
    intgShopsBulkNoteSuffix: 'location(s) resteront non mappées — aucun élément 3D ne sera créé.',
    intgShopsConfigRequired: 'Configuration requise',
    intgShopsNoConfigForSpace: 'Aucune configuration rattachée à cet espace',
    intgShopsCreateConfigInfo: 'Créez une configuration avant d\'ajouter des shops. Elle sera utilisée pour positionner les shops dans le 3D Builder.',
    intgShopsConfigName: 'Nom de la configuration',
    intgShopsConfigNamePlaceholder: 'Ex. Configuration principale',
    intgShopsGroundFloorLong: 'Rez-de-chaussée (RDC)',
    intgShopsGroundFloorName: 'Nom du rez-de-chaussée',
    intgShopsGroundFloorNamePlaceholder: 'Ex. RDC, Hall principal…',
    intgShopsSkip: 'Passer',
    intgShopsCreateConfig: 'Créer la configuration',
    intgShopsCreateShopTitle: 'Créer un shop DataFriday',
    intgShopsShopName: 'Nom du shop',
    intgShopsShopNamePlaceholder: 'Ex. Bar Principal, Merch Entrée…',
    intgShopsType: 'Type',
    intgShopsFloorZone: 'Étage / Zone',
    intgShopsSelectFloor: 'Sélectionner un étage…',
    intgShopsCreateAndMap: 'Créer et mapper',
    intgShopsCreateWord: 'Créer',
    intgShopsAndMapWord: 'et mapper',
    intgShopsMapWord: 'Mapper',
    intgShopsLocationsWord: 'location(s)',
    intgShopsBasementWord: 'Sous-sol',
    intgShopsFloorWord: 'Étage',
    intgShopsExternalAreaLong: 'Espace Externe',
    intgShopsNewLower: 'nouveau',
    intgShopsAddZone: 'Ajouter une zone',
    intgShopsMappingFailedSuffix: 'location(s) n\'ont pas pu être mappée(s).',
    intgShopsSelectConfigBeforeAssign: 'Sélectionnez une configuration avant d\'assigner les shops.',
    smmHeaderTitle: 'Mapper les produits du menu',
    smmHeaderStep: '— Étape 3',
    smmHeaderSub: 'Mappez chaque produit Weezevent à un article de votre menu DataFriday.',
    smmMapped: 'mappés',
    smmEmptyProducts: 'Aucun produit trouvé pour cette intégration.',
    smmAutoMappingOf: 'Mapping automatique de',
    smmSuggestion: 'suggestion',
    smmSuggestionsPlural: 'suggestions',
    smmSuggestionAvailable: 'suggestion automatique disponible',
    smmSuggestionsAvailablePlural: 'suggestions automatiques disponibles',
    smmView: 'Voir',
    smmMappingProgress: 'Mapping…',
    smmAutoMapAll: 'Tout auto-mapper',
    smmProduct: 'produit',
    smmProductsPlural: 'produits',
    smmWithoutMapping: 'sans mapping',
    smmItem: 'article',
    smmItemsPlural: 'articles',
    smmWithoutSpace: 'sans Space',
    smmCreateAndAttach: '— créer et rattacher automatiquement',
    smmItemAlreadyMapped: 'article déjà mappé sans Space associé',
    smmItemsAlreadyMappedPlural: 'articles déjà mappés sans Space associé',
    smmWithoutSpaceAttach: '— rattacher automatiquement',
    smmCreateAndMapAll: 'Tout créer et mapper',
    smmItemMappedPrice: 'article mappé dont le prix DataFriday diffère du prix Weezevent',
    smmItemsMappedPricePlural: 'articles mappés dont le prix DataFriday diffère du prix Weezevent',
    smmApplyingProgress: 'Application…',
    smmApplyWeezeventPrices: 'Appliquer les prix Weezevent',
    smmTabAll: 'Tous',
    smmTabMapped: 'Mappés',
    smmTabUnmapped: 'Non mappés',
    smmHideUnsoldTitle: 'Masquer les produits du catalogue jamais vendus (aucun prix).',
    smmHiddenSuffix: 'masqué(s).',
    smmHideUnsold: 'Masquer sans vente',
    smmColProduct: 'Produit (Weezevent)',
    smmColMenuItem: 'Élément Menu',
    smmColMatch: 'Match',
    smmNoProductFound: 'Aucun produit trouvé',
    smmHtTag: 'HT',
    smmTtcTag: 'TTC',
    smmSelectOption: 'Sélectionner…',
    smmPricelineDfTitle: 'Prix DataFriday actuel de l\'article (HT ; TTC indiqué à côté)',
    smmPriceInSpace: 'Prix dans cet espace :',
    smmApplyWeezeventPricePrefix: 'Appliquer le prix Weezevent',
    smmApplyWeezeventPriceSuffix: 'à l\'article',
    smmApply: 'Appliquer',
    smmPriceApplied: 'Prix appliqué',
    smmUpToDate: 'à jour',
    smmPriceHistoryTitle: 'Historique des prix de l\'article',
    smmAcceptSuggestion: 'Valider cette suggestion',
    smmIgnore: 'Ignorer',
    smmCreateMenuItemForPrefix: 'Créer article menu pour',
    smmSaveError: 'Erreur de sauvegarde',
    smmPaginationOf: 'sur',
    smmPrevious: 'Précédent',
    smmPage: 'Page',
    smmNext: 'Suivant',
    smmUnmappedProductsWarn: 'produit(s) non-mappé(s)',
    smmAllMustBeMapped: '— Tous les produits doivent être associés à un article menu avant de continuer.',
    smmLoadingCategories: 'Chargement des catégories…',
    smmCreateProductType: 'Créer un type de produit',
    smmTypeName: 'Nom du type',
    smmCancel: 'Annuler',
    smmCreate: 'Créer',
    smmCreateCategory: 'Créer une catégorie',
    smmLinkedToType: 'Liée au type',
    smmCategoryName: 'Nom de la catégorie',
    smmBulkTitle: 'Création automatique',
    smmBulkSub: 'Création & mapping en masse des produits',
    smmPhasePatchingTitle: 'Rattachement au Space…',
    smmPhaseSyncTitle: 'Mise à jour du catalogue…',
    smmPhasePreparingTitle: 'Préparation des catégories…',
    smmPhaseCreatingTitle: 'Création des articles de menu…',
    smmPhaseDoneTitle: 'Opération terminée',
    smmPhaseInterruptedTitle: 'Opération interrompue',
    smmPhasePatchingSub: 'Association des articles existants au Space courant…',
    smmPhaseSyncSub: 'Enrichissement des données produits en cours…',
    smmPhasePreparingSub: 'Vérification et création des types & catégories DataFriday',
    smmProductsProcessed: 'produits traités',
    smmProductsFailed: 'produit(s) en échec',
    smmClose: 'Fermer',
    smmAutoSuggestionsTitle: 'Suggestions automatiques',
    smmMatch: 'correspondance',
    smmMatchesPlural: 'correspondances',
    smmClickApplyHint: '— cliquez sur Appliquer pour confirmer une par une',
    smmNoSuggestionAvailable: 'Aucune suggestion disponible.',
    smmApplyAll: 'Tout appliquer',
    smmPriceHistoryDialogTitle: 'Historique des prix',
    smmLoadingHistory: 'Chargement de l\'historique…',
    smmNoPriceChange: 'Aucun changement de prix enregistré pour cet article.',
    smmHistDate: 'Date',
    smmHistPriceTtc: 'Prix (TTC)',
    smmHistVat: 'TVA',
    smmHistSource: 'Source',
    smmProductFallback: 'Produit',
    smmCreateTypeOption: '+ Créer un type…',
    smmCreateCategoryOption: '+ Créer une catégorie…',
    smmStepCatalog: 'Catalogue',
    smmStepCategories: 'Catégories',
    smmStepCreation: 'Création',
    smmApplyPriceError: 'Échec de l\'application du prix Weezevent',
    smmApplyPricesError: 'Échec de l\'application des prix Weezevent',
    smmSourceCatalog: 'Catalogue Weezevent',
    smmSourceSales: 'Ventes (prix modal)',
    smmSourceManual: 'Manuel',
    smmMappingsAppliedMid: 'mapping(s) appliqué(s),',
    smmFailedSuffix: 'en échec.',
    smmMappingsApplied: 'mapping(s) appliqué(s).',
    smmAutoMappingFailed: 'Le mapping automatique a échoué.',
    smmNameRequired: 'Le nom est requis',
    smmCannotCreateType: 'Impossible de créer le type',
    smmCreationFailed: 'Échec de la création',
    smmSelectTypeFirst: 'Sélectionnez un type d\'abord',
    smmCannotCreateCategory: 'Impossible de créer la catégorie',
    smmItemsAttachedMid: 'article(s) rattaché(s).',
    smmItemsAttachedToSpace: 'article(s) rattaché(s) au Space.',
    smmBatchCreateFailed: 'Un lot de produits n\'a pas pu être créé.',
    smmLastError: 'Dernière erreur :',
    smmProductsCreatedMappedOn: 'produit(s) créé(s) et mappé(s) sur',
    smmProductsNotProcessed: 'produit(s) n\'ont pas été traités.',
    smmBulkFatalError: 'Une erreur est survenue pendant la création automatique.',
    intgSpaceHeaderTitlePrefix: 'Associer',
    intgSpaceHeaderTitleSuffix: 'à un espace',
    intgSpaceHeaderStep: '— Étape 1',
    intgSpaceHeaderSub: 'Sélectionnez un espace existant ou créez-en un nouveau. Toutes les locations (points de vente) seront rattachées à cet espace.',
    intgSpaceBadgeAssociated: 'Associé',
    intgSpaceBadgePending: 'En attente',
    intgSpaceSuggestionLabel: 'Suggestion :',
    intgSpaceSimilarity: 'similitude',
    intgSpaceUse: 'Utiliser',
    intgSpaceSelectedSuccess: 'sélectionné avec succès.',
    intgSpaceExisting: 'Espace existant',
    intgSpaceSelectPlaceholder: 'Sélectionner un Space…',
    intgSpaceDeselect: 'Désélectionner',
    intgSpaceOrCreateNew: 'ou créer un nouveau',
    intgSpaceCreateNewTitle: 'Créer un nouveau Space',
    intgSpaceCreateNewSub: 'Définissez la structure de base',
    intgSpaceSectionIdentity: 'Identité',
    intgSpaceFieldName: 'Nom *',
    intgSpaceFieldPlaceType: 'Type de lieu',
    intgSpaceSelectEmpty: 'Sélectionner…',
    intgSpaceFieldMaxCapacity: 'Capacité max',
    intgSpaceFieldDepartment: 'Département',
    intgSpaceFieldHomeTeam: 'Équipe domicile',
    intgSpaceSectionAddress: 'Adresse',
    intgSpaceFieldAddress: 'Adresse',
    intgSpaceFieldAddress2: 'Complément d\'adresse',
    intgSpaceFieldCity: 'Ville',
    intgSpaceFieldPostcode: 'Code postal',
    intgSpaceFieldCountry: 'Pays',
    intgSpaceSectionContact: 'Contact',
    intgSpaceFieldEmail: 'Email',
    intgSpaceFieldPhone: 'Téléphone',
    intgSpaceFieldContactPerson: 'Responsable',
    intgSpaceFieldContactEmail: 'Email contact',
    intgSpaceFieldContactPhone: 'Tél. contact',
    intgSpaceSectionSocial: 'Réseaux sociaux',
    intgSpaceCreateSpaceBtn: 'Créer le Space',
    intgSpaceDialogTitle: 'Configuration initiale',
    intgSpaceDialogSub: 'Définissez la configuration par défaut et le premier étage',
    intgSpaceConfigName: 'Nom de la configuration',
    intgSpaceGroundFloor: 'Rez-de-chaussée (RDC)',
    intgSpaceFloorName: 'Nom du rez-de-chaussée',
    intgSpaceDimensions: 'Dimensions',
    intgSpaceWidth: 'Largeur (m)',
    intgSpaceLength: 'Longueur (m)',
    intgSpaceSkip: 'Passer',
    intgSpaceCreateConfigBtn: 'Créer la configuration',
    intgSpaceNext: 'Suivant',
    intgSpaceErrNameRequired: 'Le nom est obligatoire',
    intgSpaceErrEmailInvalid: 'Adresse email invalide',
    intgSpaceErrPositiveValue: 'La valeur doit être positive',
    intgSpaceErrDepartmentInvalid: 'Numéro de département invalide',
    intgSyncHeaderTitle: 'Synchronisation finale',
    intgSyncHeaderSub: 'Nettoyage, retraitement et génération des résumés consolidés pour l\'espace sélectionné.',
    intgSyncBadgeReady: 'Prêt',
    intgSyncBadgeInProgress: 'En cours',
    intgSyncBadgeDone: 'Terminé',
    intgSyncBadgeError: 'Erreur',
    intgSyncWhatHappens: 'Que va-t-il se passer ?',
    intgSyncStepCleanup: 'Nettoyage des agrégations obsolètes',
    intgSyncStepReprocess: 'Retraitement complet des transactions',
    intgSyncStepDailyAgg: 'Calcul des agrégations journalières',
    intgSyncStepSummaries: 'Génération des résumés consolidés',
    intgSyncStartBtn: 'Lancer la synchronisation',
    intgSyncInProgressTitle: 'Synchronisation en cours…',
    intgSyncElapsed: 'Temps écoulé :',
    intgSyncEstimate: 'Estimation : ~2 min',
    intgSyncPhase: 'Phase',
    intgSyncDoneTitle: 'Synchronisation terminée.',
    intgSyncDoneSub: 'Toutes les données ont été traitées avec succès.',
    intgSyncStatEvents: 'Événements',
    intgSyncStatTransactions: 'Transactions',
    intgSyncStatAggregations: 'Agrégations',
    intgSyncFinishBtn: 'Terminer',
    intgSyncErrorTitle: 'Erreur de synchronisation.',
    intgSyncRetryBtn: 'Réessayer',
    intgSyncPhaseCleanup: 'Nettoyage des anciennes données',
    intgSyncPhaseProcessing: 'Retraitement des transactions',
    intgSyncPhaseAggregating: 'Calcul des agrégations journalières',
    intgSyncPhaseSummaries: 'Génération des résumés',
    intgCreateEvtHeaderTitle: 'Créer un événement',
    intgCreateEvtHeaderSub: 'Associé à une date sans couverture',
    intgCreateEvtSectionInfo: 'Informations',
    intgCreateEvtNameLabel: 'Nom de l\'événement',
    intgCreateEvtNamePlaceholder: 'Ex. Match de Ligue 1',
    intgCreateEvtSectionDates: 'Dates',
    intgCreateEvtStartDate: 'Date de début',
    intgCreateEvtEndDate: 'Date de fin',
    intgCreateEvtEndTime: 'Heure de fin',
    intgCreateEvtSectionTaxonomy: 'Taxonomie',
    intgCreateEvtTypeLabel: 'Type d\'événement',
    intgCreateEvtCreateType: '+ Créer un type',
    intgCreateEvtSelectPlaceholder: 'Sélectionner…',
    intgCreateEvtCategoryLabel: 'Catégorie',
    intgCreateEvtCreateCategory: '+ Créer une catégorie',
    intgCreateEvtSubcategoryLabel: 'Sous-catégorie',
    intgCreateEvtCreateSubcategory: '+ Créer une sous-catégorie',
    intgCreateEvtHideOptions: 'Masquer',
    intgCreateEvtMoreOptions: 'Plus d\'options',
    intgCreateEvtSectionTicketing: 'Billetterie',
    intgCreateEvtTicketsSold: 'Tickets vendus',
    intgCreateEvtTicketsScanned: 'Tickets scannés',
    intgCreateEvtSectionFlow: 'Déroulement',
    intgCreateEvtOpeningAct: 'Acte d\'ouverture',
    intgCreateEvtIntermission: 'Mi-temps / Entracte',
    intgCreateEvtSectionSessions: 'Sessions',
    intgCreateEvtSessionCount: 'Nombre de sessions',
    intgCreateEvtSessionTitle: 'Session',
    intgCreateEvtDoorsOpening: 'Ouverture des portes',
    intgCreateEvtKickoff: 'Coup d\'envoi',
    intgCreateEvtCancel: 'Annuler',
    intgCreateEvtSubmit: 'Créer l\'événement',
    intgCreateEvtTypeDialogTitle: 'Créer un type d\'événement',
    intgCreateEvtTypeNameLabel: 'Nom du type',
    intgCreateEvtTypeNamePlaceholder: 'Ex. Sport',
    intgCreateEvtCreate: 'Créer',
    intgCreateEvtCategoryDialogTitle: 'Créer une catégorie',
    intgCreateEvtLinkedToType: 'Liée au type',
    intgCreateEvtCategoryNameLabel: 'Nom de la catégorie',
    intgCreateEvtCategoryNamePlaceholder: 'Ex. Football',
    intgCreateEvtSubDialogTitle: 'Créer une sous-catégorie',
    intgCreateEvtLinkedToCategory: 'Liée à la catégorie',
    intgCreateEvtSubNameLabel: 'Nom de la sous-catégorie',
    intgCreateEvtSubNamePlaceholder: 'Ex. Ligue 1',
    intgCreateEvtNameRequired: 'Le nom est requis',
    intgCreateEvtCannotCreateType: 'Impossible de créer le type',
    intgCreateEvtCannotCreateCategory: 'Impossible de créer la catégorie',
    intgCreateEvtCannotCreateSub: 'Impossible de créer la sous-catégorie',
    intgCreateEvtCreateFailed: 'Échec de la création',
    intgEnrichEvtTitle: 'Enrichir l\'événement',
    intgEnrichEvtDoorsOpening: 'Ouverture des portes',
    intgEnrichEvtShowTime: 'Heure du show / coup d\'envoi',
    intgEnrichEvtTimeHint: 'Format HH:MM',
    intgEnrichEvtCategory: 'Catégorie',
    intgEnrichEvtType: 'Type d\'événement',
    intgEnrichEvtTypeHome: 'Domicile',
    intgEnrichEvtTypeAway: 'Extérieur',
    intgEnrichEvtTypeNeutral: 'Neutre',
    intgEnrichEvtHomeTeam: 'Équipe domicile',
    intgEnrichEvtVisitingTeam: 'Équipe visiteur',
    intgEnrichEvtIntermission: 'Mi-temps / Entracte',
    intgEnrichEvtCancel: 'Annuler',
    intgEnrichEvtSave: 'Enregistrer',
    intgMapEvtTitle: 'Mapper à un événement existant',
    intgMapEvtDescBefore: 'Les transactions du',
    intgMapEvtDescAfter: 'seront rattachées à l\'événement sélectionné en mettant à jour sa date.',
    intgMapEvtSelectLabel: 'Événement existant',
    intgMapEvtCancel: 'Annuler',
    intgMapEvtConfirm: 'Confirmer',
    intgBreakdownTitle: 'Analyse',
    intgBreakdownKpiRevenue: 'CA HT',
    intgBreakdownKpiTransactions: 'Transactions',
    intgBreakdownKpiItems: 'Articles',
    intgBreakdownKpiShops: 'Shops',
    intgBreakdownTabByShop: 'Par shop',
    intgBreakdownTabByItem: 'Par article',
    intgBreakdownTabPerMinute: 'CA / minute',
    intgBreakdownColShop: 'Shop',
    intgBreakdownColRevenue: 'CA HT',
    intgBreakdownColTx: 'Tx',
    intgBreakdownColArt: 'Art.',
    intgBreakdownColArticle: 'Article',
    intgBreakdownColQty: 'Qté',
    intgBreakdownNoData: 'Aucune donnée disponible.',
    intgBreakdownChartRevenue: 'CA HT (€)',
    intgBreakdownChartTransactions: 'Transactions',
    intgTimelineHeaderTitle: 'Dates non couvertes',
    intgTimelineHeaderStep: '— Étape 4',
    intgTimelineHeaderSub: 'Créez ou mappez un événement DataFriday pour chaque date avant synchronisation.',
    intgTimelineUncoveredDatesCount: 'date(s) non couverte(s)',
    intgTimelineWeezeventTransactions: 'transactions Weezevent',
    intgTimelineLinkedToEvent: 'liées à un événement',
    intgTimelineWithoutEvent: 'sans événement',
    intgTimelineUnmappedLocations: 'location(s) non mappée(s)',
    intgTimelineEvent: 'événement',
    intgTimelineWeezeventUnlinked: 'Weezevent non lié',
    intgTimelineWithoutSpace: 'sans Space',
    intgTimelineCreateAndAttachAuto: '— créer et rattacher automatiquement',
    intgTimelineLinked: 'lié',
    intgTimelineWithoutSpaceAttachAuto: 'sans Space associé — rattacher automatiquement',
    intgTimelineCreateAndLinkAll: 'Tout créer et lier',
    intgTimelineTabCovered: 'Couvertes',
    intgTimelineTabUncovered: 'Non couvertes',
    intgTimelineTabAll: 'Toutes',
    intgTimelineDatesWithoutDfEvent: 'Dates sans événement DataFriday',
    intgTimelineColDate: 'Date',
    intgTimelineColTransactions: 'Transactions',
    intgTimelineColActions: 'Actions',
    intgTimelineBtnMap: 'Mapper',
    intgTimelineBtnCreate: 'Créer',
    intgTimelineAllCoveredTitle: 'Toutes les dates sont couvertes',
    intgTimelineAllCoveredSub: '— aucune date avec transactions sans événement DataFriday.',
    intgTimelineDfEventsCreated: 'Événements DataFriday créés',
    intgTimelineColDateName: 'Date / Nom',
    intgTimelineColDataPoints: 'Data points',
    intgTimelineDataPointTooltip: '1 data point = CA HT + nb transactions + quantités vendues pour une combinaison unique (minute × PDV × article).',
    intgTimelineColStatus: 'Statut',
    intgTimelineStatusAggregated: 'Agrégé',
    intgTimelineStatusUnprocessed: 'Non traité',
    intgTimelineViewAnalysisTooltip: 'Voir l\'analyse timeline',
    intgTimelineBtnAnalysis: 'Analyse',
    intgTimelineRerunAggTooltip: 'Relancer l\'agrégation',
    intgTimelineRunAggTooltip: 'Lancer l\'agrégation',
    intgTimelineBtnRerun: 'Relancer',
    intgTimelineBtnAggregate: 'Agréger',
    intgTimelineBtnDelete: 'Supprimer',
    intgTimelineNoDfEvents: 'Aucun événement DataFriday créé pour cet espace.',
    intgTimelineSyncDoneBadge: 'Terminée',
    intgTimelinePhase: 'Phase',
    intgTimelineVerifyingStatuses: 'Vérification des statuts et du contexte Step 4...',
    intgTimelineSyncError: 'Erreur lors de la synchronisation.',
    intgTimelineBtnRetry: 'Réessayer',
    intgTimelineFinishConfig: 'Terminer la configuration',
    intgTimelineBulkTitle: 'Création en masse',
    intgTimelineBulkSub: 'Association des événements Weezevent',
    intgTimelineBulkPatchingTitle: 'Rattachement au Space…',
    intgTimelineBulkCreatingTitle: 'Création des événements…',
    intgTimelineBulkDoneTitle: 'Opération terminée',
    intgTimelineBulkInterruptedTitle: 'Opération interrompue',
    intgTimelineBulkPatchingSub: 'Association des événements existants au Space courant…',
    intgTimelineBulkEventsProcessed: 'événements traités',
    intgTimelineBulkEventsFailed: 'événement(s) en échec',
    intgTimelineBtnClose: 'Fermer',
    intgTimelineStepCleanup: 'Nettoyage des anciennes données',
    intgTimelineStepProcessing: 'Retraitement des transactions',
    intgTimelineStepAggregating: 'Calcul des agrégations journalières',
    intgTimelineStepSummaries: 'Génération des résumés',
    intgTimelineFinalVerification: 'Vérification finale',
    intgTimelineFinalSync: 'Synchronisation finale',
    intgTimelineSyncPrimaryVerify: 'Tous les événements sont déjà agrégés. Vérifie la cohérence sans reconstruction complète.',
    intgTimelineSyncPrimaryFull: 'Nettoie les anciennes agrégations et recalcule tous les résumés consolidés.',
    intgTimelineSyncSecondaryVerify: 'Rapide, sans effacer ni recalculer toutes les agrégations.',
    intgTimelineSyncSecondaryFull: 'À lancer une fois toutes les dates couvertes.',
    intgTimelineRunVerification: 'Lancer la vérification',
    intgTimelineRunSync: 'Lancer la synchronisation',
    intgTimelineVerifyingLabel: 'Vérification en cours...',
    intgTimelineSyncingLabel: 'Synchronisation en cours...',
    intgTimelineVerifyDoneTitle: 'Vérification terminée !',
    intgTimelineSyncDoneTitle: 'Synchronisation terminée !',
    intgTimelineEventsVerified: 'événements vérifiés',
    intgTimelineAggregatedWord: 'agrégé',
    intgTimelineTransactionsMatched: 'transactions matchées',
    intgTimelineInitializing: 'Initialisation...',
    intgTimelineAggDone: 'Agrégation terminée.',
    intgTimelineAggSlow: 'L\'agrégation prend plus de temps que prévu — le suivi reprendra au rechargement.',
    intgTimelineProcessingBackground: 'Traitement en cours en arrière-plan — actualisation dans 5 s…',
    intgTimelineAggErrorPrefix: 'Erreur d\'agrégation :',
    intgTimelineSyncFailed: 'La synchronisation a échoué.',
    intgTimelineDeleteConfirmPrefix: 'Supprimer l\'événement',
    intgTimelineDeleteConfirmSuffix: '? La date repassera en « Non couverte ».',
    intgTimelineDeletedSuffix: 'supprimé.',
    intgTimelineDeleteError: 'Erreur lors de la suppression.',
    intgTimelineBreakdownError: 'Impossible de charger les détails.',
    intgTimelineMapSuccess: 'Événement mis à jour et date couverte.',
    intgTimelineMapErrorPrefix: 'Erreur lors du mapping :',
    intgTimelineEventFallbackName: 'Evenement',
    intgTimelineBulkEventsAttached: 'événement(s) rattaché(s) au Space.',
    intgTimelineBulkSkippedNoDate: 'ignoré(s) (sans date).',
    intgTimelineBulkCreatedOn: 'événement(s) créé(s) sur',
    intgTimelineBulkFailedShort: 'en échec.',
    intgTimelineBulkCreatedLinked: 'événement(s) créé(s) et liés au Space.',
    intgTimelineGenericError: 'Une erreur est survenue.',
    intgTimelineWeezLinked: 'Événement Weezevent lié.',
    intgTimelineLinkRemoved: 'Lien supprimé.',
    intgTimelineLinkSaveError: 'Erreur lors de la sauvegarde du lien.',
    intgTimelineEnrichSuccess: 'Événement enrichi avec succès.',
    intgTimelineSaveError: 'Erreur lors de la sauvegarde.',
    intgTimelineCsvMinute: 'Minute',
    intgTimelineCsvShop: 'Shop',
    intgTimelineCsvShopType: 'Type shop',
    intgTimelineCsvArticle: 'Article',
    intgTimelineCsvCategory: 'Catégorie',
    intgTimelineCsvQuantity: 'Quantité',
    intgTimelineCsvTransactions: 'Transactions',
    intgTimelineCsvRevenueHt: 'CA HT (€)',
    intgTimelineAttendeesSyncedTotal: 'spectateurs synchronisés au total.',
    intgTimelineAttendeesSynced: 'spectateurs synchronisés.',
    intgTimelineAttendeesSyncError: 'Erreur lors de la sync des spectateurs.',
    intgSyncProgTitleDone: 'Synchronisation terminée',
    intgSyncProgTitle: 'Synchronisation Weezevent',
    intgSyncProgFrom: 'Du',
    intgSyncProgTo: 'au',
    intgSyncProgDuration: 'Durée :',
    intgSyncProgPhase1Label: 'Phase 1 — Collecte Weezevent',
    intgSyncProgTransactions: 'transactions',
    intgSyncProgSegments: 'segments',
    intgSyncProgPhase2Label: 'Phase 2 — Insertion en base',
    intgSyncProgStatCollected: 'Collectées',
    intgSyncProgStatNew: 'Nouvelles',
    intgSyncProgStatDuplicates: 'Doublons ignorés',
    intgSyncProgSyncFailed: 'La synchronisation a échoué.',
    intgSyncProgInDb: 'en base',
    intgSyncProgNewPlural: 'nouveaux',
    intgSyncProgInDbEllipsis: 'en base…',
    intgSyncProgStarting: 'démarrage...',
    intgSyncProgError: 'Erreur',
    intgSyncProgDataInDb: 'Données en base',
    intgSyncProgStatTransactions: 'Transactions',
    intgSyncProgStatEvents: 'Événements',
    intgSyncProgStatProducts: 'Produits',
    intgSyncProgStatLocations: 'Lieux',
    intgSyncProgStatMerchants: 'Marchands',
    intgSyncProgHasMore: 'D\'autres transactions sont disponibles — relancez la synchronisation pour importer la suite.',
    intgSyncProgLocationsDetected: 'Locations détectées',
    intgSyncProgUnmapped: 'non mappées',
    intgSyncProgNotYetMapped: '→ pas encore mappé',
    intgSyncProgLocationsHint: 'Ces locations doivent être associées à des espaces pour activer l\'analyse des données.',
    intgSyncProgLastTransaction: 'Dernière transaction Weezevent :',
    intgSyncProgUnknown: 'inconnue',
    intgSyncProgLastSync: 'Dernière synchronisation :',
    intgSyncProgNever: 'jamais',
    intgSyncProgCloseBackground: 'Fermer — la sync continue en arrière-plan',
    intgSyncProgClose: 'Fermer',
    intgSyncProgResyncPeriod: 'Re-synchroniser une autre période',
    intgSyncProgCancel: 'Annuler',
    intgSyncProgRetrySync: 'Relancer la synchronisation',
    intgSyncProgConfigureLocations: 'Configurer les locations',
    intgSyncProgRelSecondsAgo: 'il y a quelques secondes',
    intgSyncProgRelAgo: 'il y a',
    intgProviderActive: 'Intégration active',
    intgProviderSync: 'Synchroniser',
    intgProviderImporting: 'Importation des données Weezevent...',
    intgProviderImportingHint: 'Cela peut prendre quelques instants',
    intgProviderLocations: 'Locations',
    intgProviderNoLocation: 'Aucune location trouvée',
    intgProviderNoLocationHint: 'Cliquez sur Synchroniser pour importer vos données Weezevent.',
    intgProviderImportData: 'Importer les données',
    intgLocationFallback: 'Location',
    intgLocationSpace: 'Espace :',
    intgLocationNoSpace: 'Aucun espace associé',
    intgLocationBtnConfigure: 'Configurer',
    intgLocationBtnContinue: 'Continuer',
    intgLocationBtnDetails: 'Voir détails',
    intgOverviewTitle: 'Configuration de l\'intégration',
    intgOverviewDescPrefix: 'Avant que les données apparaissent dans vos analyses, cette location doit être configurée en',
    intgOverviewDescSteps: '4 étapes',
    intgOverviewDescSuffix: '.',
    intgOverviewDone: 'Fait',
    intgOverviewTodo: 'À faire',
    intgOverviewStart: 'Commencer la configuration',
    intgOverviewFallbackName: 'Intégration',
    intgOverviewStepSpaceLabel: 'Associer un espace',
    intgOverviewStepSpaceDesc: 'Liez cette location à un espace DataFriday',
    intgOverviewStepShopsLabel: 'Mapper les Locations (points de vente)',
    intgOverviewStepShopsDesc: 'Associez les locations (points de vente) Weezevent à vos shops internes',
    intgOverviewStepProductsLabel: 'Mapper les produits',
    intgOverviewStepProductsDesc: 'Associez les produits aux items de votre menu',
    intgOverviewStepEventsLabel: 'Traitement & Synchronisation',
    intgOverviewStepEventsDesc: 'Agrégez les données par événement et synchronisez les résumés',
    intgWizardFallbackName: 'Intégration',
    intgWizardHeaderSub: 'Configuration Weezevent',
    intgWizardStepsLabel: 'étapes',
    intgWizardClose: 'Fermer',
    intgWizardPrevious: 'Précédent',
    intgWizardStepSpace: 'Espace',
    intgWizardStepLocations: 'Locations',
    intgWizardStepMenu: 'Menu',
    intgWizardStepEvents: 'Événements',
    intgSuccessReady: 'est prêt !',
    intgSuccessSub: 'Les données sont maintenant disponibles dans vos analyses F&B.',
    intgSuccessSummaryLabel: 'Résumé de la configuration',
    intgSuccessMerchants: 'Marchands mappés',
    intgSuccessProducts: 'Produits mappés',
    intgSuccessEvents: 'Événements traités',
    intgSuccessOtherLocationsPlural: 'autres locations à configurer',
    intgSuccessOtherLocationsSingular: 'autre location à configurer',
    intgSuccessStepsLabel: 'étapes',
    intgSuccessConfigure: 'Configurer',
    intgSuccessBackToIntegrations: 'Retour aux intégrations',
    intgSuccessViewAnalytics: 'Voir les analyses',
    intgSuccessFallbackName: 'Location',
    // === ProfileView (i18n) ===
    profileCopied: 'Copié !',
    profileCopy: 'Copier',
    profilePersonalInfoTitle: 'Informations personnelles',
    profilePersonalInfoSubtitle: 'Modifiez votre prénom, nom et coordonnées',
    profileFirstName: 'Prénom',
    profileFirstNamePlaceholder: 'Votre prénom',
    profileLastName: 'Nom',
    profileLastNamePlaceholder: 'Votre nom',
    profileEmail: 'Email',
    profileReadonly: 'non modifiable',
    profilePhone: 'Téléphone',
    profilePhonePlaceholder: '+33 6 00 00 00 00',
    profileUpdated: 'Profil mis à jour',
    profileSave: 'Sauvegarder',
    profileSecurity: 'Sécurité',
    profileSecuritySubtitle: 'Mettez à jour votre mot de passe',
    profileNewPassword: 'Nouveau mot de passe',
    profileConfirmPassword: 'Confirmer le mot de passe',
    profilePasswordMismatch: 'Les mots de passe ne correspondent pas',
    profilePasswordUpdated: 'Mot de passe mis à jour',
    profileUpdate: 'Mettre à jour',
    profileUserFallback: 'Utilisateur',
    profilePwdVeryWeak: 'Très faible',
    profilePwdWeak: 'Faible',
    profilePwdMedium: 'Moyen',
    profilePwdStrong: 'Fort',
    profileErrorGeneric: 'Une erreur est survenue',
    profilePasswordError: 'Impossible de mettre à jour le mot de passe',
    // inv — tous les PdV F&B de la config visibles (PdV sans article marqués, jamais masqués)
    invCardNoMenuAssigned: 'Aucun article de menu assigné à ce point de vente.',
    invShopClosed: 'Fermé',
    invShopOpen: 'Ouvert',
    invSort: 'Tri',
    invSortName: 'Nom',
    invSortToCount: 'À compter d\'abord',
    invSortStockAsc: 'Stock croissant',
    // inv — onglet Stockages : filtres gauche + résumé droite
    invFilterStorages: 'Stockages',
    invFilterFloors: 'Étages',
    invFilterInventoryItems: 'Articles d\'inventaire',
    invSearchStorage: 'Rechercher un stockage',
    invStorageAggTitle: 'Résumé stockages',
    invAggDetailByStorage: 'Détail par stockage',
    invStorageAggEmpty: 'Aucun article de stockage à compter.',
    invStorageAggFocusHint: 'Comptage en cours — ce stockage uniquement.',
    // === Analyse screen (i18n) ===
    anDemoDataShown: 'données de démonstration affichées.',
    anWeezeventIncompleteTitle: 'Configuration Weezevent incomplète',
    anWeezeventIncompleteBody: 'Les tables de données ne sont pas encore créées pour ce tenant. Complétez l\'intégration Weezevent (wizard étapes 1–4) pour voir les données de vente.',
    anPredictModeActive: 'Mode prévision activé',
    anFutureEventsIncluded: 'évènements futurs inclus',
    anFutureEventIncluded: 'évènement futur inclus',
    anPredictModeExplanation: 'Les chiffres prévisionnels sont calculés à partir des évènements passés similaires (scoring pondéré + scaling attendance).',
    anCalculatingForecasts: 'Calcul des prévisions…',
    anLoadingTimelineFor: 'Chargement de la timeline pour',
    anEventsPlural: 'évènements',
    anEventSingular: 'évènement',
    anAggregating15Min: 'Agrégation par tranches de 15 minutes en cours.',
    anSpaceDefault: 'Espace',
    anLoadingEventPredict: 'Chargement Event Predict…',
    anLoadingPredict: 'Chargement Predict…',
    anLoadingAnalyse: 'Chargement Analyse…',
    anHeaderChangeSpace: 'Changer d\'espace',
    anHeaderSearchSpace: 'Rechercher un espace…',
    anHeaderLoading: 'Chargement…',
    anHeaderNoSpaceAvailable: 'Aucun espace disponible',
    anHeaderNoSpaceFound: 'Aucun espace trouvé',
    anHeaderAllSpaces: 'Tous les espaces',
    anHeaderHome: 'Accueil',
    anHeaderSignOut: 'Se déconnecter',
    breadcrumbHome: 'Accueil',
    breadcrumbMenuFb: 'Menu F&B',
    analyseTitle: 'Analyse',
    analyseSubtitle: 'Vue analytique',
    anHeaderAnalysisAssistant: 'Assistant d\'analyse',
    anHeaderUser: 'Utilisateur',
    anHeaderKpiRevenue: 'CA',
    anHeaderKpiAvgPerEvent: 'Moy./Évén.',
    anHeaderKpiCost: 'Coût',
    anHeaderKpiTransactions: 'Transac.',
    anHeaderKpiBasket: 'Panier',
    anHeaderKpiAttendees: 'Spectateurs',
    anHeaderKpiTransformation: 'Transfo',
    anHeaderKpiPerCap: 'Per cap',
    anKpiCardMargin: '% Marge',
    anKpiCardTransactionRate: 'tx/min',
    anHeaderAlertRevenueUp: 'en forte hausse',
    anHeaderAlertRevenueDown: 'en baisse marquée',
    anHeaderAlertVsPreviousPeriod: 'vs période précédente',
    anHeaderQueryVsPreviousPeriod: 'vs période précédente',
    anHeaderAlertCostFasterTitle: 'Coûts en hausse plus rapide que le CA',
    anHeaderQueryTotalCost: 'coût total',
    anHeaderAlertMarginBelow: 'Marge sous',
    anHeaderAlertMarginDetail: 'Vérifiez le mix produits et les coûts food.',
    anHeaderQueryAvgMargin: 'marge moyenne',
    anHeaderAlertLowTransferTitle: 'Taux de transaction faible',
    anHeaderAlertLowTransferDetail: 'Moins d\'un spectateur sur deux consomme.',
    anHeaderQueryKpiSummary: 'synthèse des KPI',
    anHeaderAlertAvgBasket: 'Panier moyen',
    anHeaderAlertAvgTransaction: 'Transaction moyenne',
    anHeaderQueryAvgBasket: 'panier moyen',
    anHeaderAlertSpendPerAttendee: 'Dépense par spectateur',
    anHeaderQueryPerCap: 'per cap',
    anHeaderCaptureFailed: 'Échec de capture',
    anHeaderCaptureCopied: 'Capture copiée dans le presse-papiers',
    anHeaderCaptureDownloaded: 'Capture téléchargée (presse-papiers indisponible)',
    anHeaderCopyFailed: 'Impossible de copier la capture',
    anHeaderDashboard: 'Tableau de bord',
    anHeaderShared: 'Partagé',
    anHeaderLinkShared: 'Lien partagé (image téléchargée séparément)',
    anHeaderNativeShareUnavailable: 'Partage natif indisponible — capture téléchargée',
    anHeaderShareFailed: 'Impossible de partager',
    anFilterAllConfigurations: 'Toutes les configurations',
    anSummaryYearOverYearShort: 'N-1',
    anPanelAssistant: 'Assistant',
    anPanelAi: 'IA',
    anPanelTxnPerMin: 'txn/min',
    anTblShopXlsShop: 'PdV',
    anTblShopXlsItem: 'Article',
    anTblShopXlsType: 'Type',
    anTblShopXlsCategory: 'Catégorie',
    anTblShopXlsQuantity: 'Quantité',
    anTblShopXlsRevenue: 'CA',
    anTblShopXlsEvents: 'Événements',
    anTblShopXlsSheetByShop: 'Articles par PdV',
    anTblShopXlsSheetByItem: 'PdV par article',
    anTblShopXlsFileByShop: 'articles-par-pdv.xlsx',
    anTblShopXlsFileByItem: 'pdv-par-article.xlsx',
    anTimelineTitlePrefix: 'Chronologie —',
    anSearchMenuItems: 'Rechercher un article…',
    anNoResults: 'Aucun résultat',
  },
};

/**
 * Get the current locale from localStorage or default to 'fr'.
 * Défaut passé en→fr (2026-07-06) : base clients francophone ; le défaut 'en'
 * produisait un mélange EN (clés t) / FR (textes en dur) sur les pages métier.
 */
export function getCurrentLocale() {
  return localStorage.getItem('appLocale') || 'fr';
}

/**
 * Set the current locale and save to localStorage
 */
export function setCurrentLocale(locale) {
  if (translations[locale]) {
    localStorage.setItem('appLocale', locale);
    // Dispatch event for components to listen
    window.dispatchEvent(new CustomEvent('locale-changed', { detail: { locale } }));
    return true;
  }
  return false;
}

/**
 * Translate a key to the current locale
 */
export function t(key, locale = null) {
  const currentLocale = locale || getCurrentLocale();
  const localeTranslations = translations[currentLocale] || {};
  if (localeTranslations[key]) return localeTranslations[key];

  // Backward-compatible fallback for dotted keys, e.g. "spaceMenu.title" -> "spaceMenuTitle"
  if (String(key).includes('.')) {
    const parts = String(key).split('.');
    const normalizedKey = parts
      .map((part, index) => (index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
      .join('');
    if (localeTranslations[normalizedKey]) return localeTranslations[normalizedKey];
  }

  // Clé absente de la locale courante : repli sur l'anglais AVANT d'afficher
  // la clé brute (une clé fr manquante affichait p.ex. « srStepStock »).
  if (currentLocale !== 'en' && translations.en?.[key]) return translations.en[key];

  return key;
}

/**
 * Get all translations for a specific locale
 */
export function getTranslations(locale = null) {
  const currentLocale = locale || getCurrentLocale();
  return translations[currentLocale] || translations.en;
}
